import { DAILY_REWARD_STATUS } from '@Data/Models';
import { IGU_WALLET_TRANSACTIONS } from '@models/gamingWallet';
import {
    MARKETPLACE_ORDERS_SORT_OPTION,
    MARKETPLACE_PET_TYPE,
} from '@models/marketplace';
import {
    GAME_DIFFICULTY,
    LUCKY_STRIKE_GAMES_STATUS,
    MYSTERY_GAMES,
    MYSTERY_LIKES_STATUS,
    NFT_ROYAL_GAME_HISTORY_STATUS,
    NFT_ROYAL_GAME_MODE,
    TOKEN_TELLER_GAME_PREDICTION_DIRECTION,
    TOKEN_TELLER_GAME_STATUS,
    TOKEN_TELLER_HISTORY_GAMES_STATUS,
} from '@models/mysteryGames';
import ROUTES from '@navigation/routes';

const es = {
    createWalletPassphrase: {
        title: 'Su Frase Semilla',
        text: 'Por favor, guarda estas 12 palabras en un papel. Ten en cuenta su orden al anotarlas. Guárdalo en un lugar seguro.',
        button: 'Continuar',
        loading: 'Generar frase semilla..',
    },
    createWalletVerification: {
        title: 'Verificación',
        text: 'Por favor, seleccione las palabras correctas en función de su número (el orden en que fueron escritas en la pantalla anterior)',
        button: 'Continuar',
        errors: {
            passphraseNotCorrect:
                'El orden de las palabras es incorrecto. Elija las palabras correctas según su orden',
        },
        loading: 'Comprobando la frase semilla..',
    },
    createWalletFirst: {
        title: 'Escriba tu Frase Semilla',
        text: 'Si pierde o le roban el dispositivo, podrá recuperar el acceso a tus fondos utilizando la frase semilla indicada. Si pierdes tu frase semilla, perderás tus fondos.',
        button: 'Estoy Listo, Continuar',
    },
    importWalletInit: {
        title: 'Hemos Encontrado tu Cuenta',
        text: 'Ha iniciado la sesión desde otro dispositivo y no tiene acceso a la Cartera conectada. Por favor, proporcione 12 palabras de tu Cartera para continuar utilizando la aplicación',
        pets: 'Mascotas',
        import: 'Importar Cartera',
        loading: 'Importando Cartera..',
    },
    importWalletScreen: {
        title: 'Importar una Cartera',
        text: 'Introduce tu frase semilla de 12 palabras, para poder utilizar tu Cartera dentro de la app',
        listTitle: 'Frase Semilla',
        inputPlaceholder: 'Escriba aquí',
        clearAll: 'Borrar todo',
        importWallet: 'Importar',
        privateKeyButton: 'Importar desde Clave Privada',
        privateKeyModal: {
            title: 'Importar desde Clave Privada',
            text: 'Si no tienes una frase semilla, puedes importar tu Cartera utilizando una Clave Privada',
            label: 'Clave Privada',
            placeholder: 'Introduzca la Clave Privada',
            button: 'Importar',
        },
        errors: {
            mnemonicError:
                'La Cartera con esa Frase Semilla de 12 palabras no existe. Por favor, compruébelo de nuevo o proporcione otra Frase',
            privateKeyError:
                'La Cartera con esa Clave Privada no existe. Por favor, compruébelo de nuevo o proporcione otra Clave Privada',
            walletNotEqual:
                'La Cartera proporcionada no coincide con la Cartera de la cuenta',
            walletAlreadyVerified:
                'Esta Cartera pertenece a otra cuenta, no se puede importar',
        },
        success: 'Cartera importada correctamente',
    },
    createWalletInit: {
        createButton: 'Crear una Cartera',
        importButton: 'Importar una Cartera',
        slider: {
            titleSlide1: 'Conectar una Cartera',
            textSlide1:
                'Crea una nueva Cartera o importe una ya existente proporcionando su frase semilla de 12 palabras',
            titleSlide2: 'Carteras de Auto-Custodia',
            textSlide2:
                'IguVerse opera en una Cartera de Auto-Custodia, donde usted tiene el control exclusivo de sus Claves Privadas, que a su vez es el control de su criptomoneda y demuestra que los fondos son suyos',
            titleSlide3: 'Restaurar Cuenta',
            textSlide3:
                'Si pierdes el acceso al dispositivo y a tu frase semilla, no podremos restaurar tu Cartera y los fondos se perderán.',
        },
    },
    createWalletSuccess: {
        title: 'Cartera Creada',
        text: '¡Enhorabuena! Tu Cartera se ha creado correctamente, ya puedes empezar a utilizar tu cuenta',
        button: 'Ir al Último Paso',
        buttonNew: 'Continuar',
    },
    importWalletSuccess: {
        title: 'Cartera Importada',
        text: '¡Enhorabuena! Tu Cartera se ha importado correctamente, puedes empezar a utilizar tu cuenta',
        button: 'Continuar',
        buttonNew: 'Ir al Último Paso',
    },
    login: {
        facebook: 'Continuar con Facebook',
        google: 'Continuar con Google',
        apple: 'Continuar con Apple',
        email: 'Continuar con el correo electrónico',
        twitter: 'Continuar con Twitter',
        emailTitle: 'Entrar / Registrarse',
        creatingAccount:
            'Al crear una cuenta acepto el tratamiento de mis datos personales de acuerdo con',
        and: 'y',
        privacyPolicy: 'Política de Privacidad',
        termsOfUse: 'Condiciones Generales',
        placeholderEmail: 'Introduzca correo electrónico',
        labelEmail: 'Correo electrónico',
        placeholderVerificationCode: 'Introduzca el código de verificación',
        labelVerificationCode:
            'El código de verificación se enviará a tu correo electrónico',
        sendCode: 'Enviar',
        resendIn: 'Reenviar en',
        seconds: 'sec',
        welcomeTo: 'Bienvenido a',
        codeSent: 'Contraseña de un solo uso enviada',
        errors: {
            invalidEmailAddress: 'Dirección de correo electrónico no válida',
            emailIsRequired: 'El campo del correo electrónico es obligatorio',
            verificationCodeIsRequired:
                'Se requiere una contraseña de un solo uso para acceder a tu cuenta',
            verificationCodeIsBadOrExpired:
                'La contraseña de un solo uso es incorrecta o ha caducado. Inténtalo de nuevo',
            verificationCodeTooMuchAttempts:
                'Demasiados intentos. Vuelva a intentarlo más tarde',
            loginFailed: 'Error de inicio de sesión',
            smthWentWrong:
                'Algo ha ido mal durante el inicio de sesión. Inténtelo de nuevo más tarde, o pruebe un método diferente',
        },
        loading: {
            sendingCode: 'Enviando código..',
            loggingIn: 'Iniciando sesión.',
        },
    },
    mintPetRank: {
        title: 'Selecciona el Rango de tu Mascota',
        text: 'El Rango define cuántas recompensas ganará tu mascota por completar las tareas diarias',
        free: 'Free',
        roi: 'ROI ≈ ',
        dailyReward: 'Recompensa Diaria ≈ ',
        buttonNext: 'Siguiente Paso',
        disabled: 'Sólo se permite un Rango Free por cuenta',
        info: '¿Qué es el rango?',
        whiteList: 'Lista blanca ({{amount}})',
        mysteryBox: 'Caja Misteriosa',
        mysteryBoxWithAmount: 'Caja Misteriosa ({{amount}})',
    },
    mintPickPhoto: {
        title: 'Elija la Foto de tu Mascota',
        text: 'Hazle una foto a tu Mascota o elige una foto de la galería',
        or: 'o',
        takePhoto: 'Abrir Cámara',
        selectFromGallery: 'Elegir de la Galería',
        tips: {
            title: 'Pautas para una Foto Perfecta',
            visible: 'Perfecta',
            cut: 'Cortada',
            blurry: 'Borrosa',
            glare: 'Deslumbra',
            tipOne: 'Es esencial una buena luz',
            tipTwo: 'Intenta hacerla con un fondo neutro',
            tipThree: 'Asegúrate que en la foto únicamente aparece la Mascota',
        },
        analyzingPhoto: 'Analizando tu foto..',
        errors: {
            explicitContent: {
                title: 'Contenido Prohibido',
                text: 'La imagen contiene Contenido Prohibido. Estas acciones pueden causar al bloqueo de su cuenta',
            },
            uploadError: {
                title: 'Error de Carga',
                text: 'Comprueba tu conexión a Internet y vuelve a intentarlo',
            },
            processImageFailed: {
                title: 'Error de Imagen',
                text: 'No se puede procesar tu imagen en este momento. Inténtalo de nuevo o utiliza otra foto',
            },
            notAnimal: {
                title: 'No Hay Ningñun Animal en la Foto',
                text: 'Nuestros algoritmos no pueden reconocer el animal de tu foto. Por favor, inténtalo de nuevo con otra foto',
                try: 'Inténtar de nuevo',
                cancel: 'Cancelar',
            },
        },
    },
    mintEditPhoto: {
        title: 'Personaliza tu Mascota',
        text: 'Elige el fondo para tu Mascota NFT',
        loading: 'Preparando tu imagen..',
    },
    mintNamePhoto: {
        title: 'Ponle un Nombre a tu Mascota',
        text: 'Tu Mascota se merece el mejor nombre. El nombre no debe superar los 20 caracteres',
        inputLabel: 'Nombre',
        placeHolder: 'Por ejemplo, Charlie',
        buttonNext: 'Continuar',
        infoText:
            'Nuestros algoritmos son capaces de reconocer animales en las imágenes con un 99% de probabilidad',
        deleteNFTphoto: ' Borrar foto',
        deleteNFTphotoText:
            '¿Estás seguro de que quieres irte? Tu progreso se perderá',
        yesDelete: 'Sí, quiero irme',
        noKeep: 'No, continuar',
        errors: {
            startSpace: 'El nombre no puede comenzar con un espacio',
            specialCharacters:
                'El nombre no puede contener caracteres especiales',
            latinCharacters:
                'El nombre sólo puede contener caracteres de la A a la Z',
            numbers: 'El nombre no puede contener números',
            doubleSpaces: 'El nombre no puede contener espacios dobles',
            maxLength: 'El nombre no puede tener más de 20 caracteres',
            minLength: 'El nombre no puede tener menos de 2 caracteres',
            mint: {
                title: 'Fallo en la emisión de NFT',
                petRankWrongState:
                    'El Rango de mascotas no está disponible para mintear',
                obscenePetName:
                    'El nombre de la mascota no puede contener palabras malas. Tu cuenta puede ser bloqueada',
            },
        },
    },
    mintCheckout: {
        transaction: 'NFT como',
        rank: 'Rango',
        nftCustomization: 'NFT',
        successTitle: 'Nueva Mascota NFT Creada',
        successText:
            'Te conviertes en un orgulloso dueño de una nueva Mascota. Acuérdate de cuidarla bien',
        backToPlaying: 'Empezar a Jugar',
        backToCollection: 'Ver la Colección',
    },
    wallet: {
        screenTitle: 'Cartera',
        loading: 'Cargando Cartera...',
        emptyTitle: 'No se puede cargar la Cartera',
        emptyText: 'Error al Cargar la cartera',
        total: 'Total',
        deposit: 'Depósito',
        withdraw: 'Retirar',
        trade: 'Comercializar',
        balances: 'Saldos',
        exchanges: 'Intercambios',
        exchangesInfo:
            'Puede canjear nuestros Tokens en cualquiera de las siguientes bolsas',
        available: 'Disponible:',
        view: 'Ver',
        depositTo: 'Depositar en',
        depositBEP: 'Depósito {{coin}} (BEP-20)',
        testnet: 'Testnet',
        testnetWarning:
            'La aplicación se ejecuta actualmente en la red Testnet, no deposite Tokenes reales aquí',
        howToPurchaseBNB: 'Cómo Comprar BNB',
        howToPurchaseIGU: 'Cómo Comprar IGU',
        warning:
            'Asegúrese de depositar sus Tokens en la dirección y red correctas (BEP-20)',
        withdrawFrom: 'Retirarse de',
        transactionHistory: 'Historial de transacciones',
        viewOnBscScan: 'Ver en BscScan',
        noTransactionYet: 'Aún no hay Transacciones',
        noTransactionYetInfo: 'Aún no has realizado ninguna transacción',
        transactionDetails: 'Detalles de las Transacciones',
        amount: 'Importe',
        type: 'Tipo',
        date: 'Fecha',
        fromAddress: 'De la dirección',
        toAddress: 'A la dirección',
        blockChainFee: 'Blockchain Comissión',
        loadingWithdraw: 'Enviando Transacción..',
        transactions: {
            coin: {
                DEPOSIT: {
                    name: 'Depósitar',
                    text: 'La Cripto ha llegado a tu Cartera. Ver el historial de Transacciones para más detalles',
                },
                WITHDRAW: {
                    name: 'Retirar',
                    text: 'La Cripto ha sido tranferida fuera de tu Cartera. Póngase en contacto con la plataforma receptora para obtener el recibo de la Transacción',
                },
                SWAP: {
                    name: 'Intercambiar',
                    text: 'La Cripto fue cambiada a otra cripto utilizando DEX incorporado.',
                },
                CLAIM: {
                    name: 'Cobrar las Recompensas',
                    text: 'Cobrar la recompensa  y transferida al saldo de tu Cartera',
                },
                NFT_PAYMENT: {
                    name: 'Pago NFT',
                    text: 'La Crypto fue utilizada para pagar en la aplicación para mintear, curar o potenciar. Ver el historial de transacciones para más detalles',
                },
                UNKNOWN: {
                    name: 'Otros',
                    text: 'Cualquier otra transacción de la red, incluidas aprobaciones, comisiones, etc. Ver el historial de transacciones para más detalles',
                },
                CONFIRMED: {
                    title: 'Completado',
                },
                FAILED: {
                    title: 'Fallido',
                    text: 'Debido a problemas en la red, no hemos podido procesar tu transacción',
                },
                PENDING: {
                    title: 'Pendiente',
                    text: 'La transacción aún no ha sido confirmada por la red. Suele tardar entre 5 minutos y 1 hora',
                },
            },
            nft: {
                DEPOSIT: {
                    name: 'Depósitar',
                    text: 'NFT ha llegado a tu Cartera. Ver el historial de transacciones para más detalles',
                },
                WITHDRAW: {
                    name: 'Retirada de NFT',
                    text: 'NFT transferido desde IguVerse. Póngase en contacto con la plataforma receptora para obtener el recibo de su transacción',
                },
                MINT: {
                    name: 'Mint',
                    text: 'NFT  ha sido minteado en IguVerse app',
                },
                CONFIRMED: {
                    title: 'Completado',
                },
                FAILED: {
                    title: 'Fallido',
                    text: 'Debido a problemas técnicos en la red, no hemos podido procesar su transacción',
                },
                PENDING: {
                    title: 'Pendiente',
                    text: 'La transacción aún no ha sido confirmada por la red. Suele tardar entre 5 minutos y 1 hora',
                },
            },
            reward: {
                GameIterationReward: {
                    title: 'Tareas de Recompensa',
                    text: 'Tareas de recompensa bloqueadas por completar las tareas diarias',
                },
                ReferralReward: {
                    title: 'Recompensa por Referencias',
                    text: 'Recompensa por remitir a otros usuarios a la app',
                },
                Claim: {
                    title: 'Cobrar Recompensa',
                    text: 'La transacción de Cobrar convierte tus recompensas virtuales VIGUP disponibles en IGUP en tu Cartera principal',
                },
                PetLevelUpPayment: {
                    title: 'Subir el Nivel de Mascotas',
                    text: 'Pago interno por subir de nivel a la mascota',
                },
                PetRankUpPayment: {
                    title: 'Subir el Rango de Mascota',
                    text: 'Pago interno por subir de rango a la mascota',
                },
                PetRevivePayment: {
                    title: 'Restauración de Mascotas',
                    text: 'Pago interno para restaurar la mascota',
                },
                PetHealUpPayment: {
                    title: 'Curación de Mascotas',
                    text: 'Pago interno por curar a la mascota',
                },
                MintBonus: {
                    title: 'Mint Bonus',
                    text: 'Una recompensa Bonus por NFT Mint',
                },
                CharityDonation: {
                    title: 'Donación Benéfica',
                    text: 'Realiza donaciones a la Organización Benéfica que elija',
                },
                GameIterationRewardSubtransaction: {
                    title: 'Tareas Recompensa',
                    text: 'Tareas de recompensa bloqueadas por completar las tareas diarias',
                },
                CONFIRMED: { title: 'Completado' },
                PENDING: {
                    title: 'Pendiente',
                    text: 'La transacción de Cobrar fue emitida, sin embargo no fue finalizada. Debe finalizar esta transacción antes de poder realizar una nueva solicitud',
                },
                UNLOCK: {
                    title: 'Recompensas Bloqueadas',
                    text: 'Estas recompensas están pendientes y se desbloquearán y estarán disponibles para el Cobro según el calendario de desbloqueo.',
                    locked: '{{amount}} {{coin}} están bloqueados',
                },
                unlockTransactions: { title: 'Transacciones desbloqueadas' },
                UNKNOWN: { name: 'Otros', text: 'Otro tipo de transacción' },
                GameRewardStakeBonus: {
                    title: 'Bono de impulso',
                    text: 'Bonos bloqueados para el impulso',
                },
                GameRewardStakeBonusSubtransaction: {
                    title: 'Bono de impulso',
                    text: 'Bonos bloqueados para el impulso',
                },
            },
        },
        nft: {
            nft: 'NFT',
            tokenId: 'Token ID',
            myCollection: 'Colección',
            tooltip: 'Aquí puedes ver tus NFT de tu colección',
            noNFTYet: 'No Coleccionables',
            noNFTYetInfo: 'Lista vacía',
            mintNewNft: 'Nuevo NFT',
            NFTs: '{{balance}} NFTs',
            noNFTs: 'N/A',
            deposit: 'Depósitar NFT',
            viewAll: 'Ver todos',
            allNFTs: 'Todos los NFTs',
            withdraw: 'Retirar NFT',
            withdrawNftLabelAddress: 'Dirección',
            withdrawNftPlaceholderAddress: 'Introduzca la dirección',
            withdrawNftTitle: 'Retirar NFT',
            blockchainFee: 'Comisión Blockchain',
            confirmButtonLabel: 'Confirmar Retirada',
            confirmModal: {
                title: 'Confirmar NFT Retirada',
                nftName: 'NFT',
                addressFrom: 'Desde (Cartera)',
                addressTo: 'A la dirección',
                send: 'Confirmar',
                cancel: 'Cancelar',
            },
            withdrawSuccess: {
                title: 'La retirada de NFT se está tramitando',
                text: 'NFT {{name}} ha sido retirado con éxito. Normalmente tarda entre 5 minutos y 1 hora',
                addressFrom: 'Desde (Cartera)',
                addressTo: 'A la dirección',
                backToWallet: 'Volver a Cartera',
            },
            transactionNft: 'Retirada de NFT',
            withdrawWarningText:
                'Asegúrese de retirar sus Tokens a la dirección y red correctas (BEP-20). Si envías tus NFT a cualquier otra red o Cartera de intercambio, puedes perderlos permanentemente',
            transactionHistory: 'Historial de transacciones',
            noTransactionYet: 'Aún no hay transacciones',
            noTransactionYetInfo:
                'Aún no has hecho ningúna transacción. Pero no hay problema, hazla ahora mismo',
        },
        rewards: {
            tooltipText:
                'El botón Cobrar le permite convertir sus tokens de recompensa virtuales en on-chain tokens IGUP. El botón estará disponible cuando tengas recompensas pendientes. ',
            claimButton: 'Cobrar',
            reclaimButton: 'Recobrar',
            stakeButton: 'Impulsar',
            rewardsWallet: 'Cartera de Recompensas',
            mainWallet: 'Cartera Principal',
            transactionHistoryText: 'Historial de Transacciones',
            rewardsCarousel: {
                availableRewards: 'Recompensas Disponibles',
                availableRewards_text:
                    'Recompensas disponibles para convertir en tokens IGUP',
                lockedRewards: 'Recompensas bloqueadas',
                lockedRewards_text:
                    'Las recompensas estarán disponibles según tu calendario de desbloqueo',
                pendingRewards: 'Cobro de Recompensas Pendientes',
                pendingRewards_text: 'Finalice su operación de cobro',
                claimReward: 'Cobrar Recompensa',
            },
            transactionHistory: {
                Claim: 'Recompensa cobrada',
                GameIterationReward: 'Recompensa por tareas',
                ReferralReward: 'Recompensa por recomendación',
                PetLevelUpPayment: 'Subidas nivel',
                PetRankUpPayment: 'Subidas rango',
                PetRevivePayment: 'Restauración de mascotas',
                PetHealUpPayment: 'Curación de mascotas',
                MintBonus: 'Mint Bonus',
                CharityDonation: 'Donación benéfica',
                GameIterationRewardSubtransaction: 'Desbloquear',
                GameRewardStakeBonus: 'Bono de impulso',
                GameRewardStakeBonusSubtransaction: 'Desbloquear',
            },
            filter: {
                title: 'Ordenar por',
                ALL: 'Todos',
                Claim: 'Cobro de Recompensas',
                GameIterationReward: 'Tareas Recompensa',
                ReferralReward: 'Recompensa por Recomendación',
                MintBonus: 'Mint Bonus',
                GameRewardStakeBonus: 'Bono de impulso',
            },
            empty: {
                title: 'Aún no hay transacciones',
                text: 'No te preocupes y permanece atento. Cuando obtenga recompensas, se mostrarán aquí',
                button: 'Actualizar',
            },
            confirmationModal: {
                title: 'Confirmar Cobro',
                keys: {
                    from: 'De',
                    to: 'Para (Cartera)',
                    fee: 'Comisión Blockchain',
                    total: 'Resumen',
                },
                values: {
                    rewardsWallet: 'Cartera de Recompensas',
                    mainWallet: 'Cartera IGUP',
                },
                warning:
                    'Asegúrese de que tiene fondos suficientes y BNB para cubrir una comisión de gas',
            },
            claimSuccess: {
                title: 'La solicitud de recompensa en tramitación',
                text: 'Ha iniciado una nueva transacción de Cobro desde su Cartera de Recompensas. Normalmente tarda entre 5 minutos y 1 hora',
                backToWallet: 'Volver a Cartera',
            },
            claimLoading: 'Realización de Cobro, no cierre la aplicación..',
            claimBusy:
                'La red está ocupada en este momento, por favor inténtelo de nuevo mas tarde',
        },
        gaming: {
            gamingWalletChangeFeatureText:
                'Esta es una relación de cambio aproximada de IGU a VIGU',
            gamingWalletCarousel: {
                AvailableWallet: {
                    title: 'Monedero disponible',
                    text: 'Para participar, recarga tu monedero de juego con IGU',
                },
                PendingWallet: {
                    title: 'Cartera pendiente',
                    text: 'Las fichas se congelarán hasta que termines el juego',
                },
            },
            gamingWalletButtons: {
                topUp: 'Completar',
                withdraw: 'Retirar',
            },
            TopUpGamingWalletScreen: {
                screenTitle: 'Completar',
                title: 'Recarga el monedero de juego',
                text: 'Para participar, recarga tu monedero de juego con IGU y recibe VIGU',
                infoText: 'Cómo funciona',
                button: 'Verificando',
                inputSection: {
                    infoText:
                        'Introduzca o seleccione la cantidad que desea comprar',
                    errors: {
                        digits: 'Deben ser sólo dígitos',
                        min: 'El importe debe ser como mínimo {{limit}} {{coin}}',
                        max: 'El importe debe ser como máximo {{limit}} {{coin}}',
                    },
                },
                howToModal: {
                    title: 'Recarga el monedero de juego',
                    text: 'Para participar, recarga tu monedero de juego con IGU y recibe VIGU. Utiliza el botón de abajo para recargar tokens',
                },
            },
            SelectWithdrawTokenModal: {
                title: 'Seleccionar token de retiro',
                text: 'Puede seleccionar el token preferido, en el que recibirá sus recompensas en la billetera principal',
                button: 'Seleccionar',
            },
            TopUpSuccessScreen: {
                title: 'Recarga correcta',
                text: 'Has recargado tu monedero con fichas. ¡Únete ahora a los juegos competitivos!',
                button: 'Explorar juegos',
                button2: 'Ver el historial de transacciones',
                buttonBack: 'Volver al juego',
            },
            transactionHistory: {
                filter: {
                    title: 'Ordenar por',
                    [IGU_WALLET_TRANSACTIONS.All]: 'Todos',
                    [IGU_WALLET_TRANSACTIONS.Deposit]: 'Completar',
                    [IGU_WALLET_TRANSACTIONS.Withdraw]: 'Retirar',
                    [IGU_WALLET_TRANSACTIONS.RevertWithdraw]:
                        'Revertir Retirar',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGamePayment]: 'Pago',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameRefund]:
                        'Caducidad',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameDraw]: 'Empate',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameWin]: 'Victoria',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameFee]: 'Tarifa',
                    [IGU_WALLET_TRANSACTIONS.DepositBonus]: 'Bono de recarga',
                },
                transactions: {
                    [IGU_WALLET_TRANSACTIONS.Deposit]: {
                        title: 'Completar',
                        text: 'Crypto están transfiriendo a Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.Withdraw]: {
                        title: 'Retirar',
                        text: 'Crypto están transfiriendo de Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.RevertWithdraw]: {
                        title: 'Revertir Retirar',
                        text: 'Crypto están transfiriendo de Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameDraw]: {
                        title: 'The Mystery Of Likes Empate',
                        text: 'Crypto están transfiriendo a Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGamePayment]: {
                        title: 'The Mystery Of Likes Pago',
                        text: 'Crypto están transfiriendo de Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameRefund]: {
                        title: 'The Mystery Of Likes Caducidad',
                        text: 'Crypto están transfiriendo a Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameWin]: {
                        title: 'The Mystery Of Likes Victoria',
                        text: 'Crypto están transfiriendo a Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.DepositBonus]: {
                        title: 'Bono de recarga',
                        text: 'Crypto están transfiriendo de Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.DirectReferralDepositBonus]: {
                        title: 'Bono de recarga (Directas)',
                        text: 'Crypto están transfiriendo de Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.IndirectReferralDepositBonus]: {
                        title: 'Bono de recarga (Indirectas)',
                        text: 'Crypto están transfiriendo de Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameFee]: {
                        title: 'The Mystery Of Likes Tarifa',
                        text: 'Crypto están transfiriendo de Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameDirectReferralBonus]:
                        {
                            title: 'Recompensa de referencia (Directas)',
                            text: 'Crypto están transfiriendo de Gaming Wallet. Ver más detalles en bscscan',
                        },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameIndirectReferralBonus]:
                        {
                            title: 'Recompensa de referencia (Indirectas)',
                            text: 'Crypto están transfiriendo de Gaming Wallet. Ver más detalles en bscscan',
                        },
                    [IGU_WALLET_TRANSACTIONS.Breeding]: {
                        title: 'NFT Evolution Menta',
                        text: 'Crypto están transfiriendo de Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.GamesTurnoverReward]: {
                        title: 'PVP Bonificación',
                        text: 'Crypto están transfiriendo a Gaming Wallet. Ver más detalles en bscscan',
                    },

                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameDraw]: {
                        title: 'The Grand Race - Empate',
                        text: 'Crypto están transfiriendo a Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGamePayment]: {
                        title: 'The Grand Race - Pago',
                        text: 'Crypto están transfiriendo de Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameRefund]: {
                        title: 'The Grand Race - Caducidad',
                        text: 'Crypto están transfiriendo a Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameWin]: {
                        title: 'The Grand Race - Victoria',
                        text: 'Crypto están transfiriendo a Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameFee]: {
                        title: 'The Grand Race - Tarifa',
                        text: 'Crypto están transfiriendo de Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.LuckyStrikeGameWin]: {
                        title: 'Lucky Strike - Victoria',
                        text: 'Crypto están transfiriendo a Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.LuckyStrikeGamePayment]: {
                        title: 'Lucky Strike - Entrada',
                        text: 'Crypto están transfiriendo de Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.QuantumSpinReward]: {
                        title: 'Quantum Disk - Recompensa',
                        text: 'Crypto están transfiriendo a Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.QuantumSpin]: {
                        title: 'Quantum Disk - Pago',
                        text: 'Crypto están transfiriendo de Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredictWin]: {
                        title: 'Tokenteller - Victoria',
                        text: 'Crypto están transfiriendo a Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredict]: {
                        title: 'Tokenteller - Entrada',
                        text: 'Crypto están transfiriendo de Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredictFee]: {
                        title: 'Tokenteller - Tarifa',
                        text: 'Crypto están transfiriendo de Gaming Wallet. Ver más detalles en bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredictRefund]: {
                        title: 'Tokenteller - Empate',
                        text: 'Crypto están transfiriendo a Gaming Wallet. Ver más detalles en bscscan',
                    },
                },
            },
        },
        stakingBanner: {
            title: '¡Impulsa tus recompensas y obtén bonos!',
            text: '¡El impulso con IGUP está disponible en la pestaña Recompensas ahora!',
            button: 'Activar impulso',
        },
    },
    trade: {
        poweredBy: 'Desarrollado por',
        from: 'De',
        to: 'A',
        estimate: ' (Estimación)',
        enterAmount: 'Introduzca el importe',
        available: 'Max',
        selectToken: 'Seleccionar Token',
        deposit: 'Depósito',
        trade: 'Intercambiar',
        rate: 'Tipo de cambio',
        confirmTrade: 'Confirmar Operación',
        cancel: 'Cancelar',
        settings: 'Ajustes',
        settingTitle: 'Tolerancia al Desplazamiento',
        slippageMainText:
            'Su transacción se revertirá si el precio cambia desfavorablemente en un porcentaje superior al siguiente',
        save: 'Guardar',
        percentFour: 'Introducir %',
        inputWarning:
            'La Tolerancia de Desplazamiento debe estar entre {{minAmount}}% y {{maxAmount}}%. Introduzca otro porcentaje',
        checkout: { estimate: 'Usted paga', to: 'Usted recibe' },
        processingTrade: 'Procesando Operación..',
        calculatingTrade: 'Calculando..',
        button: 'Operación',
        errors: {
            isRequired: 'El valor es obligatorio.',
            maxAmountError:
                'No hay Tokens suficientes en el saldo. Por favor, introduzca otra cantidad o depósito',
            minLimit:
                'El importe del intercambio debe ser al menos {{limit}} {{coin}}',
            bnbNotEnough:
                'No hay suficiente BNB en tu saldo para cubrir la comisión de gas. Por favor, introduce otra cantidad o deposita BNB',
            transaction: 'Transacción fallida',
            DS_MATH_SUB_UNDERFLOW:
                'La cantidad de Tokens es demasiado grande, intente introducir una cantidad diferente',
        },
        tradeSuccess: {
            title: 'Intercambio finalizado',
            text: 'Enhorabuena has intercambiado Tokens con éxito. Tus Tokens están disponibles en tu saldo. Ver más en el historial de transacciones',
            backToWallet: 'Volver a la Cartera',
            from: 'De',
            to: 'A',
            estimate: '(Estimación)',
            blockchainFee: 'Comisión Blockchain',
            totalSummary: 'Resumen',
            back: 'Seguir Negociando',
        },
    },
    tradingView: { title: 'Gráfico', back: 'Volver a la Operación' },
    walletSettings: {
        title: 'Configuración Cartera',
        header: 'Configuraciones de seguridad',
        description:
            'Vea su frase semilla y clave privada, así como también administre su código de acceso aquí',
        backup: {
            title: 'Frase semilla',
            description:
                '¡Nunca le muestres tu frase semilla a nadie! Controla todos tus fondos',
            modal: {
                title: 'Frase / Clave de Recuperación de Cartera',
                text: 'Asegúrate de que nadie pueda ver tus datos secretos. Exponiéndolos a cualquiera corres el riesgo de perder tus fondos',
                yes: 'Ver',
                no: 'Volver',
                alert: 'El equipo de IguVerse nunca te preguntará por tu frase semilla o clave privada. Si alguien te pregunta es 100% un estafador, ¡ten cuidado!',
                checkbox:
                    'Reconozco que entiendo el riesgo de que si comparto una frase semilla / clave privada con alguien me roben mis tokens y mascotas',
            },
        },
        passcode: {
            title: 'Código de acceso y biometría',
            description:
                'Establecer o cambiar el código de acceso y alternar la identificación biométrica',
        },
    },
    passcode: {
        passcode: 'Contraseña',
        modal: {
            title: 'Habilitar código de acceso',
            subTitle:
                'El código de cuatro dígitos mejorará su seguridad y se utilizará para confirmar acciones importantes',
        },
        welcome: {
            title: 'Habilitar código de acceso',
            subTitle:
                'Ingrese el código de acceso, que usará para acceder a la aplicación y confirmar acciones importantes',
        },
        new: {
            title: 'Habilitar código de acceso',
            subTitle:
                'Ingrese el código de acceso, que usará para acceder a la aplicación y confirmar acciones importantes',
        },
        confirm: {
            title: 'Confirmar código de acceso',
            subTitle:
                'Ingrese el código de acceso, que usará para acceder a la aplicación y confirmar acciones importantes',
            error: 'Código incorrecto. Introduce el mismo código que has tecleado en el paso anterior',
        },
        check: {
            title: 'Introduce un código de acceso',
            subTitle: 'Ingrese su contraseña actual para confirmar',
            error: 'Código incorrecto. Vuelva a intentarlo o utilice la identificación biométrica',
        },
        success: {
            title: '¡Su cuenta está protegida!',
            subTitle:
                'Ahora su cuenta y billetera IguVerse están protegidas contra actividades maliciosas. Siempre puedes cambiar el código de acceso en la Configuración',
        },
        change: {
            title: 'Cambiar contraseña',
            subTitle:
                'Ingrese el nuevo código de acceso, que se utilizará para confirmar acciones importantes',
        },
        faceId: {
            title: 'Habilite la identificación de la cara',
            subTitle:
                'Confirme acciones importantes con una verificación más simple y rápida. IguVerse no recopilará su información',
        },
        settings: {
            turnOff: '¿Desactivar código de acceso?',
            biometric: {
                title: 'Identificación biométrica',
                subTitle:
                    'Utilizar Face ID o su huella digital para confirmar acciones importantes en la aplicación',
            },
        },
        modalRemove: {
            title: '¿Desactivar código de acceso?',
            subTitle:
                'Todos sus datos se almacenan de forma segura con el código de acceso. Puede configurarlo nuevamente en la configuración en cualquier momento',
        },
        toasts: {
            turnOff: '¡Éxito! Código desactivado!',
            biometricOff: '¡Éxito! Biometría desactivada!',
            biometricOn: '¡Éxito! Biometría activada!',
            change: '¡Éxito! Código modificado!',
            biometricError: '¡Error! Inténtelo de nuevo!',
        },
    },
    walletSettingsBackup: {
        mnemonic: {
            title: 'Tu Frase Semilla',
            text: 'Por favor, guarda estas 12 palabras en un papel. Ten en cuenta su orden al anotarlas. Guárdalo en un lugar seguro.',
            reveal: 'Mantener pulsado para revelar Frase',
        },
        privateKey: {
            title: 'Tu Clave Privada',
            text: 'La Clave Privada es un número generado aleatoriamente que da al usuario el control sobre todos los fondos vinculados a una Cartera. Manténgala en secreto',
            reveal: 'Mantener pulsado para revelar la Clave Privada',
        },
        privateKeyModal: {
            title: 'Clave Privada',
            text: 'Anote su Clave Privada. Guárdela en un lugar seguro',
        },
        buttons: { hidden: 'Mantener para revelar', visible: 'Ocultar' },
        viewPrivateKey: 'Ver su Clave Privada',
        emptyTitle: 'Error',
        emptyText: 'No se puede cargar la Cartera',
    },
    withdrawScreen: {
        title: 'Retirar',
        labelAddress: 'Dirección',
        labelAmount: 'Importe',
        placeholderAddress: 'Introduzca la dirección',
        placeholderAmount: 'Introduzca el importe',
        labelAvailable: 'Disponible',
        allButtonLabel: 'Max',
        confirmButtonLabel: 'Confirmar transacción',
        depositButtonLabel: 'Depósito',
        depositBEP: 'Depósito {{coin}} (BEP-20)',
        blockchainFee: 'Comisión Blockchain',
        totalSummary: 'Resumen',
        errors: {
            address: 'La dirección no puede estar vacía',
            amountRequired: 'El importe no puede estar vacío',
            invalidAddress: 'Cartera con dirección no válida',
            sameWallet: 'No se puede retirar a tu propia cartera',
            digits: 'Deben ser sólo dígitos',
            maxAmountError:
                'No hay Tokens suficientes en el saldo. Por favor, introduzca otra cantidad o depósito',
            minLimit: 'La retirada debe ser al menos de {{limit}} {{coin}}',
            bnbNotEnough:
                'No hay suficiente BNB en tu saldo para cubrir la comisión de gas. Por favor, introduce otra cantidad o deposita BNB',
        },
        withdrawWarningText:
            'Asegúrese de retirar tus Tokens a la dirección y red correctas (BEP-20)',
        withdrawWarningTextNFT:
            'Si envías tu NFT a cualquier otra red o cartera de intercambio, puedes perderlo permanentemente',
        transaction: 'Retirada',
        withdrawSuccess: {
            title: 'Tramitando Retirada',
            text: 'Ha iniciado una nueva retirada desde su Cartera. Normalmente tarda entre 5 minutos y 1 hora',
            backToWallet: 'Volver a Cartera',
            viewTransactionHistory: 'Ver Historial de Transacciones',
        },
    },
    ModalConfirmTransaction: {
        title: 'Confirmar Transacción',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
    },
    ModalCoinSelect: {
        select: 'Seleccionar Tokens',
    },
    ModalCropImage: {
        title: 'Recortar Imagen',
        crop: 'Recortar y continuar',
    },
    qrCodeScanner: {
        openSettings: 'Ajustes',
        noAccessToCamera: 'Sin acceso a la cámara',
        title: 'Posicionar QR-Code en el marco',
        wallet: {
            titleScanned: 'Dirección escaneada',
            text: 'Escanee el código QR de la dirección del Token. Asegúrese de que todos los detalles son visibles',
        },
        referral: {
            titleScanned: 'Código de referencia escaneado',
            text: 'Escanee el código QR del código de referencia. Asegúrese de que todos los detalles son visibles',
        },
        verify: {
            titleScanned: 'Verificar código escaneado',
            text: 'Escanee el código QR de Verificar código. Asegúrese de que todos los detalles son visibles',
        },
    },
    nftSelectGeneration: {
        continue: 'Continuar',
        search: 'Buscar en',
        pageTitle: 'Crea tu mascota NFT',
        pageInfo: 'Puede elegir la forma en que se creará tu NFT',
        nftFromPhoto: 'NFT de la foto',
        nftFromPhotoText:
            'Crea un precioso NFT a partir de la foto de tu mascota. Elige uno de nuestros espléndidos fondos para tu futuro compañero',
        nftFromImagination: 'NFT desde tu Imaginación',
        nftFromImaginationText:
            'Nuestros algoritmos de IA / ML pueden dibujar tu mascota virtual exactamente como la imaginas. Describe las características de tu mascota y disfruta del resultado',
        provideMoreInformation: 'Describa la Mascota de sus Sueños',
        provideMoreInformationInfo:
            'Seleccione una de las opciones sugeridas a continuación para que NFT creado se ajuste perfectamente a lo que imagina',
        selectAccessories: 'Seleccionar Accesorios',
        maximumAccessories:
            'Puedes seleccionar un máximo de {{num}} accesorios',
        selectGeneratedNFT: 'Elija tu Mascota',
        selectGeneratedNFTInfo:
            'Hemos creado varias mascotas únicas según tu petición. Elige la que más te guste',
        continueNextStep: 'Siguiente Paso',
        generateNewNFT: 'Reintentar',
        generateNFTButton: 'Generar NFT',
        loadingModalText: 'Cargando...',
        randomize: 'Aleatorizar',
        clear: 'Limpiar',
        select: 'Seleccionar',
        noResult: 'Sin Resultados',
        noResultText:
            'No hubo resultados para "{{query}}". Introduzca otra palabra clave para buscar',
        form: {
            animal: {
                label: 'Animales',
                placeHolder: 'Seleccionar Animal',
                modalTitle: 'Seleccionar Animal',
            },
            'drawing-type': {
                label: 'Tipo de Dibujo',
                placeHolder: 'Seleccionar el tipo de Dibujo',
                modalTitle: 'Seleccionar el tipo de Dibujo',
            },
            cat: {
                label: 'Raza de Gato',
                placeHolder: 'Seleccionar Raza de Gato',
                modalTitle: 'Seleccionar Raza de Gato',
            },
            dog: {
                label: 'Raza de Perro',
                placeHolder: 'Seleccionar Raza de Perro',
                modalTitle: 'Seleccionar Raza de Perro',
            },
            'maturity-size': {
                label: 'Madurez / Tamaño',
                placeHolder: 'Seleccionar la Madurez o el Tamaño',
                modalTitle: 'Seleccionar la Madurez o el Tamaño',
            },
            color: {
                label: 'Color',
                placeHolder: 'Seleccionar Color',
                modalTitle: 'Seleccionar Color',
            },
            emotion: {
                label: 'Emoción',
                placeHolder: 'Seleccionar Emoción',
                modalTitle: 'Seleccionar Emoción',
            },
            accessories: {
                label: 'Accesorios',
                placeHolder: 'Seleccionar Accesorios',
                modalTitle: 'Seleccionar Accesorios',
            },
            context: {
                label: 'Contexto',
                placeHolder: 'Seleccionar Contexto',
                modalTitle: 'Seleccionar Contexto',
            },
            style: {
                label: 'Estilo',
                placeHolder: 'Seleccionar Estilo',
                modalTitle: 'Seleccionar Estilo',
            },
        },
        errors: {
            maintenance: {
                title: 'Nuestros modelos de IA están sobrecargados',
                text: 'Lamentablemente, nuestros modelos de IA no pueden atender su solicitud en este momento. Por favor, inténtelo más tarde',
            },
        },
    },
    bottomNavigation: {
        play: 'Jugar',
        charity: 'Caridad',
        statistics: 'Estadísticas',
        collection: 'Colección',
        marketplace: 'Tienda',
    },
    playScreen: {
        timeToComplete: 'La Ronda Termina en',
        startPlaying: 'Empezar a Jugar',
        howToPlay: '¿Cómo jugar?',
        nftToPlay: 'Tus Mascotas',
        edit: 'Editar',
        nftToPlayInfo:
            'Selecciona tus mascotas que participarán en el juego y ganarán recompensas',
        nftToPlayHint:
            'El orden de tus mascotas importa. La primera mascota será la visible en tu Pet ID del juego compartido. La primera mascota también es la que obtiene más experiencia por realizar las tareas',
        noNFTyet: 'Aquí no vive nadie',
        noNFTyetInfo:
            'Por desgracia, aún no tienes compañero animal. Consigue tu primera mascota y empieza a jugar',
        exploreShop: 'Explorar Tienda',
        mintNew: 'Consigue tu Primera Mascota',
        dailyTasks: 'Tareas Diarias',
        dailyTasksInfo:
            'Completa tus tareas diarias para ganar energía y luego intercámbiala por Tokens',
        timeLeftToComplete: 'La Ronda Termina en',
        selectNFT: 'Añadir más Mascotas',
        playCards: {
            SHARE_title: 'Comparta tu Mascota ',
            SHARE_info:
                'Tus mascotas necesitan atención diaria.\n' +
                'Compártelas en las redes sociales',
            SHARE_button: 'Tarea Social Abierta',
            addSocialAccount: 'Añadir Cuenta Social',
            socialAlert:
                'La verificación de la tarea social puede durar hasta 12 horas, completarla más tarde puede dar lugar a Energía acreditada en la siguiente iteración del juego',
            MOVE_title: 'Pasee a tus Mascotas',
            MOVE_info:
                'Tus mascotas necesitan pasear todos los días.\nPasee con sus mascotas',
            MOVE_button: 'Tarea de Caminar Abierta',
            PLAY_title: 'Juegue con tus mascotas',
            PLAY_info:
                'Juega con tus mascotas a un minijuego arcade basado en reacciones',
            PLAY_button: 'Abrir Juego Acrade',
            VERIFY_title: 'Buscar otras Mascotas',
            VERIFY_info:
                'Encuentra las mascotas de otros usuarios en las redes sociales',
            VERIFY_button1: 'Continuar Búsqueda',
            VERIFY_button2: 'Buscar Otras Mascotas',
            completedEnergy:
                '{{energyRewarded}} / {{maxEnergyReward}} Energía Recopilada',
            SHARE_failed_title: 'Tu Publicación no ha sido Verificada',
            SHARE_failed_text:
                'Al verificar tu publicación, otros usuarios no lograron encontrar o ver tu Pet ID. Hemos echado un vistazo a la publicación y tampoco hemos podido verificarlo. Lamentablemente, hoy no recibirás energía por esta tarea. Por favor, intenta estar más atento la próxima vez',
            SHARE_failed_button: 'Volver al Juego',
            knowledgeBase: 'Ver la Base de Conocimientos',
            SHARE_failed_reasons: {
                notEnoughFollowers:
                    'Parece que su cuenta no está lo suficientemente activa. Por favor, elija otra cuenta o intente desarrollar esta',
                petIdNotFound:
                    'Otros usuarios dijeron que no pudieron encontrar el Pet ID compartido en tu cuenta. Por favor, no se olvide de compartirlo la próxima vez',
                petIdIncorrectPosition:
                    'La identificación de su mascota está colocada de tal forma que los demás usuarios no pueden distinguirla. Intente tener más cuidado la próxima vez',
                userNotFound:
                    'Tanto los usuarios como los administradores no han podido encontrar tu cuenta. ¿Le ha pasado algo?',
            },
            SHARE_success_title: 'Tarea de Compartir Completada',
            SHARE_success_text:
                'Felicidades has compartido una foto y ha pasado la verificación. Vuelve mañana para ver más',
            SHARE_success_button: 'Ver Detalles',
        },
        modalAllDead: {
            title: 'Tus Mascotas han Muerto',
            text: 'No puedes realizar tareas hasta que al menos una de tus mascotas esté en buen estado. Restaura tus mascotas y vuelve',
            button: 'Restaurar Mascotas',
        },
        modalSomeDead: {
            title: 'Algunas de tus Mascotas han Muerto',
            text: 'Algunas de tus mascotas están muertas y no ganarán recompensas. ¿Estás seguro de que quieres continuar?',
            button: 'Restaurar Mascotas',
            button2: 'Seguir Jugando',
        },
    },
    collectionsScreen: {
        title: 'Mi Colección',
        text: 'Este es un hogar para tus increíbles mascotas',
        mintNewNft: 'Consigue tu Primera Mascota',
        mintPet: 'Crear una Mascota',
        noCollectionsYet: 'Aquí no vive nadie',
        noCollectionsYetInfo:
            'Por desgracia, aún no tienes compañero animal. ¿Cómo puedes vivir sin un animal de compañía?',
        levelUp: 'Subir de Nivel',
        rankUp: 'Subir de Rango',
        restore: 'Restaurar',
        feed: 'Alimentar',
        healAllButtonTooltip:
            'Sólo puedes usar la alimentación masiva de mascotas si tienes al menos 2 mascotas con una salud inferior al 100%',
    },
    detailedPet: {
        headerSubtitle:
            'Esta es tu mascota NFT, puedes completar las tareas diarias con su ayuda y obtener recompensas en Tokens. Cuídala bien',
        levelXP: {
            title: 'Nivel y XP',
            text: 'Gana XP por completar tareas y aumentar el nivel de tu mascota. Después de alcanzar cierto nivel, la mascota puede subir a un rango superior',
            textUpgrade:
                'Has conseguido toda la experiencia en el nivel {{level}}. Actualiza tu NFT a un nuevo nivel para ganar más Tokens',
            upgrade: 'Subida de Nivel {{level}}',
        },
        animalType: {
            title: 'Tipo de Animal',
            text: 'Nuestros algoritmos son capaces de reconocer animales en imágenes con una alta probabilidad',
        },
        rank: {
            title: 'Rango {{rank}}',
            text: 'El rango es una de las principales características de las mascotas. Los rangos más altos ganan más recompensas y tienen una mayor tasa de desbloqueo de recompensas',
            upgrade: 'Subir de Rango "{{rank}}"',
            textUpgrade:
                'Has alcanzado todos los niveles en el rango "{{rank}}". Sube de rango para ganar más Tokens',
        },
        age: {
            button: 'Restaurar NFT',
            Baby: 'Bebé = {{current}} / {{max}} Días',
            Young: 'Joven = {{current}} / {{max}} Días',
            Adult: 'Adulto = {{current}} / {{max}} Días',
            Old: 'Anciano = {{current}} / {{max}} Días',
            description:
                'La edad de tu mascota se considera desde el momento de su creación. Cuando su NFT envejezca, morirá y habrá que restaurarla',
            descriptionDead:
                'La mascota ha vivido una vida larga y feliz y ha fallecido. No tienes por qué enfadarte, ¡puedes restaurarla y volver a jugar!',
            dailyUnlock: 'Desbloqueo Diario = ',
            daysMore: 'días más',
            modalWhatIsAge: {
                title: '¿Qué es la Edad?',
                text: 'Una vez que crees tu mascota NFT, empezará a vivir y a envejecer. A medida que envejezca, acabará muriendo. En este caso, será necesario restaurarla. La longevidad de tu mascota virtual depende de su Rango',
                feature: {
                    title: 'Descuento al Restaurar = {{discount}}%',
                    text: 'Tras la muerte natural del NFT, podrás restaurarlo con un {{discount}}% de descuento (conservando el Rango)',
                    alert: 'Una subida de rango restablecerá la edad de tu mascota a 0, y la mascota virtual mejorada vivirá según el límite de edad del nuevo rango. Después de restaurar el NFT, empezarás desde el Nivel 1',
                },
            },
            modalNFTisAgeDead: {
                button: 'Restaurar',
                title: 'La mascota era vieja y murió',
                text: 'La mascota NFT "{{name}}" ha vivido una vida larga y feliz y ha fallecido. No tienes por qué enfadarte, ¡puedes restaurarla y volver a jugar!',
                feature: {
                    title: 'Descuento al Restaurar = {{discount}}%',
                    text: 'Tras la muerte natural del NFT, podrás restaurarlo con un {{discount}}% de descuento (conservando el Rango)',
                    alert: 'Una subida de rango restablecerá la edad de tu mascota a 0, y la mascota virtual mejorada vivirá según el límite de edad del nuevo rango. Después de restaurar el NFT, empezarás desde el Nivel 1',
                },
            },
            checkoutAgeRevive: {
                title: 'Restaurar Mascota',
                text: 'Tu mascota era vieja y murió. No está disponible para las tareas diarias. Recupérala para jugar y ganar más Tokens',
                restoreTo: 'Restaurar a',
                transaction: 'Restaurar "{{name}}" NFT',
                errors: {
                    wrongState: 'Algo va mal, no puedo restaurar a la mascota.',
                },
            },
            successAgeRevive: {
                title: '¡Mascota restaurada!',
                text: 'Mascota restaurada con éxito. Juega tareas diarias y gana aún más Tokens con su mascota feliz',
                backToPet: 'Ver Mascota',
            },
        },
        earnings: {
            title: 'Ganancias',
            text: 'Las ganancias de NFT dependen del rango y nivel de la mascota',
            rank: 'Rango Ganancias = ',
            level: 'Bonus del nivel = ',
        },
        matching: {
            title: 'Partidos',
            text: 'En las tareas diarias, otros usuarios pueden valorar tu NFT y emparejarse entre sí',
            like: '{{like}} Me gusta',
            dislike: '{{dislike}} No me gusta',
        },
        health: {
            title: 'Salud',
            text: 'Mantén a tu mascota alimentada, de lo contrario puede perder la salud. Cuando su salud llegue a 0, morirá',
            titleDead: 'NFT ha muerto',
            textDead:
                'No has alimentado a tu animal durante mucho tiempo y ahora está muerto. No podrás recoger experiencia, recompensas ni jugar con tu mascota. Pero no te preocupes, puedes restaurarla y seguir jugando. ¡Date prisa!',
            buttonFeed: 'Alimentar a Mascotas',
            buttonRestore: 'Restaurar NFT',
            modalWhatIsHealth: {
                title: '¿Qué es la salud?',
                text: 'La salud de tu mascota disminuye cada día si no la alimentas. Mantén su salud siempre al máximo para ganar más.',
                card: {
                    title: 'Salud de la Mascota = Recompensa Diaria',
                    text: 'Las recompensas son proporcionales a los HP, por ejemplo, con 80 HP ganarás el 80% de las recompensas. ¡Cuida bien de tu mascota!',
                },
            },
            modalNFTisDead: {
                title: 'NFT ha muerto',
                text: 'No has alimentado a tu animal "{{petName}" durante mucho tiempo y ahora está muerto. No podrás acumular experiencia, recompensas ni jugar con tu mascota. Pero no te preocupes, puedes restaurarla y seguir jugando. ¡Date prisa!',
                button: 'Restaurar NFT',
            },
            checkoutRevive: {
                title: 'Restaurar NFT',
                text: 'Tu NFT no está disponible para las tareas diarias. Recupérala para jugar y ganar más Tokens',
                restoreTo: 'Restaurar a',
                transaction: 'Restaurar "{{name}}" NFT',
                max: '100 Salud',
                errors: {
                    wrongState:
                        'Algo va mal, no se puede restaurar a la mascota.',
                },
            },
            successRevive: {
                title: 'Restauración de NFT',
                text: 'NFT se ha restaurado con éxito. Juega a las tareas diarias y gana aún más Tokens',
                backToPet: 'Ver Mascota',
            },
            checkoutHealUp: {
                title: 'Alimentación NFT',
                text: 'La salud de tu animal depende de su alimentación diaria. Con plena salud, tu animal gana más monedas',
                restoreTo: 'Restaurado',
                transaction: 'Restaurar "{{name}}" NFT',
                max: '{{amount}} Salud',
                errors: {
                    wrongState: 'Algo va mal, no se puede curar a la mascota.',
                },
            },
            infoMultipleHealUp: {
                title: 'Alimentar Varias Mascotas',
                text: '¡Usa un botón para alimentar a todas tus mascotas! Las mascotas se curarán una a una. Todas las transacciones tienen lugar en la blockchain, por lo que podrás hacerles un seguimiento',
                primaryButton: 'Alimentar Mascotas',
                secondaryButton: 'No vuelvas a mostrar esto',
            },
            checkoutMultipleHealUp: {
                title: 'Curar a Varias Mascotas',
                text: 'Curar a todas tus mascotas. Los NFT con más salud obtendrán más recompensas',
                transaction: 'Restaurar {{count}} NFTs',
            },
            proceedingMultipleHealUp: {
                title: 'Curando',
                text: 'Por favor, espere un poco hasta que finalicen todas las transacciones. No salga de la pantalla, ya que las transacciones pueden fallar. Una vez finalizadas, podrá salir',
                error: 'Algunas transacciones NFT fallaron debido a problemas con Blockchain. Vuelva a intentarlo',
            },
            multipleSuccessHealUp: {
                title: 'NFTs ¡Curado!',
                text: 'Tu mascota ha sido curada. Haga clic en el botón de abajo para obtener más detalles sobre cada transacción',
                backToCollection: 'Volver a la Colección',
                item: 'Alimentación {{length}} mascotas',
            },
            successHealUp: {
                title: 'NFT ¡Curado!',
                text: 'NFT se ha alimentado con éxito y ha restablecido la salud. Juega a las tareas diarias y gana aún más Tokens',
                backToPet: 'Ver Mascota',
            },
            healUpAmountChoose: {
                title: 'Alimentar para Curar',
                text: 'Elija la opción con la cantidad de puntos de salud que desea restaurar/curar',
                button: 'Verificar',
                loading: 'Calculando resumen..',
                label: 'Seleccione el número apropiado',
                errors: {
                    MAX: 'Máximo disponible para curar {{amount}}',
                    MIN: 'Mínimo disponible para curar {{amount}}',
                },
            },
            healthPetCollectionList: { health: '{{health}} Salud' },
            healAllLeave: {
                title: '¿Seguro qué Quieres Irte?',
                text: 'La curación de su mascota está en curso, salir durante el proceso puede dar lugar a errores, doble gasto o deducción incorrecta del saldo. Proceda con precaución',
                leave: 'Salir de Todos Modos',
                keep: 'Finalizar Curación',
            },
        },
        blockchainInfo: {
            tokenId: 'Token ID',
            title: 'Visión General de NFT',
            description:
                'Su activo de NFT mascota se almacena en blockchain. Puedes retirarlo de la cartera en cualquier momento',
            descriptionFree:
                'Tu mascota es Rank Free y no un NFT real. Sube de nivel y usted será capaz de hacer NFT de ella',
            warningText:
                'Tras la retirada, NFT entrará en modo Cooldown y no estará disponible para jugar durante 24 horas',
            cooldown: 'Cooldown finaliza en',
            withdraw: 'Retirar',
        },
    },
    mysteryBoxes: {
        title: 'Cajas Misteriosas',
        emptyTitle: 'Aún no hay Cajas Misteriosas',
        emptyText: 'No posees ninguna Caja Misteriosa',
        emptyButton: 'Comprar Caja',
        prepareToOpen:
            'Abriendo Caja, a la espera de resultado aleatorio de ChainLink Oracle..',
        banner: {
            isComing: {
                title: 'Se Acerca la Venta de Cajas Misteriosas',
                text: ' tiempo restante',
            },
            isStart: {
                title: 'Comprar Caja Misteriosa',
                text: 'Prueba tu suerte y gana los rangos más altos',
            },
            isNotAvailable: {
                title: 'La Venta de Cajas Misteriosas está Cerrada',
                text: 'Las ventas de cajas misteriosas se realizan en raras ocasiones y no serán disponibles hasta nuevo aviso',
            },
        },
        header: {
            title: 'Cajas Misteriosas',
            text: 'Sus cajas compradas se guardarán aquí. Ábralas cuando quiera y mintea NFT',
        },
        mysteryBoxCard: { open: 'Caja aAbierta', mint: 'Mint NFT' },
        error: { title: 'Error', text: 'Algo ha ido mal. Intenta recargar' },
        openRank: { button: 'Ver Detalles' },
        openBoxModal: {
            title: '¿Quieres Abrir una Caja?',
            text: 'Tras abrir la caja, obtendrás un rango aleatorio y podrás mintear NFT gratis',
            button1: 'Sí, Abrir',
            button2: 'No, Cancelar',
        },
        purchaseWelcome: {
            stepOne: {
                title: 'Prueba su Suerte con las Cajas Misteriosas',
                text: 'Las Cajas Misteriosas te dan la oportunidad de conseguir el mejor NFT Rank por un precio fijo. ¡Prueba tu suerte!',
            },
            stepTwo: {
                title: 'Posibilidad de Obtener el Rango más Alto',
                text: 'Después de comprar la Caja Misteriosa, puede abrirla en cualquier momento y continuar con el proceso de minting sin ningún coste adicional',
            },
            stepThree: {
                title: 'Verdadero Azar',
                text: 'Las posibilidades de ganar diferentes rangos en la Caja Misteriosa son totalmente aleatorias y utilizan la tecnología ChainLink Oracle para generar un número aleatorio real en el Blockchain',
            },
            button: 'Seleccionar la Cantidad de Cajas',
        },
        purchaseScreen: {
            title: 'Seleccionar la Cantidad',
            text: 'Puedes comprar varias cajas a la vez',
            label: 'Introduzca o selecciona el importe',
            labelNoInput: 'Seleccionar la cantidad de Cajas Misteriosas',
            errors: {
                max: 'El máximo disponible es de 10 cajas',
                min: 'El mínimo disponible es de 1 caja',
                noSymbols: 'Sólo se admiten números',
            },
            button: 'Verificando',
            loading: 'Calculando resumen..',
        },
        purchaseCheckout: {
            title: 'Comprar Cajas Misteriosas',
            text: 'Las Cajas Misteriosas te dan la oportunidad de conseguir el mejor NFT Rango por un precio fijo. ¡Prueba tu suerte!',
            transactionDetails: {
                label: 'Caja',
                text: '{{amount}} Caja Misteriosa',
                transaction: 'Comprar {{amount}} Caja Misteriosa',
            },
        },
        purchaseSuccess: {
            title: 'Cajas Misteriosas Compradas',
            text: 'Las Cajas Misteriosas se han comprado correctamente. Puede abrirla desde la pestaña Cajas Misteriosas',
            button: 'Ver Todos',
        },
        comingSoon: {
            title: 'Próximamente Cajas Misteriosas',
            text: 'Se acerca la Venta de Cajas Misteriosas. Permanezca atento y prueba tu suerte',
            timer: 'Tiempo Restante',
        },
        saleClosed: {
            title: 'Cajas Misteriosas no Disponibles',
            text: 'La venta de Cajas Misteriosas no está disponible en este momento. Esté atento a los anuncios oficiales',
        },
        errors: {
            forbidden: {
                title: 'Se Acabaron las Ventas',
                text: 'La Venta ha terminado, no quedan Cajas Misteriosas para comprar. Pruebe suerte la próxima vez',
            },
        },
        modalMysteryBoxSaleInfo: {
            title: 'Prueba tu suerte con las Cajas Misteriosas',
            text: 'Se garantiza que el valor NFT ganado no será inferior al precio de la Caja Misteriosa. Las Cajas Misteriosas se venderán por el precio',
            timerTitle: 'Tiempo hasta la Venta',
            timerText:
                'Se trata de una venta de una colección limitada, que durará un tiempo limitado. Sólo ',
            timerAdditionalText: '{{cantidad} NFT disponibles',
            chanceTitle: 'Posibilidades de Ganar',
            chanceText:
                'Gana un NFT con cierta probabilidad. Estas son las probabilidades:',
            button: 'Ir a Cajas Misteriosas',
        },
    },
    errorBoundary: {
        navigation: 'Error',
        title: 'Error del Cliente',
        text: 'Lamentablemente, algo ha fallado. Si sigue viendo este error, póngase en contacto con nuestro servicio de asistencia técnica',
        button: 'Ir a la Página Principal',
        reloadApp: 'Recargar Aplicación',
    },
    pullToRefresh: {
        reloadBalance: {
            text: 'Actualizando activos..',
            modalText: 'Actualizando...',
        },
        reloadPets: {
            text: 'Actualizando Mascotar..',
            modalText: 'Actualizando...',
        },
        reloadMysteryBox: {
            text: 'Actualizando Cajas Misteriosas..',
            modalText: 'Actualizando...',
        },
        reloadTasks: {
            text: 'Actualizando Tareas..',
            modalText: 'Actualizando...',
        },
        reloadVerifyUsers: {
            text: 'Buscando Mascotas ..',
            modalText: 'Actualizando...',
        },
        reloadRewards: 'Actualizando Recompensas...',
        reloadStatistics: 'Actualizando Estadísticas...',
        reloadReferrals: 'Actualizando Referencias...',
        loading: 'Actualizando...',
        pulling: 'Desliza para refrescar',
        releasing: 'Compartir',
    },
    petLevelUp: {
        readyToUpModal: {
            titleStart: 'NFT está Preparada para',
            titleLevelUp: ' {{level}} Nivel ',
            titleEnd: 'Arriba',
            subTitleStart:
                '¡Enhorabuena! Usted ha recopilado toda la experiencia y NFT ',
            subTitleEnd: ' está listo para subir de nivel',
            button: 'Subir de Nivel',
            featureRankEarnings: {
                title: 'Ganancias por rango ≈ {{igup}} ≈ ({{usd}}$)',
                text: 'Estas son tus ganancias basadas únicamente en el Rango',
            },
            featureLevelEarnings: {
                title: 'Ganancias de nivel',
                text: 'Ganancias adicionales que obtienes por el Nivel de tu NFT. Cada subida de nivel aumenta tus ganancias',
            },
            featureNextRank: {
                title: '{{levels}} nivel(es) Más a “{{rankName}}”',
                text: 'Necesitas subir de nivel tu NFT {{levels}} veces más para poder subirlo al siguiente Rango',
            },
        },
        petLevelUpSuccess: {
            title: 'NFT ha Subido de Nivel',
            text: 'NFT {{name}} ha subido de nivel a {{level}}. Juega a las tareas diarias y gana aún más Tokens con el NFT mejorado',
            backToPet: 'Ver Mascota',
            loading: 'Subiendo Mascota...',
        },
        headerTitle: 'NFT Level Up',
        checkout: {
            upgrade: 'Subir a',
            level: 'Nivel {{level}}',
            transaction: 'Subir de nivel para {{name}} NFT',
        },
        errors: { PET_WRONG_STATE: 'No se puede subir de nivel' },
    },
    petRankUp: {
        readyToUpModal: {
            title: 'Subir a {{rank}} Rango',
            subTitle:
                'Has alcanzado todos los niveles en el rango {{rank}} y tu Mascota está lista para subir de Rango',
            button: 'Subir',
        },
        petLevelUpSuccess: {
            title: 'Clasificación NFT',
            text: 'NFT {{name}} se ha clasificado con éxito hasta el rango {{rank}}. Juega a las tareas diarias y gana aún más Tokens con NFT mejorado',
            backToCollection: 'Volver a la Colección',
            loading: 'Subiendo Mascota...',
        },
        headerTitle: 'NFT Level Up',
        checkout: {
            upgrade: 'Suiendo a',
            level: 'Nivel {{level}}',
            transaction: 'Subir de nivel para {{name}} NFT',
        },
        errors: { PET_WRONG_STATE: 'Clasificación no disponible' },
    },
    petIsPlaying: {
        title: 'Su Mascota está Jugando',
        text: 'Si la retiras de tu cuenta antes de completar las tareas, no obtendrás recompensas por hoy y tu mascota entrará en modo Cooldown durante las próximas 24 horas',
        button: 'Entiendo',
    },
    petOnCooldown: {
        title: 'Cooldown NFT',
        text: 'Su NFT está siendo transferido desde otro intercambio y aún no se puede jugar, el tiempo estimado de transferencia se muestra arriba. Hacemos todo lo posible para que sea más rápido, gracias por su comprensión',
    },
    petIsDead: {
        title: 'NFT ha Muerto',
        text: 'No has Alimentado a tu animal "{{petName}" durante mucho tiempo y ahora está muerto. No podrás acumular experiencia, recompensas ni jugar con tu mascota. Pero no te preocupes, puedes revivirla y seguir jugando. ¡Date prisa!',
        errors: { PET_WRONG_STATE: 'Restauración de mascotas no disponible' },
    },
    socializeToEarn: {
        welcomeSlidesShare: {
            startSharing: 'Empezar a Compartir',
            sharing: 'Compartir es Cuidar',
            sharingText:
                'Cada día tu mascota necesita tu atención. Dásela compartiéndola en las redes sociales con tus amigos',
            sharingEnergy: ' Energía Total',
            socialMedia: 'Comparta su mascota en las redes sociales',
            socialMediaText:
                'Elija su cuenta de redes sociales y adjunte un Pet ID a su contenido en las redes sociales y permita que otros usuarios encuentren a tu mascota',
            socialMediaEnergy: ' Energía Total',
            referral: 'Añada su enlace de recomendación',
            referralText:
                'Tu enlace de referencia debe estar unido al ID de la mascota en la historia. Los demás jugadores no podrán comprobar tu asignación si falta el enlace!',
            errors: {
                FORBIDDEN: {
                    text: 'No puede iniciar la tarea social ahora con esta cuenta social. Inténtelo de nuevo mañana',
                },
            },
        },
        shareYourPetPhoto: {
            copyToClipboard: 'Nombre del usuario copiado en portapapeles',
            title: 'Comparta la Foto de su Mascota',
            texts: {
                INSTAGRAM:
                    'Comparta tu contenido con la tarjeta del Pet ID en Instagram y permita que otros usuarios encuentren a tu mascota',
                TIKTOK: 'Comparta tu contenido con la tarjeta del Pet ID en TikTok y deja que otros usuarios encuentren a tu mascota',
                TWITTER:
                    'Comparta tu contenido con la tarjeta del Pet ID en Twitter y permita que otros usuarios encuentren a tu mascota',
                FACEBOOK:
                    'Comparta tu contenido con la tarjeta del Pet ID en FACEBOOK y permita que otros usuarios encuentren a tu mascota',
            },
            info: '¿Cómo compartir?',
            download: 'Descargar',
            share: 'Compartir',
            createPhoto: 'Editor Aierto',
            button: 'Compartir y Terminar',
            warningText:
                'Asegúrese de que el Pet ID de su mascota esté disponible y sea fácil de encontrar para otros usuarios hasta que finalice su tarea',
            selectCreationMethod: 'Seleccionar Foto',
            creationMethod: {
                camera: 'Hacar Foto',
                gallery: 'Seleccionar de la Galería',
            },
            modalPetIdVisible: {
                title: '¿La identificación de la mascota y el enlace son visibles?',
                text: 'Tu historia será revisada por otros usuarios. Si no pueden encontrar Pet ID o el enlace o no pueden discernir su contenido, se rechazará la finalización de su tarea',
                button1: 'Sí, continuar',
                button2: 'No, volver a comprobarlo',
            },
            modalShareYourPhoto: {
                title: 'Seleccionar método de compartir',
                shareTemplate: {
                    title: 'Compartir Plantilla',
                    text: 'Utilice la plantilla que hemos creado para compartir su Pet ID más rápidamente',
                },
                editToShare: {
                    title: 'Editar para Compartir',
                    text: 'Cargue una imagen de la galería o haga una foto para editar un Pet ID personalizado',
                },
                downloadPetId: {
                    title: 'Descargar Pet ID',
                    text: 'Estiliza el post a tu gusto sin utilizar nuestras herramientas',
                },
                submit: 'He compartido el Pet ID',
                loading: 'Preparando contenidos..',
                saveSuccess: 'Foto guardada correctamente',
            },
            petIdVisibleLoading: 'Crear tarea de búsqueda..',
            shareSuccess: {
                title: 'Buscar Otras Mascotas',
                text: 'Has compartido correctamente la foto de tu mascota. Tu tarea está en verificación y suele tardar entre 6 y 12 horas. Ahora te toca a ti encontrar otras mascotas en las redes sociales',
                button1: 'Buscar Otras Mascotas',
                button2: 'Volver a Compartido',
                button3: 'Volver a Tareas',
                toastSuccess: 'Todas las Tareas de Verificación Completadas',
            },
            alert: 'La tarea se considerará completa solo si coloca el enlace a la aplicación',
        },
        createShareTemplate: {
            screenTitle: 'Compartir Plantillas',
            title: 'Utilizar la Plantilla para Compartir',
            text: 'Utilice nuestra plantilla prediseñada para compartir contenidos de forma rápida y cómoda',
            shareTemplate: {
                Default: 'Todos los días juego IguVerse y Gana criptomonedas',
                BinanceNft:
                    'Consigue una mascota virtual y empieza a ganar dinero con IguVerse',
                BnbChain:
                    'Consigue una mascota virtual y empieza a ganar dinero con IguVerse',
                Okx: 'Aterrizaje lunar: lanzamiento de IGU en OKX',
                KuCoin: 'Aterrizaje lunar: lanzamiento de IGU en KUCOIN',
                Bybit: '¡Vote por IguVerse\ny comparta\n$121,000 en\nrecompensas!',
            },
            placeForLink: 'Lugar de enlace',
            socialCardTemplate: {
                Default: 'Juego IguVerse\ny Gana criptomonedas',
                Bybit: '¡Vote por IguVerse\ny comparta\n$121,000 en\nrecompensas!',
            },
        },
        welcomeSlidesVerify: {
            startVerify: 'Iniciar Tarea de Búsqueda',
            find: 'Buscar Otras Mascotas',
            findText:
                'Tu mascota necesita la atención de otras mascotas. Encuentra mascotas de otros jugadores y disfrutad juntos de las recompensas. No te equivoques mientras buscas a otras mascotas, ellas dependen de ti. Tu objetivo diario es encontrar a todas las mascotas.',
            findEnergy: ' Energía Total',
            beResponsible: 'Sea responsable',
            beResponsibleText:
                'Juega limpio y no intentes engañar al sistema proporcionando identificaciones erróneas o afirmando que no puedes encontrarlas. Tu cuenta puede ser bloqueada si haces esto ',
            beResponsibleEnergy: ' Energía Total',
        },
        verifyUser: {
            title: 'Buscar Mascota',
            text: 'Tienes que encontrar e introducir el Pet ID de otro usuario, que puedes encontrar en las redes sociales. Por cada partido exitoso obtendrá {{energy}} Energía',
            info: '¿Cómo encontrar el Pet ID?',
            label: 'Pet ID',
            placeHolder: 'Introduzca el Pet ID',
            question: '¿Cómo encontrar un Pet ID?',
            buttonVerify: 'Vericando',
            buttonNotFound: 'No se ha encontrado el Pet ID indicado',
            errorMessage:
                'Pet ID incorrecto. Por favor, inténtelo de nuevo. ¡Quedan intentos {{attempts}}!',
            loadingVerifyUser: 'Verificando..',
            errors: {
                noTasksText1: 'No hay Tareas Disponibles actualmente',
                noTasksText2: 'Vuelva más tarde',
                gameIterationExists1: 'No está permitido crear',
                gameIterationExists2: 'Más tareas en esta iteración del juego',
            },
            toastNoPetVerification: {
                title: 'Error',
                text: 'No hay animales de compañía disponibles para su verificación ',
            },
            toastSuccess: '¡Felicidades! Usuario {{user}} verificado',
            toastFailedVerify: 'Fallo Usuario {{user}} no verificado',
            regexError: 'Sólo se admiten dígitos y caracteres de la A a la Z',
            verifyEmpty: {
                title: 'No hay más Mascotas',
                text: 'Parece que nadie está jugando ahora. Te avisaremos cuando haya más mascotas disponibles',
                button1: 'Explorar Otras Tareas',
                button2: 'Inténtalo de Nuevo',
                refresh: 'Actualizar',
            },
            verifyNotFound: {
                title: 'Mascota no Encontrada',
                text: 'Espero que tengas razón. Si la mascota estaba realmente allí le daremos una advertencia',
                button1: 'Buscar Siguiente',
                button2: 'Terminar de Jugar',
            },
            verifyAlreadyCompleted: {
                title: 'Finalizado',
                text: 'Texto Finalizado',
                button1: 'Verificar Siguiente',
                button2: 'Terminar de Jugar',
            },
            verifyMatch: {
                title: 'Mascotas Emparejadas',
                text: {
                    step1: '¡Felicidades! Su mascota ',
                    step2: ' se emparejó con mascota ',
                    step3: '¡! Ahora podrás conectarte dentro de la aplicación',
                },
                button1: 'Buscar Siguiente',
                button2: 'Terminar de Jugar',
                like: 'Me gusta',
                dislike: 'No me gusta',
                alreadyRate: 'No puede cambiar su decisión',
            },
            verifyFailed: {
                title: 'Fallido',
                text: 'Lamentablemente, no ha introducido correctamente el Pet ID',
                button1: 'Buscar Siguiente',
                button2: 'Terminar de Jugar',
            },
            modalPetIdNotFound: {
                title: '¿No se encuentra el Pet ID?',
                text: 'Intenta encontrar el Pet ID en la foto del usuario. Si el Pet ID estaba allí y no lo proporcionaste, entonces no ganarás tus puntos de Energía y puedes recibir una advertencia.',
                button1: 'Sí, Confirmar',
                button2: 'Cancelar',
            },
            tips: {
                title: 'Consejos de Verificación',
                alert: 'Si el Pet ID no cumple las normas, haga clic en el botón "Pet ID no Encontrado"',
                post: 'El Pet ID debe colocarse en una publicación',
                picture:
                    'El Pet ID y toda su información deben ser visibles en el contenido',
                changes:
                    'Se puede cambiar el Pet ID, pero los cambios no deben ir en contra de otras normas',
                cropping:
                    'No se permite recortar ni ocultar la imagen o sus partes',
                overlaying:
                    'No se permiten superposiciones ni reducciones excesivas de tamaño',
            },
        },
        petCardId: {
            link: 'Descarga la Aplicación IguVerse en ',
            earnStart: 'Mis Mascotas ganan ',
            earnEnd: ' todos los días',
            freeEarn: 'Mi mascota Free gana ',
            donateMessage: 'Una parte de mis ganancias es donada a ',
            binanceMessage: 'Venta de IguVerse x Binance NFT',
            bnbMessage:
                'IguVerse x Cadena BNB: Únete a la nueva tendencia viral en Web3 y redes sociales',
            okxKuCoinMessage: 'El token IGU se lanza en ',
            defaultMessage:
                'Pionero en un mercado impulsado por IA y una red publicitaria: ¡únase ahora!',
        },
    },
    moveToEarn: {
        welcomeSlides: {
            walkPet: 'Pasee a tus Mascotas',
            walkPetText:
                'Tus mascotas necesitan pasear todos los días para mantenerse sanas tanto como tú. Pasea a tu mascota y serás recompensado con puntos de Energía',
            energyTotal: ' Energía Total',
            complete: 'Completa tu Objetivo de Caminar',
            completeText:
                'Completa tu objetivo de caminar, realiza un seguimiento de tu rendimiento y disfruta de un estilo de vida saludable',
            antiCheating: 'Algoritmos Contra el Engaño',
            antiCheatingText:
                'Nuestros algoritmos antitrampas son capaces de detectar actividades sospechosas de los usuarios. Los usuarios que hagan trampas perderán sus puntos de energía',
        },
        modals: {
            prepare: 'Prepárese para Caminar',
            prepareText:
                'Puedes completar la tarea de caminar una vez al día. Cuando termines o cierres la tarea, no podrás jugar más ese día',
            leave: '¿Quieres irte?',
            leaveText:
                'Terminarás la tarea con tu progreso actual de Energía. Puedes empezar la tarea de nuevo mañana',
            leaveBtn1: 'Sí, irme',
            leaveBtn2: 'No, continuar',
            prepareBtn1: 'Empezar a caminar',
            prepareBtn2: 'Cancelar',
            permissionsInfoText:
                'IguVerse recopila datos de localización incluso cuando la aplicación está cerrada o no se utiliza. La App puede acceder a tu ubicación en segundo plano para garantizar la funcionalidad de Tarea Caminar',
            permissionsInfoBtn1: 'Continuar',
            permissionsInfoBtn2: 'Cancelar',
            leaveWithOutFinish: '¿Quiere salir?',
            leaveWithOutFinishText:
                'Después de cerrar la tarea, tu progreso desaparecerá y deberás empezar de nuevo',
            leaveWithOutFinishBtn1: 'Salir',
            leaveWithOutFinishBtn2: 'Cancelar',
        },
        notSupported: {
            title: 'Geolocalización no disponible',
            text: 'Su dispositivo no es compatible con la API de geolocalización, no puede completar la tarea Caminar',
            button: 'OK',
        },
        locationProblem: {
            title: 'Problemas de geolocalización',
            text: 'Hemos observado que la función de geolocalización de su dispositivo ha dejado de funcionar como se esperaba, por lo que debe reiniciar la tarea',
            button: 'Lo tengo',
        },
        progress: {
            paused: 'En pausa',
            walking: 'Caminar',
            stopped: 'Detenido',
            tooFast: 'Demasiado rápido',
            title: 'Pasear a su Mascota',
            timeLeft: 'Tiempo Restante de Caminar',
            tooFastMessage:
                'Tu velocidad no puede ser superior a 20 km/h. El progreso se reanudará cuando la velocidad sea inferior',
            walkStoppedMessage:
                'Parece que has dejado de caminar. Su progreso se reanudará una vez que continúe caminando',
        },
        summary: {
            title: 'Estadísticas de la Caminada',
            youEarned: 'Has Ganado',
            energy: 'Energía',
            subtitle:
                '¡Felicidades! Has encontrado todas las mascotas. Vuelve mañana para más',
            distance: 'Distancia',
            steps: 'Pasos',
            averageSpeed: 'Velocidad media',
            viewMoreTasks: 'Ver más Tareas',
            finishPlaying: 'Terminar de Jugar',
        },
        startWalking: 'Empezar a Caminar',
        skip: 'Pulse para Saltar',
        km: 'km',
        kmH: 'km/h',
    },
    playToEarn: {
        welcomeSlides: {
            energy: 'Recupere su Energía',
            energyText:
                'Recoge frutas y salta obstáculos para restaurar tu nivel diario de Energía. Ten cuidado, sólo tienes un intento al día',
            energyAgainText:
                'Ejercita tu habilidad en el juego para ganar más recompensas. La tarea está disponible una vez al día, aunque puedes jugar en cualquier momento',
            energyTotal: ' Energía Total',
            energyAgainTotal: 'Aislamiento de Procesos',
            avoid: 'Evitar Obstáculos',
            avoidText:
                'Tu principal objetivo es saltar sobre los obstáculos y acumular puntos. Ten cuidado',
            food: 'Recoger Alimentos',
            foodText:
                'La comida recogida te da puntuaciones adicionales. Después de alcanzar el objetivo de puntuación, el juego termina y tu nivel de energía se restaura inmediatamente',
        },
        modals: {
            prepareToPlay: {
                title: 'Prepárate para jugar',
                text: 'En tu primera partida jugarás para recuperar energía. En el segundo y posteriores intentos podras jugar el juego pero sin el progreso de la energía',
                accept: 'Empezar a Jugar',
                cancel: 'Cancelar',
            },
            playAgain: {
                title: 'Prepárate para Jugar',
                text: 'Hoy ya has recogido la energía en este juego. Ahora puedes jugar para mejorar tus habilidades en los próximos días',
                accept: 'Empezar a Jugar',
                cancel: 'Cancelar',
            },
            loading: { text: 'Preparando el Juego..' },
            gameTimer: {
                text: 'Toca para saltar sobre los obstáculos. Gana puntos y recoge frutas',
                textWebDesktop:
                    'Pulsa la tecla "espacio" o el botón izquierdo del ratón para saltar sobre los obstáculos. Gana puntos y recoge frutas',
                textWebMobile:
                    'Toca para saltar sobre los obstáculos. Gana puntos y recoge frutas',
            },
            pause: {
                title: '¿Quieres irte?',
                text: 'Tu progreso actual se convertirá en Energía, pero no podrás seguir jugando este día',
                accept: 'Sí, irme',
                cancel: 'No, continuar',
            },
            win: {
                title: 'Tarea completada',
                text: 'Enhorabuena Has completado con éxito tu tarea diaria. Puedes seguir jugando para divertirte, pero no afectará a tu nivel de energía',
                accept: 'Finalizar',
                cancel: 'Ver más',
            },
            loose: {
                title: 'El Juego Finalizó',
                text: 'Has fallado tu tarea diaria. Puedes seguir jugando por diversión, pero no afectará a tu nivel de energía',
                accept: 'Finalizar',
                cancel: 'Ver más',
            },
            score: 'Su puntuación',
            energy: 'Energía Restaurada',
            savedLives: 'Vidas Salvadas',
            fruitCollected: 'Fruta Recogida',
        },
        summary: {
            title: 'Estadísticas del Juego',
            score: 'Tu Puntuación',
            lives: 'Vidas Salvadas',
            fruitCollected: 'Fruta Recogida',
        },
        startPlaying: 'Empezar a Jugar',
        loadingStatuses: {
            downloading: 'Descarga de recursos',
            preparing: 'Preparación de texturas',
            loadingGraphics: 'Carga de gráficos',
            spawning: 'Creación de objetos de juego',
            loading: 'Carga (no cierre la aplicación)',
        },
    },
    editNFTsScreen: {
        title: 'Elige Mascotas para Jugar',
        dragText:
            'Mascotas que participarán en los juegos. Arrástralo para cambiar el orden',
        selectList: 'Seleccione una mascota de la lista',
        warningMessage:
            'La primera mascota en orden se utilizará en su tarea social como Pet ID',
        cooldownMessage:
            'Tu NFT está en modo Cooldown y no puede participar en el juego. Espere hasta que expire el modo Cooldown',
        button: 'Guardar',
        errors: {
            saveChanges: {
                title: 'Cambios no Guardados',
                text: 'Tienes cambios sin guardar, ¿estás seguro de que quieres irte?',
                button1: 'Irme',
                button2: 'Volver para Guardar',
            },
        },
        loading: 'Guardando cambios..',
        success: 'NFT solicitud guardada!',
    },
    statuses: {
        COMPLETED: { title: 'Completado' },
        AWAITS_VERIFICATION: { title: 'A la espera de verificación' },
        MODERATOR_VERIFICATION_REQUIRED: {
            title: 'A la espera de verificación',
        },
        FAILED: { title: 'Fallido' },
    },
    profile: {
        title: 'Ajustes',
        logOut: 'Cerrar Sesión',
        deleteAccount: 'Eliminar Cuenta',
        logOutModal: {
            title: '¿Ya te vas?',
            description:
                'Tendrás que volver a iniciar sesión o crear una nueva cuenta para utilizar la aplicación IguVerse',
            okText: 'Sí, cerrar sesión',
            cancelText: 'Cancelar',
        },
        deleteAccountModal: {
            title: 'Eliminar Cuenta?',
            description:
                'Puedes eliminar definitivamente tu cuenta, pero ten en cuenta que no podrás volver a conectarte ni utilizarla',
            okText: 'Eliminar Cuenta',
            inputLabel: 'Frase de Confirmación',
            placeholder: 'Introduzca la frase de confirmación',
            preConfirmationPhrase: 'Tipo ',
            afterConfirmationPhrase: ' confirmar la acción',
            success: 'Su cuenta se ha eliminado correctamente',
            loading: 'Borrando tu cuenta..',
        },
        lightTheme: 'Claro',
        darkTheme: 'Oscuro',
        menuItems: {
            admin: {
                title: 'Verificar Usuarios',
                description: 'Verificar las redes sociales de los usuarios',
            },
            security: {
                title: 'Seguridad',
                description: 'Personaliza tu configuración de seguridad',
            },
            wallet: {
                title: 'Cartera',
                description:
                    'Gestiona la configuración de seguridad de tu Cartera',
            },
            socialAccounts: {
                title: 'Redes Sociales',
                description:
                    'Conecta tus redes sociales para participar en el Juego Social',
            },
            assignRole: {
                title: 'Asignar función',
                description:
                    'Seleccionar y asignar un rol de cuenta al usuario',
            },
            language: {
                title: 'Idioma',
                description: 'Idioma de visualización',
            },
            theme: {
                title: 'Tema',
                description: 'Seleccione un tema de interfaz',
            },
            notifications: {
                title: 'Notificaciones',
                description:
                    'Seleccione los tipos de notificaciones que desea recibir de la aplicación',
            },
            support: {
                title: 'Asistencia por chat',
                description:
                    'Deje su consulta y nuestro especialista le responderá en un chat',
            },
            supportEmail: {
                title: 'Asistencia por Correo Electrónico',
                description: 'Envíenos un correo electrónico si necesita ayuda',
            },
            knowledgeBase: {
                title: 'Base de Conocimientos',
                description:
                    'Consulta otra información útil de la aplicación IguVerse para saber más sobre nuestra privacidad',
            },
            privacyPolicy: {
                title: 'Política de Privacidad',
                description:
                    'Más información sobre nuestra Política de Privacidad',
            },
            termsOfUse: {
                title: 'Condiciones Generales',
                description:
                    'Más información sobre nuestras Condiciones Generales',
            },
            appVersion: {
                title: 'Versión de la Aplicación',
                description: 'Más reciente {{version}}',
            },
            webVersion: {
                title: 'Aplicación Web',
                description: 'Iniciar sesión en la aplicación web',
            },
            accessibility: {
                title: 'Accesibilidad',
                description:
                    'Personaliza la interfaz para adaptarla a tus preferencias',
            },
            socialMedia: {
                title: 'Nuestras Redes Sociales',
                description:
                    'Siga a IguVerse en las redes sociales para mantenerse informado',
            },
            adminSendPushNotification: {
                title: 'Enviar Notificación push',
                description:
                    'Crear una notificación push/emergente que se mostrará a todos los usuarios',
            },
            adminReverification: {
                title: 'Reverificación',
                description:
                    'Como administrador, puedes enviar una cuenta social para una verificación de seguimiento',
            },
            adminBlockUser: {
                title: 'Bloquear al Usuario',
                description:
                    'Bloquear la cuenta del usuario que haya infringido las normas de juego de IguVerse',
            },
            adminMaintenanceMode: {
                title: 'Modo de Mantenimiento',
                description:
                    'En caso de trabajo técnico, ponga la aplicación en modo de mantenimiento',
            },
            adminAssignWhiteList: {
                title: 'Asignar Lista bBlanca',
                description:
                    'Elija el número y el rango de NFT para enviar la lista blanca al ganador',
            },
        },
        languageSettings: {
            title: 'Idiomas',
            subtitle: 'Seleccionar idioma',
            description:
                'Puedes seleccionar el idioma preferido para mostrar el contenido en la aplicación IguVerse',
            options: {
                pl: {
                    name: 'Polaco',
                    change: 'Polaco',
                },
                en: {
                    name: 'Inglés',
                    change: 'Inglés',
                },
                ru: {
                    name: 'Ruso',
                    change: 'Ruso',
                },
                uk: {
                    name: 'Ucraniano',
                    change: 'Ucraniano',
                },
                cn: {
                    name: 'Chino',
                    change: 'Chino',
                },
                id: {
                    name: 'Indonesia',
                    change: 'Indonesia',
                },
                es: {
                    name: 'Español',
                    change: 'Español',
                },
                tr: {
                    name: 'Turco',
                    change: 'Turco',
                },
            },
            switchLanguageModal: {
                title: 'Cambiar idioma a {{localeId}}',
                description:
                    'Todo el contenido de la aplicación IguVerse cambiará a {{localeId}}. Puedes cambiarlo en cualquier momento',
            },
        },
        notificationsSettings: {
            title: 'Notificaciones',
            pushNotificationTitle: 'Notificaciones Push',
            emailNotificationTitle: 'Notificaciones por correo electrónico',
            notifications: {
                pushDailyReminder: 'Notificar un Recordatorio Diario',
                pushRewardEarned: 'Notificar Recompensa Obtenida',
                pushSocialTaskCompleted: 'Notificar Tarea Social Completada',
                pushPetLowHealth: 'Notificar Mascota Baja Salud',
                pushPetDead: 'Notificar Mascota ha Muerto',
                pushMysteryLikesGame: 'The Mystery Of Likes',
                emailPetDead: 'Notificar Mascota ha Muerto',
                emailSocialTaskCompleted: 'Notificar Tarea Social Completada',
            },
            saved: '¡Configuración de Notificaciones Guardada!',
        },
        socialAccountsSettings: {
            title: 'Redes Sociales',
            headerTitle: 'Conectar Redes',
            headerText:
                'Conecta con tu cuenta de redes sociales para poder completar las tareas sociales. Más información sobre los requisitos de la cuenta en nuestra Base de Conocimientos',
            headerInfo: 'Ver la Base de Conocimientos',
            alert: 'Después de conectar su cuenta, debe completar la tarea social para que la cuenta sea verificada',
            modal: {
                title: 'Verificación Completada',
                text: 'Has conectado correctamente tu cuenta social. Completa la tarea social para que la cuenta sea verificada',
                button: 'Navegar a Tareas',
            },
        },
        roles: { PLAYER: 'Jugador', ADMIN: 'Admin', MODERATOR: 'Moderador' },
        support: {
            success: {
                title: 'Mensaje enviado',
                text: 'Nos pondremos en contacto con usted en breve',
            },
            notSent: { text: 'Mensaje no enviado' },
            errorOpen: {
                text: 'Error al abrir el correo del cliente de la aplicación',
            },
        },
        accessibilitySettings: {
            title: 'Accesibilidad',
            shake: 'Enviar Opinión Agitando ',
            vibration: 'Respuesta con Vibración',
            saved: 'Ajustes de Accesibilidad guardados',
        },
        socialMediaSettings: {
            screenTitle: 'IguVerse Media',
            communities: {
                title: 'Comunidades Oficiales',
                text: 'Únase a nuestra increíble comunidad de amantes de las mascotas, obtenga ayuda y socialice',
                socials: { discord: 'Discord', telegram: 'Telegram' },
            },
            media: {
                title: 'Medios Oficiales',
                text: 'Siga nuestros canales en las redes sociales para recibir noticias y anuncios de última hora',
                socials: {
                    twitter: 'Twitter',
                    instagram: 'Instagram',
                    youtube: 'Youtube',
                    tiktok: 'TikTok',
                    website: 'Página web',
                    facebook: 'Facebook',
                },
            },
            telegram: {
                title: 'Comunidades en Telegram',
                main: 'Canal Oficial',
                en: 'Chat en inglés',
                uk: 'Chat ucraniano',
                ru: 'Chat ruso',
                cn: 'Chat chino',
                tr: 'Chat turco',
                id: 'Chat indonesio',
                kr: 'Chat coreano',
                jp: 'Chat japonés',
                ab: 'Chat en árabe',
                in: 'Chat indio',
                pp: 'Filipinas Chat',
                vt: 'Chat de Vietnam',
                bg: 'Chat de Bangladesh',
                pl: 'Chat polaco',
                es: 'Chat en español',
                fr: 'Chat francés',
                pt: 'Chat portugués',
            },
        },
        adminSendPushNotification: {
            title: 'Enviar Push Notificación',
            text: 'Crear una notificación push/emergente que se mostrará a todos los usuarios',
            button: 'Enviar',
            selectLanguage: {
                label: 'Idioma',
                placeHolder: 'Seleccionar idioma de notificación',
                modalTitle: 'Seleccionar idioma',
                button: 'Guardar',
                title: '{{amount}} Idioma seleccionado',
            },
            titleInput: {
                label: 'Título (menos de {{amount}} símbolos)',
                placeHolder: 'Nueva Actualización',
            },
            bodyInput: {
                label: 'Descripción (menos de {{amount}} símbolos)',
                placeHolder:
                    'Descubre nuestra nueva actualización con Cajas Misteriosas',
            },
            errors: { required: 'Este campo es obligatorio' },
        },
        adminReverification: {
            screenTitle: 'Reverificación',
            title: 'Enviar para reverificar',
            text: 'Seleccione una red social e introduzca a continuación la cuenta del usuario para enviarlo a moderación repetida',
            button: 'Enviar',
            labelSocial: 'Redes Sociales',
            labelInput: 'Enlace a la Cuenta',
            placeHolder: 'Introduzca el Enlace de la Cuenta',
            socialMediaModal: { title: 'Seleccionar redes sociales' },
            checkModal: {
                title: 'Comprobar detalles del perfil',
                text: 'Echa un vistazo a la cuenta social que aparece a continuación y comprueba si es la correcta. Esté atento, ya que esta acción no se puede deshacer',
                button1: 'Enviar para reverificación',
                button2: 'Cuenta incorrecta, Cancelar',
            },
            toastSuccess: 'Cuenta enviada para reverificación',
        },
        adminBlockUser: {
            screenTitle: 'Bloquear al Usuario',
            title: 'Introduzca la Dirección de la Cartera',
            text: 'Introduzca la dirección de la cartera vinculada a la cuenta que infringió las normas de IguVerse',
            button: 'Bloquear',
            modal: {
                title: '¿Bloquear usuario?',
                text: 'Asegúrate de que estás bloqueando al usuario correcto. Debes tener mucho cuidado con los usuarios que bloqueas. ¡Esta acción no se puede deshacer!',
                button1: 'Enviar',
                button2: 'Cancelar',
            },
            toastSuccess: 'El usuario ha sido bloqueado correctamente',
            toastError: 'No se encuentra al usuario',
            banReason: {
                screenTitle: 'Seleccione el motivo del bloqueo',
                label: 'Motivo del bloqueo',
                placeHolder: 'Seleccione el motivo del bloqueo',
            },
            banComment: {
                label: 'Comentario',
                placeHolder: 'Añada un comentario si es necesario',
            },
            error: {
                banComment: 'Debería añadir un comentario',
                banReason: 'Seleccione el motivo de la prohibición',
            },
        },
        adminMaintenanceMode: {
            screenTitle: 'Modo de Mantenimiento',
            on: {
                title: 'Activar el Modo de Mantenimiento',
                text: 'Puede poner la aplicación en modo de mantenimiento y los usuarios no podrán acceder a ella. Para ponerla a disposición de los usuarios, haga clic en Desactivar Modo de mantenimiento en la Configuración',
                button: 'Encender',
                modal: {
                    title: '¿Activar el Modo de Mantenimiento?',
                    text: 'Los usuarios no podrán acceder a la app si activas el modo de mantenimiento. Para que la app vuelva a estar disponible, haz clic en Desactivar Modo de Mantenimiento en los Ajustes',
                    button1: 'Encender',
                    button2: 'Cancelar',
                },
                toastSuccess: 'Modo Mantenimiento Activado',
            },
            off: {
                title: 'Desactivar el Modo de Mantenimiento',
                text: 'La aplicación está en modo de mantenimiento y los usuarios no pueden acceder a ella en este momento. Desactívala en cuanto terminen los trabajos técnicos haciendo clic en el botón de abajo. No olvides de confirmarlo',
                button: 'Apagar',
                modal: {
                    title: '¿Desactivar el Modo de Mantenimiento?',
                    text: 'Asegúrese de que el trabajo técnico está hecho y la aplicación funcionará correctamente. Para que la aplicación vuelva a estar disponible, haz clic en el siguiente botón',
                    button1: 'Apagar',
                    button2: 'Cancelar',
                },
                toastSuccess: 'Modo Mantenimiento Apagado',
            },
        },
        adminAssignWhiteList: {
            screenTitle: 'Asignar Lista Blanca',
            button: 'Asignar',
            title: 'Asignar lista blanca',
            text: 'Introduzca la dirección de la Cartera del usuario y seleccione el rango y la cantidad de NFT',
            rank: { label: 'Rango NFT', placeHolder: 'Seleccionar Rango' },
            quantity: { label: 'Cantidad' },
            modal: {
                screenTitle: 'Seleccionar Rango',
                title: '¿Asignar Lista Blanca?',
                text: 'Compruebe todo cuidadosamente: el Rango NFT y el número de NFTs, así como la dirección de la Cartera. Debes estar seguro al confirmar esta acción, ya que no se puede deshacer',
                button1: 'Asignar',
                button2: 'Cancelar',
            },
            toastSuccess: 'La lista blanca se ha asignado correctamente',
            error: {
                quantity: {
                    max: 'Cantidad máxima {{quantity}}',
                    min: 'Cantidad mínima {{quantity}}',
                    numbers: 'Sólo números',
                },
                rank: 'Debe seleccionarse el Rango',
            },
            toastError: 'No se encuentra el Usuario',
        },
        adminAssignRole: {
            screenTitle: 'Asignar rol',
            button: 'Asignar',
            title: 'Asignar rol',
            text: 'Introduzca la dirección del monedero del usuario y seleccione el rol a asignar',

            role: {
                label: 'Función',
                placeHolder: 'Seleccionar rol',
            },
            roleModal: {
                title: 'Seleccionar rol',
            },
            attentionModal: {
                title: 'Asignar rol?',
                text: 'Comprueba cuidadosamente todos los datos facilitados: la dirección del monedero y el rol. Asegúrese de que no comete ningún error. ¡Esta acción no se puede deshacer!',
                button1: 'Asignar',
                button2: 'Cancelar',
            },
            error: {
                role: 'Debe seleccionarse la función',
            },
            success: 'La función se ha asignado correctamente',
            toastError: 'No se encuentra el usuario',
            toastSuccess: 'Función asignada correctamente',
        },
        walletInput: {
            label: 'Dirección de la Cartera',
            placeHolder: 'Introduzca la dirección de la Cartera',
        },
        walletInputError: 'No es la dirección de la Cartera',
    },
    admin: {
        title: 'Admin',
        verify: {
            title: 'Verificar usuarios',
            subtitle: 'Verificar las redes sociales de los usuarios',
            text: 'Abrir una cuenta en una red social y facilitar el Pet ID para su verificación',
            emptyTitle: 'No hay más tareas',
            emptyText:
                'No hay tareas disponibles para verificar, vuelva más tarde',
            messages: {
                error: 'Pet ID incorrecto, inténtelo de nuevo',
                success: '¡Enhorabuena! Usuario verificado',
                notFound: 'Usuario rechazado',
                failed: 'Se ha producido un error, póngase en contacto con el administrador',
            },
            modalPetIdNotFound: {
                title: '¿No se encuentra el Pet ID?',
                text: 'Por favor, examine cuidadosamente el Pet ID y si no puede verificarla, seleccione una de las siguientes razones para el fallo de la verificación',
                reasons: {
                    notEnoughFollowers: {
                        title: 'No hay suficientes seguidores',
                        text: 'Su cuenta no es lo suficientemente activa en las redes sociales, no está abierta y/o tiene pocos seguidores',
                    },
                    petIdNotFound: {
                        title: 'No se ha encontrado el Pet ID',
                        text: 'El Pet ID no es visible en la foto o no se ha compartido',
                    },
                    petIdIncorrectPosition: {
                        title: 'Posición del Pet ID incorrecta',
                        text: 'Pet ID está recortado o mal colocado, de modo que no es posible ver el código',
                    },
                    userNotFound: {
                        title: 'No se pudo encontrar al Usuario',
                        text: 'La cuenta con el mensaje se ha eliminado o vinculado incorrectamente y no se puede comprobar',
                    },
                },
                button1: 'Sí, Confirmar',
            },
            label: 'Pet ID',
            placeHolder: 'Introduzca el Pet ID',
            buttonVerify: 'Verificar',
            buttonNotFound: 'No se ha encontrado el Pet ID',
            loadingVerifyUser: 'Comprobando..',
            regexError: 'Sólo se admiten dígitos y caracteres de la A a la Z',
        },
    },
    socialMediaConnect: {
        addSocialAccount: 'Añadir Cuenta de Red Social',
        selectAccountToShare: 'Seleccione la cuenta que desea compartir',
        select: 'Seleccionar',
        connect: 'Conectar',
        disconnect: 'Desconectar',
        unavailable: 'Actualmente no disponible',
        status: {
            moderating:
                'Tu cuenta ha sido añadida y se comprobará una vez que comparte el Pet ID para completar la tarea social',
            success:
                'La cuenta ha sido verificada correctamente por nuestros moderadores. Ahora puedes utilizarla para completar la tarea Socializar para ganar',
            reject: 'La cuenta no ha sido aprobada por nuestros moderadores. Por favor, conecte la Red que está en línea con nuestras reglas',
        },
        modalTerms: {
            start: 'Al conectar mi Red Social acepto ',
            and: ' y ',
            privacyPolicy: 'Política de Privacidad',
            termOfUse: 'Condiciones Generales',
        },
        connectTiktokModal: {
            title: 'Conectar cuenta TikTok',
            label: 'Nombre de usuario',
            placeHolder: 'Introduzca su nombre de usuario TikTok',
            button: 'Conectar',
            errors: {
                notExist:
                    'Esta cuenta no existe. Por favor, introduce un nombre de usuario TikTok válido',
                somethingWrong: 'Algo ha ido mal, por favor inténtelo de nuevo',
                likeFollowers:
                    'No hay suficiente actividad en su cuenta. Sólo se puede conectar la cuenta real',
                cannotLoad:
                    'No se puede cargar la cuenta de usuario. Vuelva a intentarlo',
                alreadyLinked:
                    'El nombre de usuario proporcionado ya está siendo utilizado por otro usuario',
                notLinked: 'La cuenta ya está desvinculada',
            },
        },
        socialPreview: {
            checkProfile: 'Compruebe tu perfil',
            takeALook:
                'Echa un vistazo a la cuenta de redes sociales a continuación y\n' +
                '            comprueba si esta cuenta es la tuya',
            view: 'Ver',
        },
        connectInstagramModal: {
            title: 'Conectar cuenta de Instagram',
            label: 'Nombre de usuario',
            placeHolder: 'Introduzca el enlace de la cuenta',
            addAccount: 'Soy yo, Añadir cuenta',
            cancel: 'No soy yo, Cancelar',
            button: 'Conectar',
            errors: {
                somethingWrong: 'Algo ha ido mal, por favor inténtelo de nuevo',
                alreadyLinked:
                    'El nombre de usuario proporcionado ya está siendo utilizado por otro usuario',
            },
            viaInstagram: 'o Iniciar sesión a través de Instagram',
        },
        connectTwitterModal: {
            title: 'Conectar cuenta de Twitter',
            label: 'Nombre de usuario',
            placeHolder: 'Introduzca el nombre de usuario de Twitter',
            button: 'Conectar',
            errors: {
                notExist:
                    'Esta cuenta no existe. Introduce un nombre de usuario de Twitter válido',
                alreadyLinked:
                    'El nombre de usuario proporcionado ya está siendo utilizado por otro usuario',
                somethingWrong: 'Algo ha ido mal, por favor inténtelo de nuevo',
            },
        },
        connectFacebookModal: {
            title: 'Conectar la cuenta de Facebook',
            label: 'Nombre de usuario',
            placeHolder: 'Introduce el nombre de usuario de Facebook',
            button: 'Conectar',
            errors: {
                notExist:
                    'Esta cuenta no existe. Introduce un nombre de usuario de Facebook válido',
                alreadyLinked:
                    'El nombre de usuario proporcionado ya está siendo utilizado por otro usuario',
                somethingWrong: 'Algo ha ido mal, por favor inténtelo de nuevo',
            },
            via: 'o conéctese a través de Facebook',
        },
        terms: {
            instagram: {
                one: 'Perfil público',
                two: 'Cuenta activa con al menos 100 seguidores',
                three: 'Al menos 5 mensajes con más de 3 meses de antigüedad',
            },
            tikTok: {
                one: 'Al menos 500 seguidores',
                two: 'Cuenta activa con al menos 5 vídeos de más de 3 meses de antigüedad',
                three: 'Al menos 500 "me gusta" en la cuenta',
            },
            twitter: {
                one: 'Perfil público',
                two: 'Cuenta activa con al menos 500 seguidores',
                three: 'Al menos 5 mensajes con más de 3 meses de antigüedad',
            },
            facebook: {
                one: 'Perfil público',
                two: 'Cuenta activa con al menos 100 seguidores',
                three: 'Al menos 5 mensajes con más de 3 meses de antigüedad',
                four: 'Las historias deben ser públicas',
            },
        },
        errors: {
            duplicate: {
                title: 'Tu {{social}} ya está conectado a otra cuenta',
                text: 'Tu perfil en las redes sociales está conectado a otra cuenta. Desconéctala primero e inténtalo de nuevo',
                button: 'Cerrar',
            },
            disconnect: {
                title: '¿Desconectar cuenta?',
                text: 'Podrás utilizar tu nueva cuenta para completar la tarea social, una vez que comience el nuevo día de juego',
                button1: 'Sí, Desconectar',
                button2: 'No, quédatelo',
            },
            userNameError:
                'Símbolos prohibidos. Sólo se permiten caracteres latinos, dígitos, puntos y guiones bajos',
        },
        success: {
            linkInstagram: 'Instagram conectado correctamente',
            unLinkInstagram: 'Instagram desconectado',
            linkTiktok: 'TikTok conectado correctamente',
            unLinkTiktok: 'TikTok desconectado',
            linkTwitter: 'Twitter conectado correctamente',
            unLinkTwitter: 'Twitter desconectado',
            linkFacebook: 'Facebook conectado correctamente',
            unLinkFacebook: 'Facebook desconectado',
        },
    },
    playTasksHistory: {
        title: 'Historial de Tareas',
        info: 'Aquí puedes ver el historial de tus tareas y tu progreso',
        historyCard: {
            SocialTask: 'Tarea Social',
            VerificationTask: 'Buscar Tarea',
            MoveTask: 'Tarea de Caminar',
            PlayTask: 'Tarea de Juego',
        },
        emptyState: {
            title: 'Aún no hay tareas',
            text: 'Aún no has completado ninguna tarea diaria. Pero no hay problema, hagámoslo ahora mismo',
            button: 'Empezar a Jugar',
        },
        historyTaskDetails: {
            title: 'Detalles de la Tarea',
            text: 'La energía obtenida se convertirá en Tokens de recompensa en tu Cartera de recompensas. Ver más detalles sobre las tareas a continuación',
            collectedEnergy:
                '{{earnedEnergy}} / {{maxEnergy}} Energía Recopilada',
            viewRewardWaller: 'Ver en la Cartera de recompensas',
            details: {
                type: 'Tipo:',
                type_SocialTask: 'Tarea Social',
                type_VerificationTask: 'Buscar Tarea',
                type_MoveTask: 'Tarea de Caminar',
                type_PlayTask: 'Tarea de Juego',
                petExp: 'Experiencia con Mascotas:',
                exp: '{{exp}} XP',
                date: 'Data:',
            },
        },
    },
    successTaskEnergyBlock: {
        text: 'Energía',
        collectedEnergy: '{{earnedEnergy}} / {{maxEnergy}} Energía Racopilada',
    },
    successTaskPetsExp: {
        text: 'XP acumulada',
        collectedExp: '{{collectedExp}} XP',
    },
    checkout: {
        title: 'Verificar Transacción',
        text: 'Vuelva a comprobar la información y confirme tu transacción',
        confirm: 'Confirmar y Comprar',
        try: 'Inténtelo de nuevo',
        cancel: 'Cancelar',
        purchasingFrom: 'Forma de pago',
        available: 'Saldo',
        deposit: 'Depósito',
        wallet: '{{coin}} Cartera',
        loadingPurchasing:
            'Finalizando transacción, por favor no cierre la aplicación..',
        free: 'Free',
        whiteList: 'Lista blanca (1)',
        explorerUrl: 'Ver en BscScan',
        fields: {
            transaction: 'Transacción',
            value: 'Valor',
            amount: 'Importe',
            totalSummary: 'Resumen',
            from: 'Desde (Cartera)',
            to: 'A la dirección',
            fee: 'Comissión Blockchain',
            modalTitle: 'Confirmar Cobro',
            toWallet: 'Para (Cartera)',
            gamingWallet: 'Cartera de juegos',
            mainWallet: 'Cartera principal',
            confirm: 'Confirme',
            commissionFee: 'De comisión',
            nft: 'NFT',
            nftWallet: 'Cartera NFT',
            nftMarketplace: 'Mercado NFT',
        },
        errors: {
            notEnoughCoinFunds:
                'No hay fondos suficientes. Deposite fondos en tu Cartera',
            notEnoughCoinFundsMulti:
                'No hay fondos suficientes. Elige otra opción de pago o ingresa fondos en tu Cartera',
            bnbNotEnough:
                'No hay suficientes BNB en tu saldo para cubrir una comisión de gas. Por favor, deposite BNB en tu Cartera',
            notEnoughBalanceFunds: 'Fondos Insuficientes',
            notEnoughBalanceFundsMulti:
                'No hay fondos suficientes. Elija otra opción de pago',
            insufficientVirtualBalance:
                'Fondos insuficientes en tu saldo virtual',
        },
        purchasingFromCoins: {
            coins: 'Tokens',
            virtual: 'E-Wallet',
            inapp: { ios: 'Apple', android: 'Google Pay' },
        },
        storePurchase: {
            loadings: {
                PURCHASE:
                    'Completando el pago, por favor no cierre la aplicación..',
                FINALIZE:
                    'Finalizando transacción, por favor no cierre la aplicación..',
            },
            button: 'Vale',
            storePurchaseError: {
                PURCHASE: {
                    title: 'Algo salió mal',
                    message:
                        'Algo ha ido mal durante el proceso de compra. Por favor, inténtelo de nuevo\n' +
                        'Código de error: {{code}}',
                },
                FINALIZE: {
                    title: 'Algo salió mal',
                    message:
                        'Algo ha ido mal al finalizar la transacción. Por favor, inténtelo de nuevo',
                },
            },
        },
    },
    charity: {
        title: 'Caridad',
        description:
            'Los usuarios de IguVerse realizan donaciones de dinero de sus ingresos diarios a una organización benéfica preseleccionada',
        current: 'Mi Elección',
        dailyDonation: 'Donaciones Diarias de sus Recompensas',
        howItWorks: '¿Cómo Funciona?',
        selectedOrganization: 'Organización Seleccionada',
        edit: 'Editar',
        organizations: 'Organizaciones',
        viewAll: 'Ver todos',
        donated: 'Donado',
        buttonSave: 'Guardar',
        loadingPercentage: 'Procesando..',
        saveSuccess: 'Se ha modificado el porcentaje de donaciones diarias',
        organizationsTitle: 'Todas las Organizaciones',
        infoRows: {
            address: 'Dirección',
            website: 'Página Web',
            email: 'Correo electrónico',
            instagram: 'Instagram',
            twitter: 'Twitter',
        },
        readMore: 'Seguir leyendo',
        hide: 'Ocultar',
        donations: 'Donaciones',
        totalSummary: 'Resumen',
        time: {
            minuteAgo: 'hace un minuto',
            minutesAgo: 'hace minutos',
            hourAgo: 'hace una hora',
            hoursAgo: 'hace horas',
            dayAgo: 'hace un día',
            daysAgo: 'días atrás',
        },
        payout: 'Pago caritativo',
        noDonations: 'Aún no hay donaciones',
        allDonations: 'Todas las donaciones',
        modals: {
            confirmPercentage: {
                title: 'Confirme tu Acción',
                text: 'El porcentaje de donación afectará a tus ganancias y las transferirá directamente a la organización benéfica, ¿estás seguro de que quieres cambiar tu porcentaje de donación?',
            },
        },
        editOrganization: 'Editar Organización',
        editOrganizationNotChosen:
            'Debe seleccionar como mínimo una organización para realizar donaciones',
        loadingOrganizationChange: 'Procesando..',
        changeOrganizationSuccess: 'Organización Benéfica Salvada',
        organizationDetails: 'Detalles de la Organización',
        selectDescription: 'Seleccione una Organización de la lista siguiente',
        chooseOrganization: 'Elija Organización',
    },
    Marketplace: {
        title: 'Tienda',
        text: 'Puedes comprar o vender mascotas a otros usuarios en el mercado',
        description: 'Próximamente',
    },
    Feed: {
        title: 'Alimentación Social',
        text: 'Puedes ver todas las mascotas disponibles e interactuar con ellas',
        description: 'Próximamente',
    },
    Leaderboard: {
        [ROUTES.LEADERBOARD_DAILY_TASKS]: {
            title: 'Líderes de tareas',
            text: 'Sigue el progreso de otros usuarios y compite con ellos realizando tareas diarias',
            emptyList: {
                title: 'Aún no hay usuarios en Líderes de tareas',
                text: 'Es triste decirlo, pero ningún usuario ha completado ninguna tarea todavía. Pero no se preocupe que se solucionará rápidamente',
            },
            energy: 'Energía Recogida',
            task: 'Tareas Realizadas',
        },
        [ROUTES.LEADERBOARD_PVP_GAMES]: {
            title: 'Líderes PvP',
            text: 'Siga el progreso de otros usuarios y compita jugando y ganando juegos PvP',
            emptyList: {
                title: 'Aún no hay usuarios en Líderes PvP',
                text: 'Es triste decirlo, pero ningún usuario ha completado ninguna juegos todavía. Pero no se preocupe que se solucionará rápidamente',
            },
            turnover: 'Facturación IGU',
            totalTurnover: 'Facturación IGU total',
            pnl: 'PNL (ganancia/derrota)',
            games: 'Juegos PVP jugados',
        },
        emptyScreen: {
            title: '¡Uy!',
            text: 'Algo va mal. Pero no te preocupes, se arreglará rápidamente. Intenta deslizar.',
        },
    },

    playCollectedExperience: {
        screenTitle: 'Experiencia Acumulada',
        title: 'Experiencia de las Mascotas',
        text: 'Después de completar la tarea de sus mascotas, recoge nuevos XP para avanzar de nivel',
    },
    playSuccessScreen: {
        button: 'Ver más Tareas',
        button2: 'Volver a la Página Principal',
        emptyStates: {
            VERIFY: {
                title: 'Buscar Tarea Completada',
                text: '¡Felicidades! ¡Has completado la tarea! Buscar pendientes. Vuelve mañana para más',
                failTitle: 'Tarea de búsqueda fallida',
                failText:
                    '¡Has fallado! Encuentra la tarea diaria pendiente. Vuelve mañana a por más',
            },
            MOVE: {
                title: 'Tarea de Caminar Completada',
                text: '¡Felicidades! Has recorrido toda la distancia para completar la tarea. Vuelve mañana para más',
                failTitle: 'Tarea de Caminar Fallida',
                failText:
                    'Has fallado la tarea de Caminar por hoy. Vuelve mañana e inténtalo mejor',
            },
            SOCIAL: {
                title: 'Tarea Compartida Completada',
                text: '¡Felicidades! Has compartido una foto y ha pasado la verificación. Vuelve mañana para ver más',
            },
            PLAY: {
                title: 'Juego Completado',
                text: '¡Felicidades! Has completado el juego por hoy. Vuelve mañana a por más',
                failTitle: 'Juego Fallido',
                failText:
                    'Desgraciadamente has fallado el juego. Inténtalo mejor la próxima vez',
            },
        },
    },
    general: {
        howItWorks: '¿Cómo Funciona?',
        comingSoon: 'Próximamente',
        comingSoonDesc: 'Esta función aún no está lista.',
        copiedToClipboard: 'Copiado en el Portapapeles',
        createPet: 'Crear una Mascota',
        next: 'Siguiente',
        or: 'o',
        ok: 'OK',
        loading: 'Cargando..',
        loadMore: 'Más información',
        errors: {
            unknown: {
                title: 'Error desconocido',
                message: 'Por favor, inténtelo de nuevo',
            },
            error: { title: 'Error' },
            networkRequestFailed: {
                title: 'Error de red',
                message: 'Error en la solicitud de red. Vuelva a intentarlo',
            },
            TASK_WRONG_STATE: {
                title: 'Error',
                message: 'La tarea ha caducado, inténtelo de nuevo',
            },
            TASK_CREATE_FORBIDDEN: {
                title: 'Error',
                message: 'La tarea ha caducado, inténtelo de nuevo',
            },
            UNPREDICTABLE_GAS_LIMIT: {
                title: 'Asuntos relacionados con la Cartera',
                message:
                    'No se pueden estimar los gastos de comisiñon de gas, la transacción no se realizará. Asegúrese de que tiene fondos suficientes y BNB para cubrir una comisión de gas y luego inténtelo de nuevo',
            },
            INSUFFICIENT_FUNDS: {
                title: 'Fondos Insuficientes',
                message:
                    'Asegúrate de tener suficientes fondos y BNB para cubrir la comisión de transacción. Deposita cripto en tu Cartera e inténtalo de nuevo',
            },
            fileIsTooBig: {
                title: 'El archivo es demasiado grande',
                text: 'El archivo de imagen debe ser inferior a {{size}} MB',
            },
            cantOpenUrl: {
                text: 'Tu dispositivo no puede abrir la URL {{url}}. Copie la URL y sígala manualmente',
            },
            gameAlreadyStarted: {
                text1: 'El juego ya comenzó',
                text2: 'Por favor, elige otro juego',
            },
            gameBanned: {
                text1: 'Tienes prohibido jugar este juego',
                text2: 'Espere hasta nuevo aviso',
            },
            wrongGameStatus: {
                text: 'Estado del juego incorrecto',
            },
            emptyErrorScreen: {
                title: '¡Uy!',
                text: 'Algo va mal. Pero no te preocupes, se arreglará rápidamente',
            },
            ops: {
                text: '¡Uy!',
                text2: 'Algo va mal :(',
            },
        },
        success: { title: 'Éxito' },
        socialLoading: 'Enlace ..',
        cancel: 'Cancelar',
        back: 'Volver',
        current: 'Actual',
        knowledgeBaseButton: 'Más información en la base de conocimientos',
        timerTitle: 'Tiempo Restante',
        hint: '{{hint}}/{{maxHints}} Consejos',
        continue: 'Continúe en',
        skip: 'Saltar',
        BUTTONS: {
            mintNewNft: 'Nuevo NFT',
            continue: 'Continúe en',
            continueLater: 'Continuar más tarde',
            mintNft: 'Mintear NFT',
            select: 'Seleccione',
            startPlaying: 'Empezar a jugar',
            start: 'Inicio',
            learnMore: 'Más información',
            playPvpGames: 'Jugar a juegos PVP',
            goToWallet: 'Ir a la cartera',
            createNewOrder: 'Crear nuevo pedido',
            apply: 'Aplicar',
            clear: 'Borrar',
            viewProfile: 'Ver Perfil',
            buyForWithAmount: 'Comprar por {{amount}}',
            cancel: 'Cancelar',
            delistNft: 'Eliminar el NFT',
            delist: 'Eliminar',
            viewMarketplace: 'Ver Mercado',
            getStarted: 'Comenzar',
            reloadApp: 'Recargar Aplicación',
            createNewGame: 'Crear nueva partida',
            exploreMoreGames: 'Explorar más juegos',
            viewGamesHistory: 'Ver el historial de juegos',
            viewStatistics: 'Ver estadísticas',
            tryAgain: 'Volver a intentarlo',
            createGame: 'Crear juego',
            topUpBalance: 'Recargar saldo',
            continueToNextStep: 'Continuar con el siguiente paso',
            continueShopping: 'Seguir comprando',
            enableNow: 'Habilitado ahora',
            maybeLater: 'Quizas mas tarde',
            backToSettings: 'Volver a Configuración',
            turnOff: 'Apagar',
            purchaseFor: 'Compra por {{amount}}',
            purchase: 'Compra',
            viewAll: 'Ver todos',
            view: 'Ver',
            purchaseMore: 'Comprar Más',
            viewDetails: 'Ver Detalles',
            readMore: 'Leer Más',
            hide: 'Ocultar',
            viewChart: 'Ver gráfico',
        },
        KEYS: {
            ranks: 'Clasificación',
            price: 'Precio',
            chance: 'Azar',
            rank: 'Rango',
            sortedBy: 'Ordenado por',
            typeOfNft: 'Tipo de NFT',
            totalSummary: 'Resumen Total',
            totalSuccessfulOrders: 'Total de pedidos realizados con éxito',
            totalPurchasesSummary: 'Resumen total de compras',
            NFTs: 'NFTs',
            profile: 'Perfil',
            details: 'Detalles',
            numberAndLevel: '{{level}} Nivel',
            numberAndHealth: '{{health}} Health',
            deadByAge: 'La mascota era vieja y murió',
            numberAndDaysAge: '{{days}} Días Edad',
            yourNFT: 'Tu NFT',
            vs: 'VS',
            opponentsNFT: 'NFT del adversario',
            yourPoints: 'Tus Puntos',
            opponentsPoints: 'Puntos del oponente',
            type: 'Escriba',
            gameSettings: 'Configuraciones de juego',
            difficulty: 'Dificultad',
            mode: 'Modo',
            livesCount: 'Conteo de vida',
            yourAccount: 'Tu Cuenta',
            leaderboardPlace: 'Lugar en la Clasificación',
            timeLeft: 'Tiempo restante',
            ticketsAmount: 'Cantidad de entradas',
            tickets: 'Entradas',
            winner: 'Ganador',
            prizes: 'Premios',
            won: 'Ganado',
            hash: 'Hash',
            date: 'Fecha',
            roundId: 'ID redondo',
            chainResults: 'Resultados',
            globalSeed: 'Semilla Global',
            gamesHistory: 'Historial de juegos',
            users: 'Usuarios',
        },
        FILTERS: {
            byDate: {
                Day: 'Hoy',
                Week: 'Últimos 7 días',
                Month: 'Últimos 30 días',
            },
        },
        ALERTS: {
            notEnoughCoinsOnGamingWallet:
                'No tienes suficientes fichas en tu monedero para unirte al juego. Recarga tu cuenta para empezar a jugar',
        },
        MERGED: {
            selectText: 'Seleccionar {{text}}',
        },
        DECLINATION: {
            Ticket: {
                one: 'Entrada',
                two: 'Entradas',
                five: 'Entradas',
            },
        },
    },
    modal: {
        mintPetLeave: {
            title: '¿Quieres Irte?',
            text: 'Ya casi has terminado de crear tu mascota. ¡No te rindas!',
            keep: 'Acabar con Mascota',
            leave: 'Sí, irme',
        },
        ModalFreeRank: {
            title: 'Se está perdiendo una gran bonificación',
            text: '¿Estás seguro de que quieres perderte la bonificación de {{amount}} IGUP (${{dollarValue}}) por mintear los rangos más altos posibles?',
            highest: 'Conseguir mi Bonus',
            proceed: 'Proceder sin Bonus',
        },
        askForPermissions: 'Pedir Permisos',
        goToSettings: 'Ir a Ajustes',
        try: 'Inténtelo de Nuevo',
        cancel: 'Cancelar',
        deletePhoto: '¿Borrar NFT Foto?',
        deletePhotoInfo: '¿Estás seguro de que quieres borrar tu foto?',
        yesDelete: 'Sí, Borrar',
        noCancel: 'No, Cancelar',
        changeRank: '¿Quieres cambiar de puesto?',
        changeRankInfo:
            'Se le dirigirá al primer paso del proceso de mintear de moneda',
        changeRankGo: 'Cambio Rango',
        upgradeRank: {
            title: 'Pasar al rango "{{slug}}"',
            text: 'Algunas funciones se desbloquean con rangos más altos. Sube de rango para acceder a esta función',
            upgradeToRank: 'Subir de Rango',
        },
        savingName:
            'Guardar nombre, lleva algún tiempo. Por favor, no cierre la aplicación',
        generatingNFT:
            'Haciendo algo de magia. Por lo general, se tarda unos pocos minutos ..',
        generateNewNFT: {
            title: '¿Volver al paso anterior?',
            text: 'Será devuelto y perderá Tu progreso actual. Tu mascota es única, no vamos a ser capaces de crear exactamente el mismo',
            yesGenerate: 'Sí, llévarme de vuelta',
            noKeep: 'No, quedarme aquí',
        },
        askForCameraPermissions: {
            title: 'Sin permisos para la cámara',
            text: 'Tienes que conceder permisos a la cámara para poder utilizar esta función',
        },
        askForLocationPermissions: {
            title: 'Sin permisos para la ubicación',
            text: 'Tienes que conceder permisos de localización para poder utilizar esta función',
        },
        askForCameraRollPermissions: {
            title: 'Sin permisos para Camera Roll',
            text: 'Tienes que conceder permisos a Camera Roll para poder utilizar esta función',
        },
        askForLocationPermissionsWeb: {
            title: 'Sin permisos para la ubicación',
            text: 'Tienes que conceder permisos de localización para poder utilizar esta función',
            additionalText:
                '. Ir a la configuración y activar los permisos para la ubicación',
            button: 'Cerrar',
        },
        nftPreview: {
            title: 'Vista previa de NFT',
            text: 'Esta es una vista previa de tu mascota',
        },
        confirmation: {
            title: '¿Está seguro?',
            text: 'Por favor, confirme tu acción para proceder',
            yes: 'Sí, Confirmar',
            cancel: 'Cancelar',
        },
        modalChangeLanguage: {
            screenTitle: 'Cambiar idioma',
            button: 'Cambia',
        },
    },
    navigationBar: {
        wallet: {
            MAIN: 'Principal',
            NFT: 'NFT',
            REWARDS: 'Recompensas',
            GAMING: 'Juego',
        },
        tasks: { active: 'Activo', history: 'Historia' },
        admin: { verify: 'Verificar', dashboard: 'Cuadro de Mandos' },
        referrals: { invites: 'Invitar', all: 'Mis referencias' },
        collections: { collection: 'Colección', mystery: 'Cajas Misteriosas' },
        tooltip:
            'Esta es la pestaña de la cartera. Ve aquí para ver tu saldo y tus recompensas. En la pestaña, puedes cobrar, depositar, reclamar e intercambiar tokens',
    },
    AppState: {
        GameMaintenanceState: {
            title: 'Mantenimiento del juego',
            text: 'IguVerse Tareas está en mantenimiento y actualmente no está disponible. Disculpe las molestias y vuelva pronto',
            button: 'Lo tengo',
        },
        FullMaintenanceState: {
            title: 'La aplicación está en mantenimiento',
            text: 'IguVerse App está en mantenimiento y actualmente no está disponible. Disculpe las molestias y vuelva pronto. Mantente en contacto en nuestras redes sociales',
        },
        GlobalErrorState: {
            title: 'Mantenimiento no programado',
            text: 'IguVerse App está en desarrollo y actualmente tenemos mantenimiento no planificado. Disculpe las molestias y vuelva pronto',
            button: 'Reintentar',
        },
        UpdateRequiredState: {
            title: 'Actualización disponible',
            text: 'Esta versión de la aplicación está obsoleta, por favor actualízala desde la {{store}} Store para seguir utilizándola',
            button: 'Actualizar',
            cancel: 'Ahora no',
            error: 'No se puede abrir el enlace, abra {{store}} "Store"" manualmente y descargue la versión más reciente',
        },
        UpdateRequiredStateWeb: {
            title: 'Actualización de la App..',
            text: 'La aplicación se encuentra en pleno proceso de actualización, inténtelo de nuevo en unos minutos',
            button: 'Inténtalo de nuevo',
        },
        NoNetworkConnectionState: {
            title: 'Sin conexión',
            text: 'Parece que tienes problemas con la conexión a Internet. Internet es necesario para que la aplicación funcione correctamente',
            button: 'Lo tengo',
            reconnected: '¡Reconectados!',
            reconnecting: 'Conexión perdida. Reconectando..',
        },
    },
    ranks: {
        rankLongTitle: '{{rank}} Rango',
        level: '{{level}} LVL',
        upgradeRankButton: 'Subir de Rango',
        upgradeText:
            'Has alcanzado todos los niveles de tu rango actual. Es hora de subir al rango {{rank}} y mejorar tu rendimiento',
        lockedText:
            '{{rank}} El rango no está disponible para mintear. Puedes conseguirlo subiendo de nivel y progresando en el juego',
        perDay: 'Diario',
        dailyUnlock: 'Desbloqueo diario',
        foodConsumption: 'Consumo diario',
        maxAge: 'Max. Edad',
        days: 'Días',
        list: {
            free: {
                title: 'Free',
                infoText:
                    'El Free Rank te dará la oportunidad de explorar la aplicación y sus funciones. Sin embargo, no puede reclamar o retirar recompensas antes de comprar o subir de rango su NFT',
            },
            starter: { title: 'Starter' },
            common: { title: 'Common' },
            uncommon: { title: 'Uncommon' },
            unusual: { title: 'Unusual' },
            rare: { title: 'Rare' },
            mystical: { title: 'Mystical' },
            legendary: { title: 'Legendary' },
            epic: { title: 'Epic' },
            exotic: { title: 'Exotic' },
            royal: { title: 'Royal' },
            diamond: { title: 'Diamond' },
        },
        ranksDetailedInfoScreen: { button: 'Mintear NFT', current: 'Actual' },
        rankDetailedInfo: {
            reward: {
                title: 'Recompensa Diaria ≈ {{reward}} ≈ {{usd}}',
                text: 'Recompensa diaria estimada en Tokens si se completan todas las Tareas Diarias',
                warning:
                    'El valor es sólo una estimación de la capacidad de ganancia de la mascota y puede variar',
                warningFree:
                    'El rango Free tiene una probabilidad aleatoria de ganar recompensas en el juego. No hay recompensas garantizadas para el rango Free',
            },
            rate: {
                title: 'Porcentaje de Desbloqueo Diario ≈ {{reward}} ({{rate}}) ≈ {{usd}}',
                text: 'Puede transferir el {{percent}}% de sus recompensas VIGUP disponibles a su billetera principal. Una vez reclamado, el token puede intercambiarse, enviarse a una billetera diferente o retirarse',
                alert: 'El resto de tokens VIGUP están pendientes y se almacenarán en la Cartera bloqueada',
            },
            consumption: {
                title: 'Consumo de Alimentos = {{consumption}}',
                text: 'Tu mascota consume Tokens cada día. Si la mascota no se alimenta a tiempo, pierde salud y puede morir',
            },
            age: {
                title: 'Edad Máxima = {{maxAge}} días',
                text: 'Una vez que tu NFT llega a esta edad, morirá y tendrá que ser restaurado',
                alert: 'Una subida de rango restablecerá la edad de tu NFT a 0, y la mascota virtual mejorada vivirá según el límite de edad del nuevo rango. Después de restaurar el NFT, empezarás desde el Nivel 1',
            },
        },
        modalWhatIsRank: {
            title: '¿Qué es el Rango?',
            text: 'El Rango afecta a la capacidad de ganancia de tus mascotas y a otras características importantes como la Tasa Diaria de Desbloqueo y la Tasa de Consumo de Mascotas. A mayor rango, mejores características',
            buttonAvailable: 'Ver Rangos Disponibles',
            buttonAll: 'Ver Todos los Rangos',
        },
        checkoutUpgradeRank: {
            title: 'Subir de Rango',
            text: 'Cuanto mayor sea el rango, más recompensas obtendrá tu mascota',
            upgradeTo: 'Subir a',
            transaction:
                'Ascenso de rango a {{rank}} Rango para "{{name}}" NFT',
        },
        successUpgradeRank: {
            title: 'Subida de Rango',
            text: 'El Rango de NFT ha subido con éxito. Juega a las tareas diarias y gana aún más recompensas',
            backToPet: 'Ver Mascota',
        },
    },
    localNotifications: {
        moveToEarnFinished: {
            title: 'Finalizada la Tarea de Caminar',
            message:
                'Abre la aplicación y comprueba cuánta energía has recogido',
        },
        noPets: {
            title: 'Date prisa para conseguir tu mascota',
            message:
                'Consigue tu primera mascota y comienza tu increíble viaje en IguVerse',
        },
    },
    monthPicker: {
        month1: 'Enero',
        month2: 'Febrero',
        month3: 'Marzo',
        month4: 'Abril',
        month5: 'Mayo',
        month6: 'Junio',
        month7: 'Julio',
        month8: 'Agosto',
        month9: 'Septiembre',
        month10: 'Octubre',
        month11: 'Noviembre',
        month12: 'Diciembre',
        selectMonth: 'Seleccionar',
    },
    staking: {
        stakeLoading: 'Activando el impulso, no cierre la aplicación...',
        unStakeLoading: 'Eliminando el impulso, no cierre la aplicación...',
        general: {
            dailyBoost: 'Impulso diario',
            ended: 'Terminado en',
            summary: 'Total',
            days: '{{days}} Días',
            current: 'Impulso actual',
        },
        plans: {
            title: 'Detalles de opciones',
            text: 'Cada Opción de impulso tiene determinado el período de bloqueo y el bonus',
            days: ' Días',
            boost: 'Aumenta hasta un {{boost}}',
        },
        welcomeScreen: {
            title: 'Impulso',
            headerTitleStart: 'Gana ',
            headerTitleCenter: 'Hasta el {{number}}%',
            headerTitleEnd: ' con Impulso',
            headerText:
                'Puedes impulsar tus recompensas en el juego bloqueando tus tokens por un cierto período de tiempo',
            stake: {
                title: 'Opciones de impulso',
                text: 'Realiza el invierta en con sus tokens IGU e IGUP para obtener un aumento de recompensa o interés',
            },
            lock: {
                title: 'Período de bloqueo',
                text: 'Tus tokens se bloquearán por un período de tiempo especificado en la opción',
            },
            calculation: {
                title: 'Cálculo de Boost',
                text: 'El impulso se recalcula cada día dependiendo de tus recompensas diarias',
                alert: 'Si tus recompensas han cambiado, el aumento también cambiará. Siempre podrás ver el aumento actual',
            },
            button: 'Activar impulso',
        },
        optionsScreen: {
            toastAlready: 'La opción de impulso ya está activa',
            button: 'Continuar',
            screenTitle: 'Opción de impulso',
            title: 'Seleccionar opción de impulso',
            text: 'Elige una opción de impulso para tus tokens. Puedes usar varias opciones de impulso al mismo tiempo',
            IGUP: {
                title: 'Impulsar con IGUP',
                text: 'Bloquea tu IGUP durante un periodo de tiempo determinado y recibe un aumento en tus recompensas diarias',
            },
        },
        plansScreen: {
            button: 'Continuar',
            selectPlan: 'Seleccionar opción',
            title: 'Seleccionar opción de impulso',
            headerTitle: 'Seleccionar opción',
            headerText:
                'La cantidad que elijas quedará bloqueada dentro del smart contract hasta el final del periodo. Solo se puede realizar un opción de impulso al mismo tiempo',
            headerInfoText: '¿Qué plan elegir?',
            lock: {
                title: 'Periodo de bloqueo = {{days}} días',
                description:
                    'El periodo de bloqueo es el periodo de tiempo en el que tus Tokens estarán bloqueadas y la bonificación estará activa',
            },
            boost: {
                title: 'Boost = ~{{boost}} %',
                description:
                    'Recompensa del Boost es un modificador que aumenta tus recompensas en el juego en un determinado porcentaje',
            },
            calculation: {
                title: 'Boost = ~{{boost}} %',
                description:
                    'El impulso se recalcula cada día en función de tus recompensas',
                alert: 'Si tus recompensas han cambiado, el aumento también cambiará. Siempre podrás ver el aumento actual',
            },
        },
        coinsInputScreen: {
            title: 'Seleccione la Cantidad de Tokens',
            button: 'Calcular el Boost Diario',
            button2: 'Omitir Paso',
            loading: 'Calcular el Boost diario..',
            available: 'Disponible: ',
            maxButton: 'Max',
            errors: {
                digits: 'Deben ser sólo dígitos',
                max: 'No hay suficientes Tokens en tu saldo. Por favor, introduzca otra cantidad o depósito',
                min: 'La suma debe ser al menos {{limit}} {{coin}}',
                maxStack: 'La suma debe ser como máximo {{limit}} {{coin}}',
            },
            maxBoost:
                'Realiza el invierta en de {{amount}} {{coin}} para conseguir {{boost}}% de aumento',
            maxBoostModal: {
                title: 'Maximiza tu boost',
                text: '¡Bloquea la suma sugerida y recibe el máximo impulso posible en esta opción!',
                button: 'Añadir monedas',
                deposit: {
                    title: 'Depósito óptimo = {{amount}} {{coin}}',
                    text: 'El número óptimo de tokens para obtener el mayor rendimiento. El valor depende del número de mascotas y sus estadísticas',
                },
                boost: {
                    title: 'Aumento máximo diario = {{boost}}%',
                    text: 'Después de realizar el depósito óptimo se realizará el invertido del boost diario. El aumento se recalculará cada día en función de las estadísticas de tus mascotas. Siempre puedes añadir tokens si es necesario',
                },
            },
        },
        dailyBoostScreen: {
            title: 'Impulso diario',
            headerTitle: 'Impulso diario = ',
            headerText:
                'El impulso estará activo dentro del período de bloqueo de la opción, después del cual los tokens se podrán reclamar',
            button: 'Confirmar',
            confirmationModal: {
                title: 'Confirmar',
                keys: {
                    from: 'En',
                    duration: 'Duración',
                    endingOn: 'Fin',
                    dailyBoost: 'Boost Diario',
                    summary: 'Importe',
                },
                values: {
                    from: 'Cartera Principal',
                    duration: '{{plan}}, {{days}} Días',
                },
            },
        },
        successScreen: {
            title: 'Habilitar impulsar con éxito',
            text: 'Sus tokens están en invertido y se mantendrán hasta el final del plan. Una vez finalizado el plan, deberá utilizar el botón "Obtener fichas" para devolver los tokens a tu Cartera',
            button: 'Volver a Cartera',
        },
        successUnStakeScreen: {
            title: 'Eliminando impulsar con éxito',
            text: 'Has eliminado con éxito impulsar. Los tokens han sido devueltos a tu Cartera Principal',
            button: 'Volver a Cartera',
        },
        alreadyScreen: {
            title: 'Impulsar',
            headerTitle: 'Detalles del plan',
            headerText:
                'Has realizado el invertido de tus Tokens, los cuales se mantendrán bloqueados hasta el final del plan. Una vez finalizado el plan, los tokens se pueden devolver en la Cartera Principal',
            headerInfoText: '¿Cómo funciona?',
            confirmationModal: {
                title: 'Confirmar transacción',
                keys: {
                    from: 'A la billetera',
                    duration: 'Duración',
                    endingOn: 'Terminado en',
                    dailyBoost: 'Boost diario',
                    summary: 'Resumen',
                },
                values: {
                    from: 'Cartera de Recompensas',
                    duration: '{{plan}}, {{days}} Días',
                },
            },
            staked: {
                title: '{{coin}} Impulsar',
                text: 'Plan activo. Puede añadir más Tokens',
                timerTitle: 'Tiempo Restante',
                staking: 'Impulsar:',
                deposit: 'Depositado el:',
                end: 'Terminado en:',
                boost: 'Boost Diario:',
                summary: 'Resumen:',
                buttonAdd: 'Añadir más Tokens',
                buttonUpgrade: 'Mejorar el Plan',
                buttonUnstake: 'Obtener fichas',
                modalAddCoins: {
                    title: '¿Añadir más Tokens?',
                    text: 'Después de agregar tokens, tu opción de impulso se recalculará en función del monto depositado y el temporizador se reiniciará',
                    button1: 'Añadir Tokens',
                    button2: 'Cancelar',
                },
                modalUpgrade: {
                    title: '¿Mejorar tu Plan?',
                    text: 'Después de actualizar tu opción de impulso, se recalculará en función del monto depositado y el temporizador se reiniciará',
                    button1: 'Mejorar',
                    button2: 'Cancelar',
                },
            },
        },
    },
    timer: {
        captions: {
            day: 'Días',
            hour: 'Horas',
            min: 'Min',
            sec: 'Sec',
        },
        newDay: 'Nuevo día',
        refreshed: 'Sus tareas actualizadas',
    },
    referrals: {
        myReferrer: 'Este usuario te ha invitado',
        referralCode: 'Tu Código de referencia',
        referralLink: 'Tu Enlace de referencia',
        header: {
            title: 'Invitar Nuevos Usuarios',
            text: 'Invita a otros usuarios y gana aún más con nuestro programa de referencias. A conitnuación vea cómo funciona',
            infoText: '¿Cómo funciona?',
        },
        direct: {
            title: 'Referencia directa - {{directPercentage}}',
            text: 'Recibirás el {{directPercentage}}% de todas las recompensas obtenidas por tus amigos',
        },
        indirect: {
            title: 'Referencia indirecta - {{inDirectPercentage}}',
            text: 'Recibirás el {{inDirectPercentage}}% de todas las recompensas obtenidas por los amigos de tus amigos',
        },
        gaming: {
            title: 'Bonos de juego',
            text: 'Los bonos de referencia están activos tanto para juegos PvP como para tareas de juego',
        },
        buttonShare: 'Invitar a usuarios',
        invitedReferrals: {
            card: {
                direct: 'Referencias directas',
                indirect: 'Referencias indirectas',
                active: 'Referencias activas (directas)',
                turnover: 'Facturación total',
            },
            viewReward: 'Ver Referencias',
            indirectModal: {
                title: 'Referencia indirecta',
                text: 'Este usuario fue invitado por uno de tus amigos',
            },
            header: {
                title: 'Invitaciones realizadas',
                text: 'Aquí puedes ver todas las referencias de las invitaciones realizadas y tu boost diario en el caso de cumplir con todos los términos',
                infoText: '¿Cómo funciona el Boost Diario?',
                list: 'Referencias',
                sort: 'Ordenar por',
                filter: {
                    CreatedAt: 'Última',
                    UserEnergy: 'Energía',
                },
            },
        },
        emptyScreen: {
            title: '¡Uy!',
            text: 'Algo va mal. Pero no te preocupes, se arreglará rápidamente. Intenta deslizar hacia abajo.',
        },
        emptyList: {
            title: ' Aún no hay Referencias de Invitados',
            text: 'Aún no has invitado a ningún usuario. Pero no hay problema, hagámoslo ahora mismo',
        },
        allInvitedReferralsScreen: {
            title: 'Todas las Referencias Realizadas',
        },
        inviteUsersScreen: {
            title: 'Invitar Usuario',
            text: 'Descargue la aplicación IguVerse e introduzca el código de referencia',
            myNFT: 'Mi mascota NFT',
            collectedEnergy: 'Energía Recopilada',
            leaderBoard: 'Tabla de Clasificación',
            button: 'Compartir Código',
            download: 'Descargar la aplicación IguVerse',
        },
        referralCard: {
            title: 'Utilice el Código de Referencia',
            text: 'Introduzca el código de referencia para obtener bonus adicionales',
            button: 'Introducir Código',
        },
        referrerModal: {
            title: 'Código de Referencia',
            text: 'Introduce el código de referencia y recibirás diferentes descuentos y bonus',
            label: 'Código de Referencia',
            placeHolder: 'Introduzca el código de referencia',
            noCode: '¿No tiene código? ',
            apply: 'Más información',
            button: 'Enviar Código de Referencia',
            success: {
                toastSuccess: {
                    title: 'Código de referencia enviado',
                    text: 'Ahora todas las funciones están a tu disposición',
                },
            },
            error: {
                empty: 'El código de referencia no puede estar vacío',
                incorrectCode:
                    'Código incorrecto. El código de referencia no existe o ha caducado',
                toastError: {
                    title: 'Código Incorrecto',
                    text: 'El código de referencia no existe o ha caducado',
                },
                forbidden:
                    'No se puede utilizar el código de referencia en este dispositivo',
                toastForbidden: {
                    title: 'Prohibido',
                    text: 'No se puede utilizar el código de referencia en este dispositivo',
                },
                toastAlreadyLinked: {
                    title: 'Ya utilizado',
                    text: 'Tu cuenta ya utilizó el Código de Referencia',
                },
            },
        },
        boostCards: {
            cardTitle: 'Boost diario = {{boost}}',
            cardText: 'Debe invitar a ',
            users: ' Usuarios',
            text: 'Cuantos más usuarios invites, más Boost diario obtendrás',
            button: 'Ver Recompensas',
        },
        howBoostWorks: {
            title: 'Consigue un Boost de las recompensas diarias',
            text: 'Invita a usuarios y obtén un Boost en las recompensas diarias tras alcanzar el número exacto de invitados. El Boost se aplicará automáticamente cuando lo consigas',
            alert: 'El Boost se recalcula cada día y sólo es válido para invitados activos, que jueguen cada día y consigan {{rewardEnergyThreshold}} de Energía',
        },
        modalReferee: {
            title: 'Conozca a Tu Invitado',
            text: 'Puedes visitar las redes sociales del usuario invitado para saber más y conocerlo mejor',
            energy: 'Energía Recopilada (24h)',
        },
    },
    aiQuoteInfo: {
        alertCard: {
            overload: { title: 'Sistema Sobrecargado' },
            dailyAttempts: { title: '{{attempts}} Intentos restantes' },
        },
        modalInfo: {
            title: 'NFT desde tu Imaginación',
            text: 'Se puede crear NFT utilizando tecnología de IA, pero esta operación es muy costosa. A veces, debido a la alta carga puede ser temporalmente no disponible',
            daily: 'Últimas 24 horas de Utilización = ',
            dailyText:
                'No puedes generar más de {{amount}} mascotas únicas utilizando la tecnología de IA durante el periodo de 24 horas',
            systemLoad: 'Cargando el sistema = {{load}}',
            systemLoadText:
                'A veces el sistema puede estar sobrecargado debido a una gran demanda. Tendrá que esperar un poco',
            load: {
                low: 'Bajo',
                medium: 'Medio',
                high: 'Alto',
                overloaded: 'Sobrecargado',
            },
            systemUsage: 'Utilización del Sistema = {{percentage}}%',
            systemUsageText:
                'El sistema está en versión Beta y actualmente sólo está disponible en ciertas cantidades al día',
        },
        modalErrorNoMints: {
            title: 'No Quedan más Intentos',
            text: 'Lamentamos informarle de que se han realizado todos los intentos para hoy. Pero no se preocupe, puede intentar mintear NFT utilizando la tecnología IA mañana',
            button1: 'Mintear la Foto',
        },
        modalErrorOverLoad: {
            title: 'Sistema Sobrecargado',
            text: 'Lamentamos informarte de que mintear IA está sobrecargado ahora por otros usuarios. Le haremos saber, cuando esté disponible',
            button1: 'Mintear la Foto',
        },
    },
    howTo: {
        fee: {
            stepOne: {
                title: 'La comisión de Blockchain es aproximada',
                text: 'Todas las transacciones en la aplicación tienen lugar en Blockchain y tienen una comisión en BNB. El importe de la comisión sólo puede conocerse en el momento en que se ejecuta la transacción y sólo le mostramos una estimación',
            },
            stepTwo: {
                title: 'Comisión más Alta por Tokens',
                text: 'En el blockchain, hay que aprobar el uso de Tokens antes de ejecutar una determinada transacción. Pagar con BNB solo requiere una transacción, mientras que pagar otros Tokens requiere dos transacciones: aprobación y ejecución',
            },
        },
        charity: {
            stepOne: {
                title: 'Ayuda a las Organizaciones de Animales',
                text: 'Puedes seleccionar organizaciones benéficas de la lista y realizar donaciones para ayudar a los animales de todo el mundo',
            },
            stepTwo: {
                title: 'Establecer un Porcentaje Preferente',
                text: 'Puedes elegir el porcentaje de las recompensas que se destinarán a la donaciones (del 1% al 100%). También puedes cambiar este valor en cualquier momento',
            },
        },
        play: {
            button: 'Empezar el Juego',
            stepOne: {
                title: 'Elige Mascotas para Completar Tareas',
                text: 'En el apartado de abajo elige las mascotas que participarán en el juego. La primera mascota en el orden se utilizará en la tarea Social y se mostrará como tu mascota principal.',
            },
            stepTwo: {
                title: 'Restaurar la Energía',
                text: 'Tienes 24 horas para restaurar tu nivel de Energía completando las tareas antes de que acabe el día. El 100% de Energía significa que ganarás el 100% de tus recompensas máximas posibles en función de las estadísticas de las mascotas. Cada día, cuando el temporizador marque las 00:00, el nivel de energía se restablecerá',
            },
            stepThree: {
                title: 'Gana Recompensas',
                text: 'Una vez completadas las tareas, tu Energía se convertirá en Recompensas en función de las estadísticas de tu mascota',
            },
            stepFour: {
                title: 'Boost tu NFT',
                text: 'Suba de nivel a tus mascotas, crea nuevas mascotas, suba de rango para disfrutar de más beneficios. Consiga la posición más alta en la Tabla de Clasificación y disfruta de más recompensas',
            },
        },
        referrals: {
            button: 'Invitar a Usuarios',
            stepOne: {
                title: 'Comparta tu Código de Referencia',
                text: 'Invita a usuarios a la aplicación IguVerse y gana con tu juego. Por referencias directas obtendrás - {{direct}}% y por referencias indirectos - {{inDirect}}%',
            },
            stepTwo: {
                title: 'Boost de las Tareas Diarias',
                text: 'Invita a usuarios y consigue un boost en las tareas diarias tras alcanzar el número exacto de invitaciones. Más información en la pestaña "Mis invitados"',
            },
            stepThree: {
                title: 'Reciba más Descuentos',
                text: 'En el bloque "NFT para Jugar" elige como mínimo un NFT para jugar partidas. Ten en cuenta que el primer NFT recogerá la mayor cantidad de experiencia de nivel',
            },
            stepFour: {
                title: 'Obtenga bonos de juego',
                text: 'Por cada juego ganado y por cada recarga, las referencias directas le darán el {{direct}}% de la suma, mientras que las referencias indirectas, el {{inDirect}}%',
            },
        },
        availableRewards: {
            stepOne: {
                titleOne: 'Reclame el ',
                titleTwo: ' de sus recompensas',
                text: 'Puede transferir el {{percent}}% de sus recompensas VIGUP disponibles a su billetera principal. Una vez reclamado, el token puede intercambiarse, enviarse a una billetera diferente o retirarse',
            },

            stepTwo: {
                title: 'Operación de Cobro',
                text: 'Cobrar es una operación blockchain que le da derecho a convertir su saldo VIGUP en su Cartera Principal IGUP. Después de realizar la operación de Cobro con éxito los fondos estarán disponibles inmediatamente',
            },
            stepThree: {
                title: 'Intercambio de VIGUP por ',
                text: 'Podrá intercambiar los tokens ganados por el token IGUAI una vez que se lance el mercado. Al usar la aplicación, se convierte en uno de los primeros en adoptar nuestra solución de capa superior',
            },
            stepFour: {
                title: 'Saldo Negativo',
                text: 'A veces tu saldo disponible puede ser negativo, lo que significa que has usado tus recompensas bloqueadas para diferentes transacciones en el juego como curar y subir de nivel. Permitimos que tus recompensas disponibles sean inferiores a cero, hasta el valor de tu saldo bloqueado. Una vez que desbloquees los Tokens, el saldo disponible también aumentará',
            },
            alert: 'El resto de tokens VIGUP están pendientes y se almacenarán en la Cartera bloqueada',
        },
        lockedRewards: {
            stepOne: {
                title: 'Premios Bloqueados',
                text: 'Las recompensas obtenidas se bloquean según las estadísticas de las mascotas (Rango y Nivel). Mejora tus mascotas para reducir el periodo de bloqueo',
            },
            stepTwo: {
                title: 'Convertir en Recompensas Disponibles',
                text: 'Las recompensas bloqueadas se desbloquean automáticamente y, una vez desbloqueadas, estarán disponibles en Saldo de Recompensas Disponibles',
            },
            stepThree: {
                title: 'Intercambio de VIGUP por ',
                text: 'Podrá intercambiar los tokens ganados por el token IGUAI una vez que se lance el mercado. Al usar la aplicación, se convierte en uno de los primeros en adoptar nuestra solución de capa superior',
            },
        },
        socializeToEarn: {
            CONFIRMED: 'Correcto',
            FAILED: 'Incorrecto',
            step: {
                title: 'Enlace IguVerse agregado',
                text: 'Siempre agregue el enlace a la aplicación IguVerse, que se puede encontrar en la pantalla Compartir, cuando comparta la identificación de la mascota. El enlace debe adjuntarse a la historia misma.',
            },
            stepOne: {
                title: 'La identificación y el enlace de la mascota son completamente visibles',
                text: 'La identificación de la mascota y el enlace deben ser identificables por el verificador sin dificultad. El enlace a la aplicación debe estar activo',
            },
            stepTwo: {
                title: 'Se pueden hacer puqueñas modificaciones',
                text: 'Puede cambiar el tamaño y el color del Pet ID o su inclinación. Naturalmente, estas modificaciones no deben contradecir la primera regla',
            },
            stepThree: {
                title: 'Pet ID es difícil de distinguir',
                text: 'No permitimos ninguna modificación del Pet ID , incluidos el recorte y la ocultación de la imagen o sus partes. Más información',
            },
            stepFour: {
                title: 'Pet ID está cubierto',
                text: 'No se permite superponer o sobrepintar la imagen, así como reducir excesivamente su tamaño',
            },
        },
        verifyUser: {
            stepOne: {
                title: 'Encuentra el Pet ID en las redes sociales',
                text: 'Sigua las redes sociales de otros usuarios, comprueba el contenido y localiza el Pet ID. Escribe el código en la aplicación y completa la tarea',
            },
            stepTwo: {
                title: 'Proporcionar el Pet ID Encontrado',
                text: 'Introduzca el código Pet ID o escanéelo con el escáner de códigos QR. En caso de que no esté, haga clic en el botón Mascota no Encontrada. Busca a todos los usuarios para completar la tarea',
            },
            stepThree: {
                title: 'Sea Responsable',
                text: 'Juega limpio y no intentes engañar al sistema proporcionando con identificaciones erróneas o afirmando que no puedes encontrar. Tu cuenta puede ser marcada o bloqueada si continúas haciendo esto',
            },
        },
        purchaseBNB: {
            screenTitle: 'Cómo Comprar BNB',
            title: 'Comprar BNB en Binance',
            text: 'BNB es una criptomoneda que se utiliza para pagar comisiones en Binance Smart Chain, el blockchain que utilizamos. Mira el siguiente vídeo para saber más sobre cómo depositar BNB en la Cartera del juego',
            guideBlock: {
                title: 'Guía de Compra y Retirada',
                first: 'Accede a la aplicación Binance. Descarga, regístrate y verifícate si no la tienes',
                second: 'Compra cripto con tarjeta o con el servicio p2p. ¡Usted puede elegir BNB de inmediato!',
                third: 'Abra la pestaña Cartera y pulse Retirar',
                fourth: 'Elija la criptomoneda que desea retirar. En nuestro caso, BNB',
                fiveStepOne:
                    'Introduce la dirección a la que desea retirar y seleccione la red: ',
                fiveBold: 'Cadena inteligente BNB (BEP-20)',
                fiveStepTwo:
                    '. La dirección de tu Cartera se encuentra en la pestaña de la Cartera de la aplicación IguVerse. Empieza por 0x y es una combinación de letras y números',
                six: 'Espere unos segundos a que se procese la transacción y ¡listo!',
            },
            resourceBlock: {
                title: 'Recursos Útiles',
                buy: 'Guía de Compra de BNB (BNB)',
                withdraw: 'Cómo Retirarse de Binance',
                status: 'Cómo Comprobar el Estado de una Transacción de Criptomoneda en Blockchain',
            },
        },
        petOrderId: {
            title: 'Ordena a las Mascotas',
            text: 'Elige el Personaje Jugador Mascota en la sección "NFT para Jugar" y ¡ordena el resto! El orden de las mascotas determinará la XP que reciben',
            cardFeatureInfo: {
                title: 'Prioridad de las Mascotas',
                text: 'El primero Personaje Jugador Mascota te representará en tu Pet ID, en las votaciones de mascotas y en la Tabla de Clasificaciones',
            },
            button: 'Reordenar Mascotas',
        },
        howToGamingAvailableWallet: {
            screenTitle: 'Monedero disponible',
            button: 'Completar',
            stepOne: {
                title: 'Juega juegos competitivos',
                text: 'La billetera de juego te permite competir con otros jugadores por recompensas y ganar IGU. Usa la pestaña de juegos para ver los juegos disponibles',
            },
            stepTwo: {
                title: 'Recarga el monedero de juego',
                text: 'Para participar, recarga tu monedero de juego con IGU y recibe VIGU. Utiliza el botón de abajo para recargar tokens',
            },
            stepThree: {
                title: 'Retirar a la billetera principal',
                text: 'Las recompensas ganadas en los juegos competitivos se almacenarán en la billetera del juego. Puede retirar estas recompensas a la billetera principal en cualquier momento',
            },
            stepFour: {
                title: 'Obtenga bonos de referencias',
                text: 'Por cada juego ganado y por cada recarga, las referencias directas le darán el {{direct}}% de la suma, mientras que las referencias indirectas, el {{indirect}}%',
            },
        },
        howToGamingPendingWallet: {
            screenTitle: 'Cartera pendiente',
            alert: 'IguVerse no posee los tokens en la cartera de juego pendiente y están bloqueados en un contrato inteligente durante la duración del juego',
            stepOne: {
                title: 'Congelado mientras juegas',
                text: 'Los fondos en Gaming Wallet se congelarán hasta que termines el juego. Esta medida ha sido implementada para prevenir estafas',
            },
            stepTwo: {
                title: 'Descongelación automática',
                text: 'Si ha ganado el juego, sus fondos se devolverán automáticamente a Gaming Wallet. De lo contrario, se entregarán al ganador',
            },
        },
        howToCommissionFee: {
            screenTitle: 'De comisión',
            stepOne: {
                title: ' de comisión',
                text: 'Cobramos una comisión del {{commission}}% por cada retiro de la Cartera de juego',
            },
            stepTwo: {
                title: 'Tokenomía mejorada',
                text: 'Los juegos PvP siguen el modelo económico de la piscina, que es superior a las economías de la mayoría de los proyectos de GameFi. La tarifa de comisión se deducirá para fortalecer aún más la economía',
            },
        },
        HowToCollections: {
            stepOne: {
                title: 'Un compañero de mascota virtual',
                text: 'Crea una mascota NFT con la ayuda de la IA que te ayudará a ganar en las redes sociales. También puedes subir una foto de tu propia mascota',
            },
            stepTwo: {
                title: 'Restaurar la Energía',
                text: 'Tienes 24 horas para restaurar tu nivel de Energía completando las tareas antes de que acabe el día. El 100% de Energía significa que ganarás el 100% de tus recompensas máximas posibles en función de las estadísticas de las mascotas. Cada día, cuando el temporizador marque las 00:00, el nivel de energía se restablecerá',
            },
            stepThree: {
                title: 'Intercambio de VIGUP por ',
                text: 'Podrá intercambiar los tokens ganados por el token IGUAI una vez que se lance el mercado. Al usar la aplicación, se convierte en uno de los primeros en adoptar nuestra solución de capa superior',
            },
        },
    },
    energyInfoScreen: {
        title: 'Recopila Energía y Cámbiala por Tokens',
        text: 'Tu Energía/IGUP es tu tipo de cambio que depende de la cantidad de mascotas, rangos, niveles y otros modificadores como el boost',
        button: 'Empezar a Jugar',
        features: {
            first: {
                title: '1 Energía ≈ {{amount}} IGUP',
                text: 'Este es el tipo de cambio aproximado, que puede variar en función de diferentes condiciones',
            },
            second: {
                title: 'Umbral de Energía = {{energy}}',
                text: 'Si no alcanzas el umbral mínimo de {{energy}} puntos de energía, la mitad de tus puntos de energía se quemarán y la otra mitad se transferirá al día siguiente',
            },
        },
    },
    initial: {
        initialMint: {
            title: 'Crea tu Primera Mascota y Comienza tu Viaje en IguVerse',
            text: 'Este es el último paso antes de tu empezar tu increíble viaje en IguVerse. Crea tu primera mascota y empieza a jugar y ganar recompensas por la actividad diaria con tu mascota',
            button: 'Crea tu Primera Mascota',
        },
        initialReferral: {
            title: '¡Disfrute del descuento de Mintear las Referencias!',
            text: 'Has sido invitado a nuestra app. Disfruta de descuentos y bonificaciones por jugar a IguVerse. Date prisa en crear tu Mascota NFT',
            button: 'Continuar',
        },
    },
    ModalShareOrSave: {
        title: 'Guardar Contenido',
        text: 'Guarda tu contenido favorito de IguVerse en la Camera Roll o compártelo con tus amigos',
        save: 'Guardar en Camera Roll',
        share: 'Compartir',
        loading: 'Preparando contenido..',
        saveSuccess: 'Contenido guardado en Camera Roll',
    },
    RelatedApps: {
        downloadApp: {
            titleiOS: 'Aplicación disponible en iOS',
            titleAndroid: 'Aplicación disponible en Android',
            description:
                'Disfrute de una mejor experiencia en la aplicación móvil',
            buttonOk: 'Descargar aplicación',
            buttonCancel: 'Ahora no',
        },
        switchToApp: {
            titleiOS: 'Cambiar a la aplicación iOS',
            titleAndroid: 'Cambiar a la aplicación Android',
            description:
                'Disfrute de una mejor experiencia en la aplicación móvil',
            buttonOk: 'Cambiar a App',
            buttonCancel: 'Ahora no',
        },
    },
    ShareYourFeedback: {
        title: 'Comparte tu Opinión',
        text: 'Puede compartir tus opiniones con nosotros y, al enviar este formulario, nos enviará los registros del lado del cliente para que podamos ayudarle a identificar su problema',
        placeholder: 'Describa detalladamente sus problemas',
        button: 'Enviar',
        loading: 'Enviando..',
        accessibility: 'Desactivar la función "Envíar tus Opiniones"',
    },
    ModalMainnet: {
        title: 'Función NO Disponible',
        text: 'Esta función NO estará disponible hasta que la IGU salga en la bolsa. La fecha exacta de cotización se anunciará en breve',
        button: 'OK',
    },
    ModalDailyRewards: {
        [DAILY_REWARD_STATUS.Bonus]: {
            title: 'Bonificación PvP acreditada',
            text: 'Por su actividad en juegos PvP, se le ha otorgado una bonificación que se deposita directamente en Gaming Wallet',
        },
        [DAILY_REWARD_STATUS.Daily]: {
            title: 'Recompensa Diaria Disponible en su Cartera',
            text: '¡Ya han llegado tus recompensas por las tareas de ayer!',
        },
        [DAILY_REWARD_STATUS.Both]: {
            title: 'Has recibido una recompensa diaria y una bonificación JcJ',
            text: '¡Tus recompensas diarias han llegado y ya comenzaron a desbloquearse! También ha recibido tokens de bonificación por jugar juegos PvP',
        },
        dailyReward: {
            title: 'Recompensas Disponibles {{availableAmount}} / {{totalAmount}} IGUP',
            text: '{{availableAmount}} IGUP está disponible inmediatamente en su Cartera',
        },
        unlocks: {
            title: 'Tokens Bloqueados',
            text: '{{restAmount}} IGUP se irá desbloqueando gradualmente durante el periodo',
        },
    },
    MintBonusScreen: {
        mintSuccess: {
            title: 'Bonus Programa',
            text: 'Mint Bonus',
        },
        BonusMintRanksDetailedInfoScreen: {
            title: 'Mint NFT - Consigue un IGUP Bonus al instante',
            text: 'Le ofrecemos mintear NFT y obtener unos bonus que podrá retirar en el futuro. Continúe al siguiente paso y finalice el Mint proceso',
            button1: 'Continuar',
            button2: 'Ver todos los Bonus',
            timeRemaining: 'Tiempo restante',
            features: {
                bonus: {
                    key: 'Bonus por Rango = {{amount}} IGUP (${{dollarValue}})',
                    value: 'Los Tokens que se abonarán en su cuenta tras mintear la moneda con éxito',
                },
                lock: {
                    key: 'Periodo de Bloqueo = {{days}} días',
                    value: 'Los Tokens podrán retirarse una vez finalizado el periodo de bloqueo',
                },
            },
        },
        BonusMintRanksCarouselScreen: {
            screenTitle: 'Bonus por Rango',
            title: '{{slug}} Rango',
            button1: 'Seleccionar Rango',
            features: {
                bonus: {
                    key: 'Bonus por Rango = {{amount}} IGUP (${{dollarValue}})',
                    value: 'Los Tokens que se abonarán en su cuenta tras mintear la moneda con éxito',
                },
                lock: {
                    key: 'Periodo de Bloqueo = {{days}} días',
                    value: 'Los Tokens podrán retirarse una vez finalizado el periodo de bloqueo',
                },
            },
        },
    },
    YourPetsAreHungry: {
        title: 'Tus Mascotas Tienen Hambre',
        text: 'La pérdida de salud disminuirá tus recompensas y puede hacer que tus NFT sean inutilizables después de un tiempo. ¡Alimenta a tus mascotas para ganar de forma constante!',
    },
    priceUpModal: {
        title: 'Aumento de Precios hasta ',
        text: 'Debido a la gran demanda y al rápido crecimiento del proyecto, nuestro equipo decidió subir los precios de los NFT para recompensar a los primeros usuarios y garantizar que la economía siga siendo sostenible y equilibrada a largo plazo',
        priceUpdate: 'Aumento de precios en',
        button: 'Nuevo NFT',
    },
    updateModal: {
        banner: {
            title: 'Nueva Actualización',
            text: 'Comprobar la nueva versión {{version}} de la aplicación',
        },
        screen: {
            screenTitle: 'Nueva Actualización',
            title: 'Nueva Actualización Pendiente',
            text: 'El equipo de IguVerse ha estado trabajando duro para mejorar su experiencia con la aplicación y desarrollar nuevas funciones. Disfruta de estas mejoras en la nueva versión {{version}}',
            button: 'Empezar a Jugar',
        },
    },
    communityModal: {
        title: 'Obtener Ayuda de la Comunidad',
        text: 'Únete a nuestras redes sociales oficiales para obtener respuestas a tus preguntas y nuevas perspectivas. ¡Aprenda a aumentar los beneficios, la retirada de fondos y mucho más!',
        button1: 'Ver Redes Sociales',
        button2: 'No Volver a Mostrar',
    },
    socialTooltip: {
        text: 'Haga clic en la etiqueta "Fallido" para saber por qué su cuenta o identificación de mascota no cumple nuestros criterios y ha sido rechazada. Accedá a la Base de Conocimiento para conocer sus próximos pasos',
    },
    gameIterationText: {
        text: 'Se están contando las recompensas de ayer, lo que suele llevar unos {{minutes}} minutos. Podrás volver a jugar cuando termine este proceso',
        toastErrorTitle: 'Se están contando las recompensas de ayer',
    },
    howConnectFacebookModal: {
        info: 'Cómo conectarse',
        screenTitle: 'Cómo conectar Facebook',
        title: 'Encontrar la identificación de Facebook',
        text: 'Para conectar su cuenta de Facebook, debe buscar y copiar su ID de Facebook. Visite su página de perfil y copie la parte del enlace después de / — es su ID de Facebook',
        button: 'Conectar cuenta',
    },
    listingIgu: {
        iguListing: 'IGU Lista',
        title: ' se está preparando para ',
        textOne: 'La cotización en la bolsa {{exchange}} se realizará el día ',
        textTwo: '. ¡Abróchense los cinturones, Iguanas, que despegamos!',
        button: 'Investigación en bolsa',
        listed: {
            title: ' cotiza en ',
            text: 'El tan esperado lanzamiento de IGU finalmente ha llegado: ¡es solo el comienzo de nuestra odisea espacial! Compre e intercambie la moneda IGU en el intercambio de {{exchange}} ahora mismo',
        },
    },
    bybitVote: {
        title1: '¡Vota por IGU y comparte ',
        title2: ' en recompensas!',
        text: 'IguVerse eligió participar en ByVotes, donde puedes votar por el próximo listado de ByVit. ¡Vota por IGU y recibe recompensas!',
        banner: {
            title1: 'Vota y gana desde ',
            title2: '',
        },
        button: 'Aprende más',
    },
    howToPurchaseIGU: {
        modalTitle: 'Cómo comprar IGU',
        exchangesModalTitle: 'Comprar IGU en intercambios',
        cardDeposit: {
            title: 'Depósito',
            text: 'Puede depositar tokens admitidos desde cualquier billetera BSC BEP-20',
        },
        cardExchange: {
            title: 'Comprar en intercambios',
            text: 'Compre y negocie IGU en los intercambios en los que se ha incluido',
        },
        cardTrade: {
            title: 'Comercio en la aplicación',
            text: 'Intercambie IGU de manera rápida y conveniente directamente en la aplicación',
        },
    },
    howToClaimFreePet: {
        title: 'Compre un NFT para reclamar',
        text: 'No puede reclamar recompensas, ya que no tiene ningún NFT en su cuenta. Una mascota gratis no es una NFT, ya que no está en la cadena de bloques. Comprar una mascota NFT o subir de rango la que tienes te dará acceso a recompensas',
        alert: 'Todas las recompensas que ha ganado anteriormente se rastrean y podrá reclamarlas después de la compra',
        button: 'Nuevo NFT',
    },
    howToClaimOnButton: {
        titleOne: 'Reclame el ',
        titleTwo: ' de sus recompensas',
        text: 'Puede transferir el {{percent}}% de sus recompensas VIGUP disponibles a su billetera principal. Una vez reclamado, el token puede intercambiarse, enviarse a una billetera diferente o retirarse',
        alert: 'El resto de tokens VIGUP están pendientes y se almacenarán en la Cartera bloqueada',
        button: 'Reclame su recompensa',
    },
    onBoarding: {
        mainWallet: {
            title: 'Cartera principal',
            stepOne: {
                title: 'Toda su criptografía está aquí',
                text: 'Esta billetera almacena todos los tokens admitidos disponibles en su cuenta. Los tokens no admitidos no se muestran. Todas sus recompensas se transferirán aquí después de reclamarlas',
            },
            stepTwo: {
                title: 'Navegar entre billeteras',
                text: 'Desde la pestaña Cartera principal, puede abrir todas las demás carteras disponibles en su cuenta deslizando el dedo. Estas billeteras incluyen la billetera NFT, la billetera de recompensas y la billetera de juegos',
            },
        },
        login: {
            stepOne: {
                title: 'Una nueva forma de ganar criptomonedas',
                text: '¡Use su rutina diaria de redes sociales para ganar tokens criptográficos! Las tareas incluyen compartir contenido en línea, caminar y jugar un juego de arcade',
            },
            stepTwo: {
                title: 'Un compañero de mascota virtual',
                text: 'Crea una mascota NFT con la ayuda de la IA que te ayudará a ganar en las redes sociales. También puedes subir una foto de tu propia mascota',
            },
            stepThree: {
                title: 'Juegos competitivos',
                text: '¿Quieres ganar mucho más? Desafía a otros en nuestros modos de juego PvP y gana en grande',
            },
            stepFour: {
                title: 'Donaciones para animales',
                text: 'El 1% de sus recompensas diarias se destina al bienestar animal. Puede aumentar el tamaño de la donación en la aplicación',
            },
            stepFive: {
                title: 'Productos futuros',
                text: 'La aplicación es solo el primer producto de una serie. Conviértase en uno de los primeros en adoptar nuestro mercado impulsado por IA y una red publicitaria descentralizada una vez que se lancen',
            },
        },
    },
    HomeScreen: {
        MemsModal: {
            title1: '',
            title2: ' en MemeFi Discord: ¡Únete ahora!',
            text: 'MemeFi acaba de lanzar una campaña de sorteo de NFT en Discord. Con una tarea sencilla obtendrás entradas Royale para NFT con entregas de $MEMF',

            button1: 'Únete a la Discord',
            button2: 'Explorar sitio web',
            banner: {
                title: '$450.000 Airdrop',
                text: 'MemeFi acaba de lanzar una campaña de sorteo de NFT en Discord',
            },
        },
        exploreGames: 'Explorar juegos',
        minimalBet: {
            title: 'Apuesta mínima = {{amount}}',
            text: 'La suma más pequeña que puede apostar en un juego',
        },
        WelcomeHeader: {
            title: 'Bienvenido de nuevo!',
            text: 'Juega y gana criptomonedas todos los días',
        },
        ModalGameComingSoon: {
            title: 'Juego próximamente',
            text: 'Nuestro equipo está trabajando arduamente en el nuevo juego PvP y se lanzará pronto. ¡Echa un vistazo a otros juegos divertidos en nuestra biblioteca!',
        },
        GamesBlock: {
            header: 'Juegos de competición',
            button: 'Jugar',
            buttonContinue: 'Continúa jugando',
            buttonComingSoon: 'Próximamente...',
            orders: '{{orders}} Habitaciones',
            games: {
                [MYSTERY_GAMES.mysteryLikes]: {
                    title: 'The Mystery of Likes',
                    text: 'Adivina el número correcto de Me gusta para un NFT',
                },

                [MYSTERY_GAMES.nftRoyal]: {
                    title: 'The Grand Race',
                    text: 'Carrera hacia la victoria en un camino lleno de frutas',
                },
                [MYSTERY_GAMES.nftEvolution]: {
                    title: 'NFT Evolution',
                    text: 'Cría NFT y recibe versiones más poderosas',
                },
                [MYSTERY_GAMES.luckyStrike]: {
                    title: 'Lucky Strike',
                    text: 'Obtenga boletos para tener suerte y reclame todo en un emocionante juego de fortuna',
                },
                [MYSTERY_GAMES.quantumSpin]: {
                    title: 'Quantum Disk',
                    text: 'Gira tu rueda cuántica para encantar la moneda de diez centavos en movimiento',
                },
                [MYSTERY_GAMES.tokenteller]: {
                    title: 'Tokenteller',
                    text: 'Coge tu bola de cristal y adivina los precios futuros de las IGU',
                },
                socialProof:
                    '{{amount}} ganados en el juego {{game}} PvP ahora mismo',
            },
        },
        GamesFeatures: {
            orders: 'Salas de juego vacantes',
            prizePool: 'Fondo total de premios',
            turnover: 'Facturación en {{coin}}',
            totalSlots: 'Total de rondas',
        },
        VacantRoomsEmpty: {
            title: 'No hay juegos vacantes',
            text: 'No hay solicitudes de juegos activas por ahora. ¿Quieres crear uno? Cualquier jugador podrá desafiarte',
        },
        EmptyGameHistory: {
            title: 'Aún no hay juegos',
            text: 'No has jugado ni creado ningún juego. Crea uno ahora y sé desafiado por un jugador aleatorio',
        },
        GamesNavigationBar: {
            ORDERS: 'Habitaciones vacantes',
            HISTORY: 'Historia',
            ROUNDS: 'Rondas',
            WHEEL: 'Disco',
        },
        ActiveOrdersFilters: {
            title: 'Habitaciones vacantes',
            modalTitle: 'Ordenar por',
            Newest: 'Más nuevo',
            Oldest: 'Más antiguo',
            Highest: 'Premio más alto',
            Lowest: 'Premio más bajo',
        },
        ConfirmPlayModal: {
            title: 'Apuesta ',
            title2: 'Girar para ',
            text: 'Al unirse al juego, confirma que la apuesta se retirará a The Pending Game Wallet',
        },
        GamesCreateWelcome: {
            screenTitle: 'Crear Pedido para el "{{game}}"',
            title: 'Desafía a otros',
            text: 'Crea un juego con la apuesta preferida y termínalo, para que otros jugadores puedan asumir tu desafío',
        },
        MaxMinimalBetFeature: {
            title: 'Apuesta mínima = {{min}}, Apuesta máxima = {{max}}',
            text: 'Las sumas más pequeñas y más grandes que puede apostar en un juego',
        },
        GameTermination: {
            title: 'Terminación automática = {{days}} Días',
            text: 'El tiempo después del cual el juego expira si ningún otro jugador te desafía',
            alert: 'Si nadie lo desafió dentro de los siete días, el juego se eliminará automáticamente y el depósito se devolverá a su saldo',
        },
        EnterCoinsAmountScreen: {
            screenTitle: 'Introduzca la cantidad de monedas',
            error: {
                max: 'Saldo insuficiente, recarga para continuar',
                maxStake:
                    'Apuesta máxima {{amount}}, por favor disminuya la cantidad de la apuesta',
                minStake:
                    'Apuesta mínima {{amount}}, por favor, aumente la apuesta',
                digits: 'Deben ser sólo dígitos',
            },
            confirmTransaction: {
                valueType: 'Creación de pedidos para "{{game}}"',
            },
        },
        PreviousGameModal: {
            title: 'Terminar el juego anterior?',
            text: 'Completa el juego al que te has unido para que otros usuarios puedan desafiarte. El juego caducará automáticamente en {{days}} días',
            button1: 'Terminar juego anterior',
        },
        GameHistoryScreen: {
            title: 'Historia',
            text: 'Aquí está el historial de los juegos que has completado. Puedes verlos por mes',
            status: {
                [MYSTERY_LIKES_STATUS.WaitingForMyself]: 'Esperando tu turno',
                [MYSTERY_LIKES_STATUS.WaitingForOpponent]:
                    'Esperando a un oponente',
                [MYSTERY_LIKES_STATUS.Refund]: 'El juego ha expirado',
            },
        },
        MysteryGamesBanner: {
            oneGame: {
                title: 'Continúa jugando!',
                text: 'Termina el juego "{{game}}"',
            },
            more: {
                title: 'Continúa jugando!',
                text: 'Hay 2 juego sin terminar',
            },
        },
        MysteryGamesContinueModal: {
            title: 'Continúa jugando',
            text: 'Hay 2 juegos sin terminar que debes completar para conocer los resultados del juego',
        },
        MysteryLikes: {
            MysteryLikesHowItWorks: {
                stepOne: {
                    title: 'Adivina el número de Me gusta',
                    text: 'Cada ronda de juego tiene {{gamesAmount}} juegos contra el otro jugador. Adivina más veces que tu oponente para ganar',
                },
                stepTwo: {
                    title: 'Únete y crea juegos',
                    text: 'Los usuarios pueden unirse y crear juegos. Al crear un juego, debe elegir la apuesta en tokens VIGU. Al unirse a un juego, acepta apostar la cantidad de tokens especificada por el creador del juego',
                },
                stepThree: {
                    title: 'Hacer trampa es imposible',
                    text: 'La cantidad de Me gusta para un NFT es inaccesible para los usuarios, por lo que no es posible hacer trampa. Si pareces estar teniendo un golpe de mala suerte, es lo que es. Juega un poco más y la marea cambiará seguro',
                },
            },
            MysteryLikesCreateGameSuccess: {
                title: 'Se creó un juego',
                text: '¡Has creado un juego con éxito! Por favor, termine la ronda para que podamos comparar sus respuestas con las de su futuro oponente',
                button: 'Empezar a jugar',
            },
            MysteryLikesSelectRange: {
                title: 'Seleccione el rango',
                text: 'Elija el rango que contiene el número correcto de Me gusta',
                button: 'Continuar con la siguiente imagen',
                toastError: 'Ya votado',
                buttonFinish: 'Terminar el juego',
                tooltip1:
                    'Este es el NFT de tu oponente. Tienes que adivinar cuántos likes tiene. Los Me gusta son invisibles tanto para ti como para tu oponente',
                tooltip2:
                    'Para elegir el número de Me gusta, haga clic en una de las tarjetas y pase a la siguiente imagen con el botón de abajo',
            },
            MysteryLikesSelectRangeFinish: {
                [MYSTERY_LIKES_STATUS.WaitingForOpponent]: {
                    title: 'Esperando a un oponente',
                    text: 'Has completado el juego. Ahora depende de tu oponente desafiarte y unirse. Si un oponente no lo completa dentro de los siete días, el juego finalizará automáticamente y se le devolverá su depósito',
                },
                [MYSTERY_LIKES_STATUS.Won]: {
                    title: 'Has ganado!',
                    textOne:
                        '¡Felicitaciones! Has logrado superar a tu oponente. ',
                    textTwo: ' se transferirán a su billetera de inmediato',
                },
                [MYSTERY_LIKES_STATUS.Draw]: {
                    title: 'Vaya, es un empate!',
                    text: 'Por improbable que parezca, ambos ganaron la misma cantidad de puntos. Su apuesta ha sido devuelta a su billetera. ¿Quieres otra ronda?',
                },
                [MYSTERY_LIKES_STATUS.Lost]: {
                    title: 'Has perdido :(',
                    text: 'Lamentablemente, tu oponente logró superarte en esta ronda de juego. Su participación ha sido transferida a su billetera. Bueno, ¡siempre puedes ganar la próxima vez!',
                },
                statistics: 'Tus estadísticas',
                alert: 'Si nadie lo desafió dentro de los siete días, el juego se eliminará automáticamente y el depósito se devolverá a su saldo',
                likes: 'Me gusta',
            },
            MysteryLikesConfirmPlay: {
                warning:
                    'La cantidad de Me gusta para un NFT es inaccesible para los usuarios, por lo que no es posible hacer trampa',
            },

            MysteryLikesLoadingScreen: {
                prepare: {
                    title: 'Preparación de NFT',
                    text: 'Estamos barajando los NFT para que obtengas un diseño aleatorio. ¡Los me gusta son invisibles para los jugadores! Por favor, espera un poco y no abandones el juego ni la aplicación',
                },
                complete: {
                    title: 'Análisis de resultados',
                    text: 'Procesando sus elecciones y las de su oponente para anunciar los resultados. Por favor, espera un poco y no abandones el juego ni la aplicación',
                },
            },
        },

        NftEvolution: {
            breedCost: {
                title: 'Costo de cría{{amount}}',
                text: 'El costo del próximo Rank NFT después de la crianza con un 40% de descuento',
                alert: 'Conseguir el siguiente rango no está garantizado',
            },
            WelcomeNftEvolution: {
                BestRankToBreed: {
                    title: 'Mejores rangos para criar',
                    text: 'Aquí hay una lista de las mejores combinaciones de rango para la reproducción',
                },
                stepOne: {
                    title: 'Raza NFT',
                    text: 'Elija dos NFT para reproducir y obtenga un NFT de un rango aleatorio con cierta probabilidad. ¡Los NFT no desaparecen!',
                },
                stepTwo: {
                    title: 'Clonación de ADN',
                    text: '¡Nuestros laboratorios de alta tecnología ahora pueden tomar ADN de animales muertos y clonarlos! Entonces, tome un par de NFT muertos y créelos. La salud no será restaurada',
                },
                stepThree: {
                    title: 'Posibilidades de clasificación',
                    text: 'Aprenda cuáles son las posibilidades de obtener cada rango al criar. Los NFT no tienen que ser del mismo rango. Sin embargo, tiene la oportunidad de ganar un NFT de cualquier rango, incluidos los rangos más altos',
                },
                stepFour: {
                    title: 'Costo de cría',
                    text: 'El costo del próximo Rank NFT después de la crianza con un 40% de descuento. Recibirá un NFT único generado por IA. La generación a partir de una foto no está disponible',
                },
            },
            NftEvolutionSelectPets: {
                text: 'Aquí hay una lista de las mejores combinaciones de rango para la reproducción',
                button: 'Calcular probabilidades',
                emptyCard: {
                    first: 'Seleccione el primer NFT a cruzar',
                    second: 'Seleccione el segundo NFT a cruzar',
                },
                loading: 'Análisis...',
            },
            NftEvolutionSelectPet: {
                title: 'Seleccione NFT',
            },
            NftEvolutionCheckout: {
                title: 'Las posibilidades del cruce',
                text: 'Más información sobre las ventajas de los cruces',
                button: 'Raza para {{amount}}',
                loading: {
                    title: 'Cría',
                    text: 'Por favor, espere mientras se reproducen los NFT. No cierres la aplicación ni salgas de la pestaña. El proceso de reproducción suele durar hasta cinco minutos',
                },
            },
            ConfirmBreedModal: {
                title: 'Raza para ',
                text: 'Al unirte al juego, aceptas criar dos NFT para recibir un nuevo NFT de un Rango aleatorio',
            },
            NftEvolutionSuccess: {
                title: 'NFT de rango {{rank}} creado!',
                text: 'Felicidades! Has criado con éxito tus NFT y has recibido un NFT de rango {{rank}}',
            },
            NftEvolutionMintPet: {
                title: 'Personalizar nuevo NFT',
                text: 'Hemos generado automáticamente cuatro imágenes del NFT para usted. Échales un vistazo, elige el mejor y escribe el nombre de tu nuevo NFT',
            },
            noPetModal: {
                title: 'Menta un nuevo NFT para jugar',
                text: 'Para participar en el juego, se necesitan al menos dos mascotas. Acuña uno nuevo y empieza a jugar',
            },
        },

        NftRoyal: {
            lockPeriodWarning:
                'Para evitar hacer trampa, usamos un sistema inteligente de detección de trampas',

            NftRoyalHowItWorks: {
                stepOne: {
                    title: 'Juega un divertido juego de arcade',
                    text: 'Esta es una variación del juego de las tareas diarias, donde te enfrentarás a oponentes fuertes. Ofrecemos varios modos de juego para mejorar su experiencia. Tendrás un solo oponente',
                },
                stepTwo: {
                    title: 'Únete y crea juegos',
                    text: 'Los usuarios pueden unirse y crear juegos. Al crear un juego, debe elegir la apuesta en tokens VIGU. Al unirse a un juego, acepta apostar la cantidad de tokens especificada por el creador del juego',
                },
                stepThree: {
                    title: 'Hacer trampa es imposible',
                    text: 'Para evitar hacer trampa, usamos un sistema inteligente de detección de trampas que garantiza que solo la habilidad y la suerte determinen al ganador',
                },
            },
            NftRoyalGameSettings: {
                gameMode: {
                    [NFT_ROYAL_GAME_MODE.Score]: {
                        title: 'Puntos',
                        text: 'Los jugadores competirán por puntos',
                    },
                    [NFT_ROYAL_GAME_MODE.Fruit]: {
                        title: 'Fruta',
                        text: 'Los jugadores competirán por las frutas',
                    },
                },
                difficultyType: {
                    [GAME_DIFFICULTY.Easy]: {
                        title: 'Fácil',
                        text: 'Baja velocidad y baja tasa de desove de cactus',
                    },
                    [GAME_DIFFICULTY.Medium]: {
                        title: 'Medio',
                        text: 'Velocidad media y tasa media de desove de cactus',
                    },
                    [GAME_DIFFICULTY.Hard]: {
                        title: 'Duro',
                        text: 'Alta velocidad y alta tasa de desove de cactus',
                    },
                },
                lives: 'El número máximo de vidas en el juego',
            },
            NftRoyalGameSettingsModal: {
                title: 'Configuraciones de juego',
                text: 'Hay una variedad de parámetros diferentes para un juego más emocionante',
                feature: {
                    mode: {
                        description:
                            'En el modo de puntuación compites por puntos y en el modo de frutas compites por la cantidad de frutas recolectadas',
                    },
                    difficulty: {
                        description:
                            'Los tres niveles de dificultad (fácil, medio y difícil) controlan la velocidad y la aparición de cactus',
                    },
                    livesCount: {
                        description:
                            'El número de vidas en el juego. El juego termina con la pérdida de la última vida de uno de los jugadores',
                    },
                },
            },

            NftRoyalCreateGameSuccess: {
                title: '¡Has creado una partida con éxito!',
                text: 'Por favor, termine el juego para que podamos comparar sus resultados con los de su futuro oponente',
            },

            NftRoyalGameHistory: {
                [NFT_ROYAL_GAME_HISTORY_STATUS.WaitingForOpponent]: {
                    title: 'Esperando a un oponente',
                    text: 'Has completado el juego. Ahora depende de tu oponente desafiarte y unirse. Si un oponente no lo completa dentro de los siete días, el juego finalizará automáticamente y se le devolverá su depósito',
                },
                [NFT_ROYAL_GAME_HISTORY_STATUS.Won]: {
                    title: 'Has ganado!',
                    textOne:
                        '¡Felicitaciones! Has logrado superar a tu oponente. ',
                    textTwo:
                        ' se transferirá a tu billetera de juego de inmediato',
                },
                [NFT_ROYAL_GAME_HISTORY_STATUS.Draw]: {
                    title: 'Vaya, es un empate!',
                    text: 'Por improbable que parezca, ambos ganaron la misma cantidad de puntos. Su apuesta ha sido devuelta a su billetera. ¿Quieres otra ronda?',
                },
                [NFT_ROYAL_GAME_HISTORY_STATUS.Lost]: {
                    title: 'Has perdido :(',
                    text: 'Lamentablemente, tu oponente logró superarte en esta ronda de juego. Su participación ha sido transferida a su billetera. Bueno, ¡siempre puedes ganar la próxima vez!',
                },
                GameStatistics: {
                    title: 'Estadísticas del Juego',
                    score: 'Tu Puntuación',
                    lives: 'Vidas Salvadas',
                    fruitCollected: 'Fruta Recogida',
                },
            },
            NftRoyalLoadingScreen: {
                prepare: {
                    title: 'Preparando juego',
                    text: 'Estamos haciendo todo el trabajo necesario para que el juego comience. Por favor espere un poco. ¡No tomará mucho tiempo!',
                },
                complete: {
                    title: 'Análisis de resultados',
                    text: 'Procesando su resultado y el resultado de su oponente para anunciar los resultados. Por favor, espere un poco y no abandone el juego o la aplicación',
                },
            },
            emptyScreen: {
                title: '¡Uy!',
                text: 'Algo va mal. Pero no te preocupes, se arreglará rápidamente',
            },
        },

        [MYSTERY_GAMES.luckyStrike]: {
            keys: {
                participants: 'Participantes',
                winners: 'Ganadores afortunados',
            },

            purchaseTicket: 'Agarrar boletos',
            ticketsGrabbed: 'Boletos agarrados',
            soldOut: 'Todas las entradas están agotadas',
            LuckyStrikeTimerBlock: {
                title: 'La ronda termina en',
                text: 'El tiempo restante de la ronda',
            },
            HashSecuritySystem: {
                title: 'Sistema Hash Seguro',
                text: 'Cada boleto tiene un código hash único que está oculto para otros jugadores. ¡El código decide el ganador!',
            },
            LuckyStrikePricePool: {
                title: 'Premio = {{text}}',
                text: 'El fondo total recaudado de las primas de boletos. Un ganador se lo lleva todo. La recompensa se paga a Gaming Wallet',
            },
            LuckyStrikeParticipants: {
                title: 'Participantes = {{text}}',
                text: 'Jugadores a participar y límite de jugadores. Una vez que se alcanza el límite, los boletos nuevos dejan de estar disponibles',
            },
            LuckyStrikeHowItWorks: {
                stepOne: {
                    title: 'Presentamos Lucky Strike',
                    text: '¡Juega una ronda y gana un buen premio! Cada boleto que obtienes en cada ronda aumenta tus probabilidades de ganar',
                },
                stepTwo: {
                    title: 'Aumenta tus posibilidades',
                    text: 'Los jugadores tienen la oportunidad de ganar el pozo hecho con las primas de los boletos. Cuantos más boletos recoja, mayor será la posibilidad de recibir la recompensa',
                },
                stepThree: {
                    title: 'Hacer trampa es imposible',
                    text: 'Dado que el hash de un ticket es inaccesible para otros usuarios, no es posible hacer trampa. Si pareces estar teniendo un golpe de mala suerte, eso es lo que es. Juega un poco más y la marea cambiará seguro',
                },
            },
            LuckyStrikeMain: {
                title: 'Rondas de la suerte',
                text: 'Las rondas varían en duración, número de jugadores y posibilidades de ganar',
                emptyList: {
                    title: 'No hay ganadores',
                    text: 'Por el momento no hay usuarios que hayan ganado una ronda. ¡Pronto aparecerán ganadores!',
                },
            },
            LuckyStrikeWinners: {
                title: 'Ganadores afortunados',
                text: 'Echa un vistazo a los afortunados ganadores',
            },
            LuckyStrikePurchaseModal: {
                title: 'Obtenga el boleto "{{type}}"',
                text: 'Las primas se recogen del fondo de juego. El ganador se lleva todo el grupo y está determinado por el hash del ticket. Cuantos más boletos obtenga, mayor será la posibilidad de recibir la recompensa',
                alert: 'Puede obtener un máximo de {{maxTickets}} boletos por juego para evitar trampas y mejorar la experiencia del juego',
            },
            LuckyStrikeWaitingForResult: {
                title: 'Esperando resultados!',
                text: 'Espere hasta el final de la ronda para conocer el resultado del juego. Puede obtener más boletos para aumentar sus posibilidades de ganar',
            },
            LuckyStrikeUserTickets: {
                text: 'Cada boleto tiene un código hash único que está oculto para otros jugadores y nos ayuda a garantizar la imparcialidad del juego',
                alert: 'Ya tienes un máximo de {{text}} boletos permitidos por juego',
            },

            LuckyStrikeHistoryItem: {
                [LUCKY_STRIKE_GAMES_STATUS.Won]: '{{round}} Ganada',
                [LUCKY_STRIKE_GAMES_STATUS.Lost]: '{{round}} Perdida',
                [LUCKY_STRIKE_GAMES_STATUS.WaitingForResults]:
                    'Esperando resultados',
            },
            LuckyStrikeHistoryBlockHeader: {
                [LUCKY_STRIKE_GAMES_STATUS.Won]: {
                    title: '¡Has ganado!',
                    textOne:
                        '¡Felicitaciones! Tu boleto es el de la suerte y ganas todo el premio acumulado. ',
                    textTwo: ' se depositará en su billetera al instante',
                },

                [LUCKY_STRIKE_GAMES_STATUS.Lost]: {
                    title: 'Has perdido :(',
                    text: 'Desafortunadamente, esta vez no lograste ganar la ronda. ¡Qué suerte para ti en la próxima!',
                },
            },
            LuckyStrikeGameHistoryInfo: {
                gameType: 'Tipo de juego',
                correctTicket: 'Entrada ganador',
                yourTicket: 'Tu Entrada',
                yourTickets: 'Tu Entradas',
            },

            toasts: {
                soldOut: {
                    text1: '¡Error!',
                    text2: '¡Entradas agotadas!',
                },
                gameExpired: {
                    text1: '¡Error!',
                    text2: '¡Ronda expirada!',
                },
                gamePending: {
                    text: '¡Uy!',
                    text2: 'Algo va mal',
                },
            },
        },

        [MYSTERY_GAMES.quantumSpin]: {
            keys: {
                spin: 'Girar',
                spinning: 'Hilado',
            },
            QuantumSpinProvablyFair: {
                card: {
                    title: 'Demostrablemente justo',
                    text: 'Todos los resultados se calculan mediante una función criptográfica, que permite a cualquiera comprobar la equidad del juego',
                },

                title: 'Demostrablemente justo',
                text: 'Los resultados están encadenados, lo que hace imposible engañar al sistema. Cuando publicamos el primer hash en Twitter, usted mismo puede demostrar la imparcialidad de los resultados',
                algorithm: {
                    title: 'Algoritmo',
                    text: 'Todos los resultados del juego para las siguientes {{rounds}} de rondas han sido predeterminados. Antes de cada ronda, revelamos un hash del resultado, haciendo imposible para nosotros cambiar el resultado después del hecho.\n\nEn realidad, hemos encadenado todos los resultados, haciendo imposible para nosotros incluso cambiar resultados futuros. Y antes de generar la cadena de resultados, revelamos el primer hash, publicamos esto en Twitter y mezclamos un futuro blockhash de Bitcoin que no podríamos haber conocido. Esto hace que todos los resultados sean provablemente justos.\n\nAntes de que comenzara la primera ronda del juego, creamos una cadena de hashes. Cada hash es un valor de 256 bits. La cadena comienza con un valor de 256 bits elegido al azar y cada valor subsiguiente se calcula usando el hash BLAKE2b del valor anterior.\n\nEl uso de una función hash criptográfica garantiza que uno pueda calcular fácilmente cualquier valor en la cadena usando el valor anterior, pero uno no puede calcular fácilmente los valores en la dirección inversa. El último valor en la cadena de hash precalculada es lo que publicamos públicamente y usamos para la primera ronda del juego. La segunda ronda del juego usó el penúltimo valor hash, la tercera ronda usó el antepenúltimo valor hash, etc. Recorriendo la cadena de esta manera, uno puede verificar que el resultado de todas las rondas de juego pasadas fue consistente con la cadena precalculada, pero el resultado de las rondas futuras sigue siendo impredecible para los usuarios.\n\nPara eliminar la posibilidad de que generamos intencionalmente la cadena usando un valor inicial que sesgara los resultados de los juegos a nuestro favor, cada valor en la cadena se anexa a la semilla global y el valor resultante se hashea nuevamente usando BLAKE2b para crear el valor final que determinará el resultado de cada ronda del juego. Esta semilla global se establece en el hash del bloque de Bitcoin que anunciamos antes de su minería. La inclusión de la semilla global garantiza que el resultado de los juegos fuera desconocible para nosotros cuando se publicó el valor hash de la primera partida',
                },
                verification: {
                    title: 'Ejemplo De Verificación',
                    text: 'Cualquiera puede verificar que los resultados de todas las rondas de juego anteriores se generaron utilizando el algoritmo probadamente justo con el siguiente código python',
                },
            },
            QuantumSpinHowItWorks: {
                stepOne: {
                    title: 'Gira la rueda cuántica',
                    text: 'La rueda está en superposición; no sabemos qué traerá. Gira la rueda para romper la incertidumbre y conquistar el premio más grande',
                },
                stepTwo: {
                    title: 'Cada giro cuántico requiere energía, es decir, fichas',
                    text: 'Su premio puede ser de mayor o menor valor que su apuesta. ¡Naturalmente, puedes recibir una gran recompensa!',
                },
                stepThree: {
                    title: 'Hacer trampa es imposible',
                    text: 'Los resultados de un giro se determinan en el mismo momento del juego a través de un proceso aleatorio y son desconocidos para el equipo. Valoramos la equidad y la transparencia',
                },
            },
            QuantumSuccess: {
                coin: '¡Felicitaciones! Ha ganado {{coin}} en recompensas, que se transferirán a su billetera de inmediato. Vuelve a probar suerte y comparte tus resultados en las redes sociales',
                rank: ' ¡Felicitaciones! Ha ganado un NFT de rango {{rank}}, que se transferirá a su billetera de inmediato. Vuelve a probar suerte y comparte tus resultados en las redes sociales',
            },
            QuantumSpinGameHistory: {
                again: 'Gíralo de nuevo',
            },
            QuantumSpinDetailsModal: {
                button: 'Volver a Disco',
            },
            QuantumSpinHistory: {
                title: 'Está vazio aqui',
                text: 'Você ainda não jogou nenhum jogo',
            },
        },
        [MYSTERY_GAMES.tokenteller]: {
            predictPrice: 'Predecir precio',
            addMoreTokens: 'Agregar más tokens',
            priceDirection: 'Dirección del precio',

            [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Up]: 'ARRIBA',
            [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Down]: 'ABAJO',
            TokenTellerConfirmationModal: {
                [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Up]:
                    'Multiplicador ARRIBA',
                [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Down]:
                    'Multiplicador ABAJO',
            },
            TokenTellerHowItWorks: {
                stepOne: {
                    title: 'Presentamos al Tokenteller',
                    text: 'Pon a prueba tus habilidades de pronóstico en este juego de ritmo rápido. Prediga el movimiento del precio de IGU en una ronda de {{min}} minutos. Utiliza todas las herramientas necesarias: bolas de cristal, oráculos de animales e incluso magia negra',
                },
                stepTwo: {
                    title: 'Tamaño de la recompensa',
                    text: 'En un juego, eliges arriba o abajo. El tamaño de su recompensa depende del multiplicador, que es la relación entre el grupo alcista y el grupo bajista. El multiplicador se muestra en la pestaña Predicción y puede cambiar hasta que la ronda entre en funcionamiento',
                },
                stepThree: {
                    title: 'Hacer trampa es imposible',
                    text: 'Empleamos un oráculo confiable que toma el precio actual de {{coin}} de los intercambios. Siempre puedes consultar el precio en una casa de cambio',
                },
            },
            TokenTellerMainScreen: {
                title: 'Rondas',
                text: 'Solo puedes unirte a una próxima ronda',
            },
            TokenTellerPurchaseModal: {
                title: 'Predecir el movimiento del precio',
                text: 'Únase a una ronda para predecir hacia dónde se dirige {{coin}}. Seleccione la apuesta y la dirección a continuación',
                alert: 'Ya has hecho la predicción de que el token {{direction}}. Ahora solo puedes aumentar tu posición en esta dirección',
            },

            TokenTellerPricePool: {
                title: 'Piscina = {{text}}',
                text: 'El fondo se obtiene de las apuestas de los usuarios. La recompensa depende de la relación entre las apuestas totales alcistas y bajistas',
            },
            TokenTellerUpPayout: {
                title: 'Multiplicador ARRIBA = {{coefficient}}X',
                text: 'Multiplicador de ganador si el precio sube',
            },
            TokenTellerDownPayout: {
                title: 'Multiplicador ABAJO = {{coefficient}}X',
                text: 'Multiplicador de ganador si el precio baja',
            },
            TokenTellerParticipants: {
                title: 'Participantes = {{text}}',
                text: 'El número de jugadores que participan en la ronda',
            },

            TokenTellerTimerBlock: {
                [TOKEN_TELLER_GAME_STATUS.Pending]: {
                    title: 'La ronda comienza en',
                },
                [TOKEN_TELLER_GAME_STATUS.Closed]: {
                    title: 'La ronda termina en',
                },
            },
            TokenTellerHistoryItem: {
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Won]: 'Ganar',
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Lost]: 'Perder',
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.WaitingForResults]:
                    'Esperando resultado',
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Refund]: 'Empatar',
            },

            TokenTellerHistoryBlockHeader: {
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Won]: {
                    title: '¡Has ganado!',
                    textOne:
                        '¡Felicitaciones! Ha predicho correctamente el movimiento del precio. ',
                    textTwo: ' se depositará en su billetera inmediatamente',
                },

                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Lost]: {
                    title: 'Has perdido :(',
                    text: 'Desafortunadamente, esta vez no lograste ganar. ¡Una buena razón para demostrar tu valía en la siguiente ronda!',
                },
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Refund]: {
                    title: '¡Vaya, es un empate!',
                    text: 'Por improbable que parezca, es un empate. Su apuesta ha sido devuelta a su billetera. ¿Quieres otra ronda?',
                },
            },
            TokenTellerGameHistoryInfoItem: {
                iguBefore: 'Precio inicial',
                iguAfter: 'Precio de cierre',
                prediction: 'Posición',
                totalPool: 'Fondo total',
                participants: 'Participantes',
                upPayout: 'Multiplicador ARRIBA',
                downPayout: 'Multiplicador ABAJO',
            },
        },
        DailyTasks: {
            header: 'Tareas diarias',
            collected: '{{collectedEnergy}} / {{maxEnergy}} Recogida',
            SocialTask: {
                title: 'Una tarea social',
                text: 'Publicar en las redes sociales',
            },
            VerificationTask: {
                title: 'Una tarea de búsqueda',
                text: 'Consultar los mensajes de otros usuarios',
            },
            MoveTask: {
                title: 'Tarea móvil',
                text: 'Disfruta paseando al aire libre con tu mascota',
            },
            PlayTask: {
                title: 'Misión del juego',
                text: 'Juega a un emocionante juego de arcade',
            },
        },
        ReferralCard: {
            title: '{{percent}}% de descuento en NFT!',
            text: 'Invita a nuevos usuarios a la app IguVerse y consigue un descuento en NFT de menta',
            button: 'Invita',
        },
        TimerTopUp: {
            title: 'por cada recarga',
            text1: '¡Deposita tokens ahora y recibe un {{percent}}% más de {{coin}} en tu billetera! Disponible solo antes de:',
            text2: '¡Comience a jugar nuestros nuevos juegos competitivos y obtenga tokens de bonificación en susaldo!',
        },
    },
    pvpBonus: {
        cardButton: 'PVP Bonificación',
        title: 'Bonificaciones PvP',
        text: 'Los propietarios de NFT tienen derecho a incentivos por jugar PvP. ¡Comience ahora y obtenga sus bonos de inmediato!',
        pvpBonusModal: {
            title: 'Cómo ganar más en PvP',
            text: '¡El retorno de IguVerse de PvP se compartirá contigo de manera proporcional a tu facturación! Obtén un NFT y automáticamente recibirás bonos por jugar',
            features: {
                games: {
                    title: 'Contador de juegos = {{games}}',
                    text: 'Los juegos que has jugado hoy. ¡No te detengas ahora!',
                },
                bonus: {
                    title: 'Bonificaciones PvP = {{amount}}',
                    text: 'Estos son los tokens extra que recibirás por jugar juegos PvP al final del día. ¡Combate con otros y gana aún más!',
                },
            },
        },
        pvpBonusModalFreePet: {
            title: 'Mejora el rango para recibir más tokens en PvP',
            text: 'Tu mascota del rango libre debe actualizarse a un rango más alto para que seas elegible para las bonificaciones de PvP',
        },
    },
    MarketPlace: {
        navigationBar: {
            ORDERS: 'Órdenes activas',
            MY_PROFILE: 'Mi perfil',
        },
        MarketPlaceActiveOrdersScreen: {
            title: 'Mercado',
            text: 'Un lugar para negociar NFT',
            empty: {
                title: 'No hay NFT a la venta',
                text: 'Aún no se han creado órdenes de venta. ¡Se el primero en crear uno!',
            },
            notFound: {
                title: 'No se han encontrado resultados',
                text: 'No hemos encontrado ningún pedido de este tipo. Introduzca otra palabra clave para busca',
            },
        },
        MarketPlaceSearch: {
            modalTitle: 'Filtros',
            placeHolder: 'Buscar por nft, colección, usuario...',
            typeSection: {
                [MARKETPLACE_PET_TYPE.AISystem]: 'Sistema AI',
                [MARKETPLACE_PET_TYPE.FromPhoto]: 'Desde Foto',
                [MARKETPLACE_PET_TYPE.Alive]: 'Vivo',
                [MARKETPLACE_PET_TYPE.Dead]: 'Muerto',
            },

            sortBySection: {
                [MARKETPLACE_ORDERS_SORT_OPTION.FromHighestPrice]:
                    'Desde el precio más alto',
                [MARKETPLACE_ORDERS_SORT_OPTION.FromLowestPrice]:
                    'Desde el precio más bajo',
                [MARKETPLACE_ORDERS_SORT_OPTION.RecentlyListed]: 'Recientes',
                [MARKETPLACE_ORDERS_SORT_OPTION.EndingSoon]:
                    'Finalizando Pronto',
            },
        },
        MarketPlaceWelcomeCreateOrderScreen: {
            screenTitle: 'Crear nuevo pedido',
            title: 'Presente su NFT al Gran Mundo',
            text: 'Aquí puede listar su NFT y venderlo!',
            features: {
                rank: {
                    title: 'Rango Mínimo – {{rank}}',
                    text: 'Su NFT debe tener un rango más alto que el rango {{lowRank}}. Solo los NFT comprados en la aplicación se pueden negociar en el mercado',
                },
                termination: {
                    title: 'Terminación automática = {{days}} Días',
                    text: 'El tiempo en el que caducará el pedido si no se compra antes',
                    alert: 'Si nadie ha comprado NFT en {{days}} días, el pedido se eliminará automáticamente de la lista del Mercado. Mientras esté en la lista puede seguir jugando y ganando',
                },
                commission: {
                    title: 'Comisión = {{commission}}%',
                    text: 'Cada NFT vendido con éxito está sujeto a una comisión del {{commission}}%',
                },
            },
        },
        MarketPlaceModalNoPet: {
            title: 'Acuñar un NFT para vender',
            text: 'Para vender un NFT, debe tener al menos una mascota. ¡Minta uno ahora!',
        },
        MarketPlaceSelectNftScreen: {
            screenTitle: 'Seleccione NFT',
        },
        MarketPlaceSelectNftPriceScreen: {
            screenTitle: 'Introduzca el precio NFT',
        },
        MarketPlaceCreateOrderSuccessScreen: {
            title: 'NFT listado en el mercado',
            text: 'Ha enumerado con éxito su NFT. Ahora otros usuarios podrán comprarlo',
        },
        navigationBarOverview: {
            OVERVIEW: 'Descripción general',
            OWNER_HISTORY: 'Historial del propietario',
        },
        MarketPlaceOverview: {
            text: 'Este es un NFT de otro usuario. Puedes ver sus características a continuación:',
            textOwner:
                'Este es su NFT. Puedes ver sus características a continuación:',
            OverviewOwnerSection: {
                profileLabel: 'Perfil del propietario',
            },
            proceedToCheckoutModal: {
                title: '¿Pasar por la caja?',
                text: 'Después de comprar un NFT, estará en modo de enfriamiento durante 24 horas. Asegúrate de haber comprobado todas sus propiedades antes de comprar',
            },
        },
        DelistNftModal: {
            title: 'Eliminar el NFT?',
            text: 'Si se elimina de la lista, el NFT dejará el mercado y ya no estará disponible para su compra',
        },
        MarketplaceProfile: {
            joined: 'Registrado {{date}',
            myNFTs: 'Mis NFTs',
            exploreNFTs: 'Explorar NFTs',
            emptyUser: {
                title: 'Sin pedidos',
                text: 'Aún no se han creado pedidos de mercado',
            },
            empty: {
                title: 'Sin pedidos',
                text: 'Este usuario aún no ha creado ningún pedido',
            },
        },
        MarketPlaceDelistSuccessScreen: {
            title: 'NFT "{{name}}" se ha eliminado con éxito del mercado',
        },
        MarketPlaceBuySuccessScreen: {
            title: 'Nuevo NFT se unió a la familia',
            text: 'Has comprado con éxito un nuevo NFT! Ahora tu colección tiene un nuevo miembro y ahora es mucho más fuerte',
        },
        MarketPlaceOverviewOwnerHistoryScreen: {
            empty: {
                title: 'Sin historial de NFT',
                text: 'El NFT aún no se ha negociado. ¡Puedes ser el primero en comprarlo!',
            },
        },
        MarketPlaceNoTradeAvalibleScreen: {
            title: '¡El mercado ha salido!',
            description:
                'Acabamos de lanzar nuestro mercado interno, donde puede intercambiar sus NFT de IguVerse. ¡Ábrelo a través de la aplicación web y haz tu primer pedido ahora!',
            button: 'Explorar en web',
        },
    },
    SpaceId: {
        card: {
            title: 'Obtener ID de ESPACIO',
            text: 'Muestre su apodo personalizado en todas partes de la aplicación y más allá',
        },
        how: {
            screenTitle: 'Cómo usar ID de SPACE ID',
            title: 'Registrar Identidad Digital',
            text: '¿Cansado de direcciones complejas e ilegibles? ¡Cambie el suyo con una identidad legible por humanos (nombre de dominio) con SPACE ID!',
            guideBlock: {
                first: 'Importe su billetera IguVerse a cualquier billetera DeFi sin custodia (por ejemplo, Trustwallet, Metamask) a través de su frase semilla',
                second: 'Agregue la red BEP-20 y conecte su billetera al sitio web',
                third: 'Busque el nombre de dominio deseado en el sitio web',
                fourth: 'Compre el nombre de dominio deseado y actualice la aplicación IguVerse. Podrá ver su apodo personalizado en la billetera, en la tabla de clasificación y en cualquier otro lugar donde se use',
                alert: 'Para comprar un dominio, es necesario tener algunos BNB en su billetera',
            },
            button1: 'Explore los dominios de SPACE ID',
        },
        modal: {
            title: 'SPACE ID único!',
            text: '¡Ha comprado y registrado con éxito un dominio personalizado! A partir de ahora, su nombre único se mostrará en todas partes de la aplicación. Su dirección real seguirá siendo la misma y puede copiarla haciendo clic en "Copiar" en su billetera',
            link: 'Más información en SPACE ID',
        },
    },
    Achievements: {
        title: 'Logros',
        text: 'Tareas emocionantes que rastrean su progreso único y le permiten mostrar sus habilidades y experiencia de juego',
        unlocked: '{{achievement}} desbloqueado!',
        unlockedText:
            '¡Felicitaciones! Has conseguido desbloquear un logro. ¡Compártelo con tus amigos en las redes sociales!',
        button: 'Compartir logros',
        modal: {
            title: 'Destacar con logros',
            text: 'Completa las tareas para obtener logros. Es mucho más entretenido jugar con un poco de desafío y un cofre lleno de medallas',
        },
    },
};

export default es;
